(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2122,1005],{

/***/ 90008:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ LazyComp; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48489);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2__);



const LazyComp = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2__.LazyLoadComponent, {
        ...props
    });


/***/ }),

/***/ 91706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ CardRowGroup; },
/* harmony export */   "l": function() { return /* binding */ CardRow; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);


const CardRow = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.memo(function CardRow(param) {
    let { className ="" , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "df fw jcfs aic gg1 fs14 gray800 ".concat(className),
        ...props
    });
});
const CardRowGroup = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.memo(function CardRowGroup(param) {
    let { className ="" , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "df wsnw jcfs aic gg1 fs14 gray800 ".concat(className),
        ...props
    });
});


/***/ }),

/***/ 58410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);


const Tag = (param)=>/*#__PURE__*/ {
    let { className ="" , children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
        className: "font-isb bg-lighterGreen py-1 px-2 br4 not-italic whitespace-nowrap empty:hidden ".concat(className),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(Tag));


/***/ }),

/***/ 33130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v5_CovidTestModal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./node_modules/@c10h/colors/es/palette.js
var palette = __webpack_require__(45602);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(26420);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/i18n.ts + 5 modules
var src_i18n = __webpack_require__(76361);
// EXTERNAL MODULE: ./src/hooks/useReadableSlotTime.ts + 1 modules
var useReadableSlotTime = __webpack_require__(8764);
// EXTERNAL MODULE: ./src/components/v5/Composition/CardRow.tsx
var CardRow = __webpack_require__(91706);
;// CONCATENATED MODULE: ./src/components/v5/Composition/Dot.tsx


const Dot = /*#__PURE__*/ react.memo(function Dot() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "fs20 font-isb",
        "aria-hidden": true,
        children: "\xb7"
    });
});

// EXTERNAL MODULE: ./src/components/v5/Composition/Tag.tsx
var Tag = __webpack_require__(58410);
;// CONCATENATED MODULE: ./src/components/v5/CovidTestModalItem.tsx








const CovidTestModalItem = (param)=>{
    let { title , onClick , slot , href , icon , subTitle , howLong , price , index , onClose , asPath , isModal , isCovidTestingPage  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const readableSlotTime = (0,useReadableSlotTime/* useReadableSlotTime */.H5)(slot === null || slot === void 0 ? void 0 : slot.time);
    // Using `asPath` as `href` is a hack so that we don't need to render a button instead of anchor, bad a11y practice
    const finalHref = href || asPath;
    const mobileView = !isCovidTestingPage && !isModal;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
            href: finalHref,
            className: "df pv4 pos-r showOnHoverWrapper ".concat(index && !mobileView ? "brdt brd-gray100" : ""),
            onClick: onClick || onClose,
            "data-cy": "home-widget-link-inner",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w100p pt2 maxw3-md ".concat(mobileView ? "maxw3" : "maxw4"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "cIcon-".concat(icon || "stethoscope", " darkBlue fs32-md ").concat(mobileView ? "fs32" : "fs42"),
                        "aria-hidden": true
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "fx pr4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "font-csb gray800 fs18-md ".concat(mobileView ? "fs18" : "fs22"),
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "font-i gray800 lh12 fs14-md",
                            children: subTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardRow/* CardRow */.l, {
                            className: "mt1",
                            children: [
                                howLong && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.Z, {
                                    children: howLong
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardRow/* CardRowGroup */.e, {
                                    children: [
                                        price && /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            className: "font-isb wsnw",
                                            children: price
                                        }),
                                        readableSlotTime && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                price && /*#__PURE__*/ (0,jsx_runtime.jsx)(Dot, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                    className: "font-isb fsn wsnw ".concat(mobileView ? "" : "darkGreen"),
                                                    children: readableSlotTime
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                mobileView && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Dot, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "darkGreen font-isb",
                                            children: i18n.t("Book")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                !mobileView && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "pos-a font-ib fs12 white bg-gray800 br5 pv3 ph4 brdn right0 cp hover-bg-gray600 op0 showOnHover dn-md",
                            children: i18n.t("Select")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pt2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "cIcon-arrRight fs26",
                                "aria-hidden": true
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var v5_CovidTestModalItem = (CovidTestModalItem);

// EXTERNAL MODULE: ./src/_services/featureFlagConstants.ts
var featureFlagConstants = __webpack_require__(72714);
// EXTERNAL MODULE: ./node_modules/color/index.js
var color = __webpack_require__(32130);
var color_default = /*#__PURE__*/__webpack_require__.n(color);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(21395);
// EXTERNAL MODULE: ./node_modules/react-outside-click-handler/index.js
var react_outside_click_handler = __webpack_require__(98280);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(1989);
// EXTERNAL MODULE: ./src/store/index.ts + 6 modules
var store = __webpack_require__(40367);
// EXTERNAL MODULE: ./src/store/slices/userLocation.ts
var userLocation = __webpack_require__(36330);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(56722);
// EXTERNAL MODULE: ./src/constants/apptReasons.ts
var apptReasons = __webpack_require__(4063);
// EXTERNAL MODULE: ./src/constants/specialtyIds.ts
var specialtyIds = __webpack_require__(93209);
// EXTERNAL MODULE: ./src/hooks/useCareEntryExtensions.ts
var useCareEntryExtensions = __webpack_require__(63871);
// EXTERNAL MODULE: ./src/hooks/useFeatureFlags.ts
var useFeatureFlags = __webpack_require__(15343);
// EXTERNAL MODULE: ./src/components/_common/Carbon.tsx
var Carbon = __webpack_require__(29946);
// EXTERNAL MODULE: ./src/utils/fetchPricingData.ts
var fetchPricingData = __webpack_require__(37059);
// EXTERNAL MODULE: ./src/utils/getPricingTierBySlug.ts + 1 modules
var getPricingTierBySlug = __webpack_require__(67350);
;// CONCATENATED MODULE: ./src/hooks/usePrices.ts







const usePrices = (regionSlug)=>{
    const [prices, setPrices] = (0,react.useState)([]);
    const dispatch = (0,es/* useDispatch */.I0)();
    const regionPricing = (0,store/* useTypedSelector */.ix)((state)=>state.regionPricing);
    const selectedRegion = (0,store/* useTypedSelector */.ix)(userLocation/* selectSelectedRegion */.dz);
    const slugToCheck = regionSlug || selectedRegion;
    (0,Carbon/* useEffectAsync */.LX)(async ()=>{
        const priceTier = (0,getPricingTierBySlug/* getPricingTierByRegionSlug */.i)(slugToCheck);
        const maybePrices = regionPricing[priceTier];
        if (!(maybePrices === null || maybePrices === void 0 ? void 0 : maybePrices.length)) {
            const newRegionPricing = await (0,fetchPricingData/* fetchPricingData */.H)();
            const newPrices = newRegionPricing[priceTier];
            dispatch(store/* actions.setRegionPricing */.Nw.setRegionPricing(newRegionPricing));
            setPrices(newPrices);
        } else {
            setPrices(maybePrices);
        }
    }, [
        selectedRegion,
        regionSlug,
        regionPricing
    ]);
    return prices;
};

// EXTERNAL MODULE: ./src/utils/fetchCachedSlotAround.ts + 1 modules
var fetchCachedSlotAround = __webpack_require__(39815);
// EXTERNAL MODULE: ./src/utils/filterLocationsBySpecialtyId.ts
var filterLocationsBySpecialtyId = __webpack_require__(83821);
;// CONCATENATED MODULE: ./src/constants/priceSlugs.ts

const PriceSlugByReasonId = {
    [apptReasons/* ApptReasonId.COVID_TRAVEL_CLEARANCE_TESTING */.xT.COVID_TRAVEL_CLEARANCE_TESTING]: "rapid-covid-naat",
    [apptReasons/* ApptReasonId.NEXT_DAY_RT_PCR */.xT.NEXT_DAY_RT_PCR]: "covid-expediated-sendout"
};

;// CONCATENATED MODULE: ./src/utils/getPriceByApptReasonId.ts

const getPriceByApptReasonId = (apptReasonId, prices)=>{
    var _prices_find;
    // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ "23b5bd54-42e3-4e5a-a05b-b21c4be55601": string; "b475dca5-c9cf-41b5-abed-9b69982088ad": string; }'.
    const maybePriceSlug = apptReasonId in PriceSlugByReasonId && PriceSlugByReasonId[apptReasonId];
    const maybePrice = maybePriceSlug ? (_prices_find = prices.find((price)=>price.slug === maybePriceSlug)) === null || _prices_find === void 0 ? void 0 : _prices_find.price : null;
    return typeof maybePrice === "number" ? "$".concat(maybePrice / 100) : null;
};

// EXTERNAL MODULE: ./src/utils/getRedirectUrl.ts
var getRedirectUrl = __webpack_require__(34488);
// EXTERNAL MODULE: ./src/utils/locationsByRegion.ts
var locationsByRegion = __webpack_require__(10241);
// EXTERNAL MODULE: ./src/components/_common/_constants.ts + 1 modules
var _constants = __webpack_require__(93932);
// EXTERNAL MODULE: ./src/components/v5/Reason/CareDiscoverySearch/careDiscoveryAnalytics.ts
var careDiscoveryAnalytics = __webpack_require__(9121);
;// CONCATENATED MODULE: ./src/components/v5/CovidTestModal.tsx





// @ts-expect-error TS7016: Could not find a declaration file for module 'color'. '/Users/goksel/Sites/carbon-website-next/node_modules/color/index.js' implicitly has an 'any' type.




// @ts-expect-error TS7016: Could not find a declaration file for module 'react-outside-click-handler'. '/Users/goksel/Sites/carbon-website-next/node_modules/react-outside-click-handler/index.js' implicitly has an 'any' type.



















const TRAVEL = "TRAVEL";
const NONTRAVEL = "NONTRAVEL";
const LOCATIONS_LIMIT = 5; // count of locations with specialty
const CovidTestModal = (param)=>{
    let { showTravelContent , covidLocationId , isModal =true , isCovidTestingPage  } = param;
    var _location_region;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { locations , locationsSorted  } = (0,store/* useTypedSelector */.ix)((param)=>{
        let { config  } = param;
        return config;
    });
    const selectedRegion = (0,store/* useTypedSelector */.ix)(userLocation/* selectSelectedRegion */.dz);
    const pricingData = (0,store/* useTypedSelector */.ix)((state)=>state.regionPricing);
    const hasPricingData = pricingData.tier1.length !== 0;
    const locsByRegion = (0,react.useMemo)(()=>(0,locationsByRegion/* locationsByRegion */.i)(locations, selectedRegion), [
        locations,
        selectedRegion
    ]);
    (0,react.useEffect)(()=>{
        if (!hasPricingData) (0,fetchPricingData/* fetchPricingData */.H)().then((data)=>dispatch(store/* actions.setRegionPricing */.Nw.setRegionPricing(data)));
    }, [
        hasPricingData
    ]);
    const dispatch = (0,es/* useDispatch */.I0)();
    const enableCache = (0,useFeatureFlags/* useFeatureFlag */.y)(featureFlagConstants/* FeatureFlag.GROWTH_CACHED_SLOTS_ENABLED */.T.GROWTH_CACHED_SLOTS_ENABLED);
    // if travel content opened from inside modal or not
    const [isTravelRefererModal, setIsTravelRefererModal] = (0,react.useState)(false);
    const [slotsFetched, setSlotsFetched] = (0,react.useState)(false);
    const { asPath , pathname  } = (0,router.useRouter)();
    const preselectedLocations = locations.filter((l)=>l.id === covidLocationId);
    const location = preselectedLocations[0];
    const titles = {
        [NONTRAVEL]: i18n.t("COVID Testing"),
        [TRAVEL]: i18n.t("COVID Travel Testing")
    };
    const reasonExtensions = (0,useCareEntryExtensions/* useResultExtensions */.l)();
    const items = [
        {
            icon: reasonExtensions[apptReasons/* ApptReasonId.COVID_SICK_VISIT */.xT.COVID_SICK_VISIT].icon,
            title: i18n.t("COVID Sick Visit"),
            subTitle: i18n.t("Full provider evaluation for patients with symptoms, including any necessary testing."),
            price: i18n.t("Covered by insurance"),
            howLong: reasonExtensions[apptReasons/* ApptReasonId.COVID_SICK_VISIT */.xT.COVID_SICK_VISIT].turnaround,
            reasonId: apptReasons/* ApptReasonId.COVID_SICK_VISIT */.xT.COVID_SICK_VISIT,
            specialtyId: specialtyIds/* SpecialtyId.COVID_TESTING_MOBILE */.mg.COVID_TESTING_MOBILE,
            slug: "covid-sick-visit"
        },
        {
            icon: reasonExtensions[apptReasons/* ApptReasonId.COVID_TESTING_NO_SYMPTOMS */.xT.COVID_TESTING_NO_SYMPTOMS].icon,
            title: i18n.t("COVID Exposure Screening"),
            subTitle: i18n.t("Full provider evaluation for patients with an exposure risk, including any necessary testing."),
            price: i18n.t("Covered by insurance"),
            howLong: reasonExtensions[apptReasons/* ApptReasonId.COVID_TESTING_NO_SYMPTOMS */.xT.COVID_TESTING_NO_SYMPTOMS].turnaround,
            reasonId: apptReasons/* ApptReasonId.COVID_TESTING_NO_SYMPTOMS */.xT.COVID_TESTING_NO_SYMPTOMS,
            specialtyId: specialtyIds/* SpecialtyId.COVID_TESTING_MOBILE */.mg.COVID_TESTING_MOBILE,
            slug: "covid-exposure-screening"
        },
        {
            icon: "rapid-hepatitis-c-screening",
            title: i18n.t("Same-Day NAAT"),
            subTitle: i18n.t("No provider evaluation. Samples processed on-site."),
            howLong: reasonExtensions[apptReasons/* ApptReasonId.COVID_TRAVEL_CLEARANCE_TESTING */.xT.COVID_TRAVEL_CLEARANCE_TESTING].turnaround,
            reasonId: apptReasons/* ApptReasonId.COVID_TRAVEL_CLEARANCE_TESTING */.xT.COVID_TRAVEL_CLEARANCE_TESTING,
            specialtyId: specialtyIds/* SpecialtyId.COVID_TRAVEL_CLEARANCE */.mg.COVID_TRAVEL_CLEARANCE,
            slug: "same-day-naat",
            specialtyIdInCategory: specialtyIds/* SpecialtyId.COVID_TESTING_MOBILE */.mg.COVID_TESTING_MOBILE,
            price: "$150-250"
        },
        {
            icon: "flight",
            title: i18n.t("COVID Travel Testing"),
            subTitle: i18n.t("No provider evaluation. RT-PCR and NAAT options available."),
            howLong: reasonExtensions[apptReasons/* ApptReasonId.COVID_TRAVEL_CLEARANCE_TESTING */.xT.COVID_TRAVEL_CLEARANCE_TESTING].turnaround,
            reasonId: apptReasons/* ApptReasonId.COVID_TRAVEL_CLEARANCE_TESTING */.xT.COVID_TRAVEL_CLEARANCE_TESTING,
            specialtyId: specialtyIds/* SpecialtyId.COVID_TRAVEL_CLEARANCE */.mg.COVID_TRAVEL_CLEARANCE,
            slug: "covid-19-travel-clearance",
            onClick: ()=>{
                setIsTravelRefererModal(true);
                dispatch(store/* actions.setConfig */.Nw.setConfig({
                    covidModal: {
                        showTravelContent: true,
                        showCovidModal: true,
                        covidLocationId
                    }
                }));
            }
        },
        {
            travel: true,
            icon: "rapid-hepatitis-c-screening",
            title: i18n.t("Same-Day NAAT"),
            subTitle: i18n.t("No provider evaluation. Samples processed on-site."),
            howLong: reasonExtensions[apptReasons/* ApptReasonId.COVID_TRAVEL_CLEARANCE_TESTING */.xT.COVID_TRAVEL_CLEARANCE_TESTING].turnaround,
            reasonId: apptReasons/* ApptReasonId.COVID_TRAVEL_CLEARANCE_TESTING */.xT.COVID_TRAVEL_CLEARANCE_TESTING,
            specialtyId: specialtyIds/* SpecialtyId.COVID_TRAVEL_CLEARANCE */.mg.COVID_TRAVEL_CLEARANCE,
            slug: "same-day-naat",
            price: "$150-250"
        },
        {
            travel: true,
            icon: reasonExtensions[apptReasons/* ApptReasonId.NEXT_DAY_RT_PCR */.xT.NEXT_DAY_RT_PCR].icon,
            title: i18n.t("Next-Day RT-PCR"),
            subTitle: i18n.t("No provider evaluation. Samples processed in a lab with expedited results."),
            howLong: reasonExtensions[apptReasons/* ApptReasonId.NEXT_DAY_RT_PCR */.xT.NEXT_DAY_RT_PCR].turnaround,
            reasonId: apptReasons/* ApptReasonId.NEXT_DAY_RT_PCR */.xT.NEXT_DAY_RT_PCR,
            specialtyId: specialtyIds/* SpecialtyId.COVID_TRAVEL_CLEARANCE */.mg.COVID_TRAVEL_CLEARANCE,
            slug: "next-day-rt-pcr",
            price: "$150-250"
        },
        {
            travel: true,
            icon: "rapid-hepatitis-c-screening",
            title: i18n.t("Same-Day Antigen"),
            subTitle: i18n.t("No provider evaluation. Samples processed on-site."),
            howLong: reasonExtensions[apptReasons/* ApptReasonId.SAME_DAY_ANTIGEN */.xT.SAME_DAY_ANTIGEN].turnaround,
            reasonId: apptReasons/* ApptReasonId.SAME_DAY_ANTIGEN */.xT.SAME_DAY_ANTIGEN,
            specialtyId: specialtyIds/* SpecialtyId.COVID_TRAVEL_CLEARANCE */.mg.COVID_TRAVEL_CLEARANCE,
            slug: "same-day-antigen",
            price: reasonExtensions[apptReasons/* ApptReasonId.SAME_DAY_ANTIGEN */.xT.SAME_DAY_ANTIGEN].price || "$60"
        },
        {
            travel: true,
            icon: "rapid-hepatitis-c-screening",
            title: i18n.t("Same-Day RT-PCR"),
            subTitle: i18n.t("No provider evaluation. Samples processed on-site."),
            howLong: reasonExtensions[apptReasons/* ApptReasonId.SAME_DAY_RT_PCR */.xT.SAME_DAY_RT_PCR].turnaround,
            reasonId: apptReasons/* ApptReasonId.SAME_DAY_RT_PCR */.xT.SAME_DAY_RT_PCR,
            specialtyId: specialtyIds/* SpecialtyId.COVID_TRAVEL_CLEARANCE */.mg.COVID_TRAVEL_CLEARANCE,
            slug: "same-day-rt-pcr",
            price: reasonExtensions[apptReasons/* ApptReasonId.SAME_DAY_RT_PCR */.xT.SAME_DAY_RT_PCR].price || "$150-200"
        }
    ];
    const prices = usePrices(location === null || location === void 0 ? void 0 : (_location_region = location.region) === null || _location_region === void 0 ? void 0 : _location_region.slug);
    const [itemsFinal, setItemsFinal] = (0,react.useState)(items);
    (0,Carbon/* useEffectAsync */.LX)(async ()=>{
        // @ts-expect-error TS2531: Object is possibly 'null'.
        if (isModal) document.getElementById("body").classList.add("preventScroll");
        if (!locationsSorted) return;
        items.map((item)=>{
            const { reasonId  } = item;
            const flowId = (0,v4/* default */.Z)();
            const price = item.price || getPriceByApptReasonId(reasonId || "", prices);
            const href = location ? (0,getRedirectUrl/* getSchedulingRedirectUrl */._W)({
                practiceId: location.practiceId,
                locationId: location.id,
                specialtyId: item.specialtyId,
                apptReasonId: item.reasonId,
                flowId
            }) : "".concat(_constants/* v5Pages.getCareRoot */.Td.getCareRoot, "/").concat(item.slug);
            return Promise.resolve({
                ...item,
                price,
                href,
                flowId
            });
        }).sequence().then((res)=>{
            setItemsFinal(res);
            return res;
        }).then((updatedItems)=>{
            // @ts-expect-error TS2684: The 'this' context of type '(Promise<{ price: string | number | object | null; href: string; icon: string; title: string; subTitle: string; howLong?: string | undefined; slot?: Partial<ApptSlot> | undefined; ... 4 more ...; specialtyIdInCategory?: string | undefined; }> | Promise<...>)[]' is not assignable to method's 'this' of type 'Promise<{ price: string | number | object | null; href: string; icon: string; title: string; subTitle: string; howLong?: string | undefined; slot?: Partial<ApptSlot> | undefined; ... 4 more ...; specialtyIdInCategory?: string | undefined; }>[]'.
            updatedItems.map((item)=>{
                if (enableCache) {
                    const { reasonId , specialtyId  } = item;
                    const closestLocationsBySpecialty = (0,filterLocationsBySpecialtyId/* filterLocationsBySpecialtyId */.N)(location ? preselectedLocations : locsByRegion, // @ts-expect-error TS2345: Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
                    specialtyId, LOCATIONS_LIMIT);
                    return (0,fetchCachedSlotAround/* fetchCachedSlotAround */.o)({
                        locations: closestLocationsBySpecialty,
                        specialtyId,
                        reasonId,
                        locationCount: LOCATIONS_LIMIT
                    }).then((slot)=>({
                            ...item,
                            slot
                        }));
                }
                return Promise.resolve(item);
            }).sequence().then((slots)=>{
                setItemsFinal(slots);
                setSlotsFetched(true);
            });
        });
    }, [
        locationsSorted,
        hasPricingData,
        prices,
        selectedRegion
    ]);
    (0,react.useEffect)(()=>function cleanup() {
            // @ts-expect-error TS2531: Object is possibly 'null'.
            document.getElementById("body").classList.remove("preventScroll");
        }, []);
    const itemsGrouped = itemsFinal.groupBy((param)=>{
        let { travel  } = param;
        return travel ? TRAVEL : NONTRAVEL;
    });
    const onClose = ()=>{
        dispatch(store/* actions.setConfig */.Nw.setConfig({
            covidModal: {
                showCovidModal: false
            }
        }));
    };
    const renderModal = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat(!isModal ? "" : "pos-f w100vw minh100vh left0 top0 zIndex9999 df aic jcc ovf-y-a contrast-tb bg-white-f-md"),
            style: {
                backgroundColor: color_default()(palette.gray800).alpha(0.5),
                backdropFilter: "blur(10px)"
            },
            role: "dialog",
            tabIndex: -1,
            "aria-label": i18n.t("Which COVID test do you need"),
            "aria-modal": true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_outside_click_handler["default"], {
                onOutsideClick: ()=>dispatch(store/* actions.setConfig */.Nw.setConfig({
                        covidModal: {
                            showCovidModal: false
                        }
                    })),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "bg-white w100p maxw46 br2 pos-r h100vh-md w100vw-md br0-md",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "df jcsb p6 ph0-md",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    tabIndex: 0,
                                    className: "cIcon-arr2Left fs20 brdn bg-transparent cp hover-gray400 ".concat(!showTravelContent || !isTravelRefererModal ? "op0" : ""),
                                    "aria-label": i18n.t("Back"),
                                    onClick: ()=>dispatch(store/* actions.setConfig */.Nw.setConfig({
                                            covidModal: {
                                                showTravelContent: false,
                                                showCovidModal: true
                                            }
                                        }))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    className: "fs20 brdn bg-transparent cp hover-gray400",
                                    onClick: ()=>dispatch(store/* actions.setConfig */.Nw.setConfig({
                                            covidModal: {
                                                showCovidModal: false
                                            }
                                        })),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "visually-hidden",
                                            children: i18n.t("Close Dialog")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "cIcon-close1",
                                            "aria-hidden": true
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "ph15 pb10 ph4-md pb40-md",
                            children: [
                                showTravelContent ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "fs24-md",
                                            children: i18n.t("Which travel test do you need?")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "font-i fs14-md",
                                            children: i18n.t("Patients are responsible for verifying which test meets the travel requirements for their destination. Travel testing is recommended for asymptomatic patients, and is not covered by insurance.")
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "fs24-md",
                                    children: i18n.t("Which COVID test do you need?")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "mt4",
                                    children: itemsGrouped[showTravelContent ? TRAVEL : NONTRAVEL].filter((param)=>{
                                        let { slot  } = param;
                                        return !location || slot;
                                    }).map((param, index)=>{
                                        let { href , onClick , flowId , ...item } = param;
                                        const isClinicOrHome = pathname === _constants/* v5Pages.home */.Td.home || pathname === _constants/* v5Pages.clinicDetails */.Td.clinicDetails;
                                        const _onClick = isClinicOrHome ? ()=>{
                                            if (onClick) {
                                                // This check is here because the previously defined onclick opens modal
                                                onClick();
                                            } else {
                                                // If you don't open the modal, close it
                                                dispatch(store/* actions.setConfig */.Nw.setConfig({
                                                    covidModal: {
                                                        showCovidModal: false
                                                    }
                                                }));
                                            }
                                            // Always report click event in modal, but only pass flowId if patient app link
                                            (0,careDiscoveryAnalytics/* getSendClickedCareDiscoveryRowEvent */.$g)("base")({
                                                name: item.title,
                                                appointment_reason: item.reasonId,
                                                slug: item.slug
                                            }, item.slot || undefined, index + 1, href && /patients/gi.test(href) ? flowId : undefined);
                                        } : undefined;
                                        return /*#__PURE__*/ (0,react.createElement)(v5_CovidTestModalItem, {
                                            ...item,
                                            key: item.title,
                                            index: index,
                                            onClick: _onClick,
                                            // If `onClick` is present, it means it should not link to anywhere
                                            href: onClick ? undefined : href,
                                            onClose: onClose,
                                            asPath: asPath,
                                            isModal: isModal
                                        });
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        });
    const renderNonModal = ()=>{
        if (!slotsFetched) return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: i18n.t("Loading...")
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: itemsGrouped.getKeys().map((g)=>{
                const items = itemsGrouped[g].filter((param)=>{
                    let { slot , onClick  } = param;
                    return (!location || slot) && !onClick;
                }).filter((param)=>{
                    let { specialtyIdInCategory  } = param;
                    return !isCovidTestingPage || isCovidTestingPage && !specialtyIdInCategory;
                });
                if (!items.length) return null;
                // check if location has items with specialtyIds (only in location page)
                if (location) {
                    const isSpecialtyIdsInLocation = items.every((it)=>{
                        const specialtyId = it.specialtyIdInCategory || it.specialtyId;
                        // @ts-expect-error TS2345: Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
                        return location.specialtyIds.includes(specialtyId);
                    });
                    if (!isSpecialtyIdsInLocation) return null;
                }
                return(// @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ NONTRAVEL: string; TRAVEL: string; }'.
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: !isCovidTestingPage ? "mt8" : "",
                    children: [
                        !isCovidTestingPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "fs24",
                            children: titles[g]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            children: items.map((item, index)=>/*#__PURE__*/ (0,react.createElement)(v5_CovidTestModalItem, {
                                    ...item,
                                    key: item.title,
                                    index: index,
                                    onClose: onClose,
                                    asPath: asPath,
                                    isModal: isModal,
                                    isCovidTestingPage: isCovidTestingPage
                                })).compact()
                        })
                    ]
                }, titles[g]));
            })
        });
    };
    return !isModal ? renderNonModal() : renderModal();
};
/* harmony default export */ var v5_CovidTestModal = (CovidTestModal);


/***/ }),

/***/ 56290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);


const SectionHeader = (param)=>/*#__PURE__*/ {
    let { text  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "ttu font-im text-gray-500 fs13 ls2",
        children: text
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SectionHeader);


/***/ }),

/***/ 30796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ SectionLink; },
/* harmony export */   "l": function() { return /* binding */ keyedSectionLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26420);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32466);



const SectionLink = (param)=>/*#__PURE__*/ {
    let { text , href  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: href,
            className: "gray600 font-im hover-font-isb hover-gray800 t-150 focus-bsDarkBlue3 pv2 semiBoldHover",
            style: {
                "--br": 0.2
            },
            "data-text": text,
            "data-cy": "footer-link",
            children: text
        })
    });
};
const keyedSectionLink = (param)=>/*#__PURE__*/ {
    let { text , href  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionLink, {
        text: text,
        href: href
    }, text);
};


/***/ }),

/***/ 49897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var ni18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76361);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32466);
/* harmony import */ var src_languages_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71389);
/* harmony import */ var _common_Carbon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29946);
/* harmony import */ var _OptionsList__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57347);






const positions = {
    "bottom left": {
        top: 42,
        left: 0
    },
    "bottom right": {
        top: 42,
        right: 0
    },
    "top left": {
        bottom: 42
    },
    "top right": {
        bottom: 42,
        right: 0
    }
};
const LanguageSelector = (param)=>{
    let { anchorDirection ="bottom left" , onlyShow , className , ...props } = param;
    var _languages_find;
    const i18n = (0,ni18n__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)();
    const [showList, setShowList] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const options = src_languages_js__WEBPACK_IMPORTED_MODULE_3__.languages.filter((lng)=>src_languages_js__WEBPACK_IMPORTED_MODULE_3__.selectable.includes(lng.code) && (!onlyShow || onlyShow.includes(lng.code))).map((lng)=>{
        return {
            text: lng === null || lng === void 0 ? void 0 : lng.native,
            value: lng.code,
            selected: lng.code === i18n.lang
        };
    }).prepend({
        header: i18n.t("Select language")
    });
    const toggleList = (boolean)=>()=>{
            setShowList(boolean);
        };
    const listIsOnTop = /top/.test(anchorDirection);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "pos-r wfc mr6 focus-bsDarkBlue3 br8 mr0-md ".concat(className || ""),
        onBlur: (0,_common_Carbon__WEBPACK_IMPORTED_MODULE_4__/* .ifChildrenLoseFocus */ .SM)(toggleList(false)),
        ...props,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                onClick: toggleList(!showList),
                className: "brdn bg-transparent m0 p0 inherit",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "br5 p3 hover-bg-gray100 t-150 df aic font-ir fs14 cp",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "cIcon-globe mr2 fs16",
                            "aria-hidden": true
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "visually-hidden",
                            children: i18n.t("Language: ")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "fs12 font-ib",
                            children: (_languages_find = src_languages_js__WEBPACK_IMPORTED_MODULE_3__.languages.find((lng)=>i18n.lang === lng.code)) === null || _languages_find === void 0 ? void 0 : _languages_find.native
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "cIcon-icon_arrow_dropdown ml2 fs18 t-100 ".concat(!listIsOnTop && showList || listIsOnTop && !showList ? "rotate-180" : ""),
                            "aria-hidden": true
                        })
                    ]
                })
            }),
            showList && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OptionsList__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                className: "pos-a bg-white zIndex1 contrast-tb",
                style: {
                    ...positions[anchorDirection],
                    maxHeight: 600,
                    overflowY: "auto"
                },
                options: options,
                onOutsideClick: toggleList(false),
                onSelectOption: (code)=>(0,ni18n__WEBPACK_IMPORTED_MODULE_1__/* .setLanguage */ .m0)(code)
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LanguageSelector);


/***/ }),

/***/ 32122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v5_Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/@c10h/colors/es/palette.js
var palette = __webpack_require__(45602);
// EXTERNAL MODULE: ./src/components/v5/components/Dialog/ModalDialog.tsx
var ModalDialog = __webpack_require__(66096);
// EXTERNAL MODULE: ./src/components/v5/CovidTestModal.tsx + 5 modules
var CovidTestModal = __webpack_require__(33130);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(44926);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(21395);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(67320);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./src/i18n.ts + 5 modules
var src_i18n = __webpack_require__(76361);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(1989);
// EXTERNAL MODULE: ./src/components/_common/_constants.ts + 1 modules
var _constants = __webpack_require__(93932);
// EXTERNAL MODULE: ./src/components/v5/V5Comp.tsx
var V5Comp = __webpack_require__(63575);
// EXTERNAL MODULE: ./src/store/index.ts + 6 modules
var store = __webpack_require__(40367);
;// CONCATENATED MODULE: ./src/constants/CovidTravelModalConstants.tsx








const showTravelModalReferers = [
    // "localhost:5000",
    "southwest.com",
    "alaskaair.com",
    "hawaiianairlines.com",
    "hawaiicovid19.com",
    "san.org",
    "flysanjose.com",
    "flypdx.com",
    "portseattle.org"
];
const pagesWhereHidden = [
    "covid-19-travel-clearance",
    "alaska",
    "travel-clearance"
];
const alwaysShowOn = [
    "covid-19-clearance-exam"
];
const useCovidTravelModalConstants = (referer, path)=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        if (referer) {
            // prevent referer check from passing again.
            dispatch(store/* actions.setReferer */.Nw.setReferer(null));
        }
    }, []);
    const alwaysShowOnPage = path && alwaysShowOn.reduce((acc, next)=>acc || path.includes(next), false);
    const hideOnPage = path && pagesWhereHidden.reduce((acc, next)=>acc || path.includes(next), false);
    const refererCheck = referer && showTravelModalReferers.reduce((acc, next)=>acc || referer.includes(next), false);
    const showTravelModal = alwaysShowOnPage || !hideOnPage && refererCheck;
    const modalProps = {
        buttons: [
            {
                children: i18n.t("Find a testing site near you"),
                hoverBg: palette.gray600,
                href: _constants/* v5Pages.covid19TravelClearance */.Td.covid19TravelClearance
            }
        ]
    };
    const modalInner = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "df fdc",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "fs24-xs fs32 tal mb2 gray800",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                    children: [
                        "Looking for COVID-19",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " Travel Clearance testing?"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "fs14-xs tal mb2 gray800",
                children: i18n.t("Book a COVID-19 travel clearance test to travel safely. Schedule your test today.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "df mt4 mt2-xs fw ",
                children: modalProps.buttons.map((b, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                        className: "fs14-f fs12-f-xs mr2 mh2-xs mb2-xs",
                        ...b
                    }, "modalBtn-".concat(i)))
            })
        ]
    });
    // @ts-expect-error TS2322: Type 'string | boolean | undefined' is not assignable to type 'boolean'.
    return {
        showTravelModal,
        modalImage: "/covidTravel/travel-clearance-modal",
        modalInner
    };
};

// EXTERNAL MODULE: ./src/languages.js
var languages = __webpack_require__(71389);
// EXTERNAL MODULE: ./src/useEscape.ts
var useEscape = __webpack_require__(58689);
;// CONCATENATED MODULE: ./src/utils/getLink.ts

const getCanonicalLink = (asPath)=>_constants/* prodHost */.VM + asPath.replace(/\?(.*)/, "");
const getLinkWithLocale = (asPath, locale)=>locale === "en" ? getCanonicalLink(asPath) : _constants/* prodHost */.VM + "/" + locale + asPath.replace(/\?(.*)/, "");

;// CONCATENATED MODULE: ./src/constants/dynamicBanner.ts
const bannerSpacer = "banner-spacer";

// EXTERNAL MODULE: ./src/constants/urls.ts
var urls = __webpack_require__(58543);
// EXTERNAL MODULE: ./src/utils/ignoreArrays.ts
var ignoreArrays = __webpack_require__(1146);
// EXTERNAL MODULE: ./src/utils/zIndexMap.ts
var zIndexMap = __webpack_require__(45812);
// EXTERNAL MODULE: ./src/components/_common/Carbon.tsx
var Carbon = __webpack_require__(29946);
// EXTERNAL MODULE: ./src/components/_common/LazyComp.tsx
var LazyComp = __webpack_require__(90008);
// EXTERNAL MODULE: ./src/components/v5/Footer/SectionHeader.tsx
var SectionHeader = __webpack_require__(56290);
// EXTERNAL MODULE: ./src/components/v5/Footer/SectionLink.tsx
var SectionLink = __webpack_require__(30796);
;// CONCATENATED MODULE: ./src/components/v5/Footer/Column.tsx




const Column = (param)=>/*#__PURE__*/ {
    let { header , items  } = param;
    return (0,jsx_runtime.jsxs)("div", {
        className: "mr20 mb10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader/* default */.Z, {
                text: header
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "dg gafr gg6 mt8",
                children: items.map(SectionLink/* keyedSectionLink */.l)
            })
        ]
    });
};
/* harmony default export */ var Footer_Column = (Column);

;// CONCATENATED MODULE: ./src/components/v5/Footer/SplitLayout.tsx


const SplitLayout = (param)=>/*#__PURE__*/ {
    let { children , className ="" , ...rest } = param;
    return (0,jsx_runtime.jsxs)("div", {
        className: "df jcsb maxw80 ma ph8 ph4-sm ".concat(className),
        ...rest,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fx5",
                children: children[0]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fx minw18 minw0-sm",
                children: children[1]
            })
        ]
    });
};
/* harmony default export */ var Footer_SplitLayout = (SplitLayout);

;// CONCATENATED MODULE: ./src/components/v5/Footer/Middle.tsx





const Middle = (param)=>{
    let { sections  } = param;
    const leftSections = sections.filter((section)=>!section.isOnRight);
    const rightSections = sections.filter((section)=>section.isOnRight);
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        "aria-label": i18n.t("Footer Navigation"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer_SplitLayout, {
            className: "pb10",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "df fw",
                    children: leftSections.map((section)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Column, {
                            header: section.header,
                            items: section.items
                        }, section.header))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "df jcsb fdc fx2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "dg gafc gg10 ",
                        children: rightSections.map((section)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Column, {
                                header: section.header,
                                items: section.items
                            }, section.header))
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Footer_Middle = (Middle);

// EXTERNAL MODULE: ./src/components/v5/LanguageSelector.tsx
var LanguageSelector = __webpack_require__(49897);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(26420);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/useMediaQuery.ts
var useMediaQuery = __webpack_require__(57974);
// EXTERNAL MODULE: ./src/useV5ImgSrc.tsx
var useV5ImgSrc = __webpack_require__(52299);
;// CONCATENATED MODULE: ./src/components/v5/Footer/MinimalFooter.tsx









const MinimalFooter = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const isSm = (0,useMediaQuery/* default */.Z)("sm");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        "aria-label": i18n.t("Footer Links"),
        className: "bg-gray100 w100p contrast-tbt",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer_SplitLayout, {
            className: "pv3 pb5-sm font-ir fs14 aic fdcr-sm aifs-sm ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "fx3 mt2-sm",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "df aic db-sm",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "df aic mr18",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: {
                                            pathname: _constants/* v5Pages.home */.Td.home
                                        },
                                        className: "focus-bsDarkBlue3 mr2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            height: 25,
                                            width: 120,
                                            src: (0,useV5ImgSrc/* useV5ImgSrc */.eH)("/logo", true),
                                            alt: "Carbon Health",
                                            className: "db"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "gray800 hover-gray800 ",
                                        children: "\xa9 ".concat(new Date().getFullYear())
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "df aic mt1-sm",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: {
                                            pathname: _constants/* v5Pages.privacy */.Td.privacy
                                        },
                                        className: "gray600 hover-gray800 focus-bsDarkBlue3 mr18 mr0-sm",
                                        style: {
                                            "--br": 0.2
                                        },
                                        children: i18n.t("Privacy Policy")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "dn dib-sm fs10 mh2",
                                        children: "•"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: {
                                            pathname: _constants/* v5Pages.terms */.Td.terms
                                        },
                                        className: "gray600 hover-gray800 focus-bsDarkBlue3",
                                        style: {
                                            "--br": 0.2
                                        },
                                        children: i18n.t("Terms of Service")
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "fx2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "dg gafc gg4 aic maxw20 df-sm fdcr-sm aifs-sm gg2-sm jcfe",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                marginLeft: isSm ? -10 : 0
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguageSelector/* default */.Z, {
                                className: "mr0-f",
                                anchorDirection: isSm ? "top left" : "top right"
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Footer_MinimalFooter = (MinimalFooter);

;// CONCATENATED MODULE: ./src/components/v5/Footer/Top.tsx









const Top = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { isMobile  } = (0,store/* useTypedSelector */.ix)((state)=>state.config);
    const isSm = (0,useMediaQuery/* default */.Z)("sm");
    const isSmOrMobile = isSm || isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer_SplitLayout, {
        className: "aife fdc-sm aifs-sm contrast-tbt ".concat(isSmOrMobile ? "pb6" : "pb24"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "dg gafr gg8 gg4-xs fx3 mb5-sm df-sm",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            height: 50,
                            width: 50,
                            src: (0,useV5ImgSrc/* useV5ImgSrc */.eH)("/coloredLogo", true),
                            alt: "Carbon Health"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "fs32 fs24-sm gray800 font-c",
                        children: i18n.t("All your healthcare,\n in one place.")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fx2 pl20-sm pl16-xs",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "dg aife gg2 maxw18 gafc",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                            link: true,
                            href: {
                                pathname: _constants/* v5Pages.download */.Td.download
                            },
                            fontSize: isSm ? 0.75 : 1,
                            className: "focus-bsDarkBlue3",
                            children: i18n.t("Get the App")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                            link: true,
                            href: {
                                pathname: _constants/* v5Pages.locations */.Td.locations
                            },
                            fontSize: isSm ? 0.75 : 1,
                            className: "focus-bsDarkBlue3",
                            children: i18n.t("Find a Clinic")
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Footer_Top = (Top);

;// CONCATENATED MODULE: ./src/constants/getCareConstants.ts
/**
 * Useage
 * 
 * import {getCareSlugs} from "src/constants/getCareConstants";
 * 
 * _constants.ts > getCareSlug: "/get-care/[slug]"
 * 
 * href: {
    pathname: v5Pages.getCareSlug,
    query: {
      slug: getCareSlugs.[slug],
    },
  },
 */ const getCareSlugs = {
    covidCare: "covid-care",
    covidTravelTesting: "covid-19-travel-testing",
    nextDayRtPc: "next-day-rt-pc",
    urgentCare: "urgent-care",
    lgbtqHealthAndWellness: "lgbtq-health-and-wellness",
    womansHealth: "womens-health"
};

// EXTERNAL MODULE: ./src/components/v5/Transitions/Fade.tsx
var Fade = __webpack_require__(64800);
;// CONCATENATED MODULE: ./src/components/v5/Footer/DropdownList.tsx




const DropdownList = (param)=>{
    let { section , noBorder  } = param;
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const toggleIsOpen = function() {
        let boolean = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !isOpen;
        return ()=>{
            setIsOpen(boolean);
        };
    };
    const buttonTarget = "".concat(section.header.toLowerCase().replace(" ", "-"), "-footer-menu");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: "ph8 ph4-xs",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "brd-gray200 pv3 ".concat(noBorder ? "brdn" : "brdb"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: "df jcsb aic w100p bg-transparent brdn focus-bsDarkBlue3-hug pv3 cp ph2 fs20 fw4 font-cm ls-3 gray800",
                            style: {
                                "--br": 0.2
                            },
                            onClick: toggleIsOpen(),
                            "aria-expanded": isOpen,
                            "aria-controls": buttonTarget,
                            children: [
                                section.header,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "cIcon-icon_arrow_dropdown fs24 t-100 ".concat(isOpen ? "rotate-180" : ""),
                                    "aria-hidden": true
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                    id: buttonTarget,
                    in: isOpen,
                    duration: 100,
                    timeout: 0,
                    unmountOnExit: true,
                    collapse: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "dg gg6 pv3 gafr",
                        children: section.items.map((param)=>/*#__PURE__*/ {
                            let { text , ...rest } = param;
                            return (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    ...rest,
                                    className: "gray600 font-im hover-font-isb hover-gray800 p2 focus-bsDarkBlue3-hug ls-3",
                                    style: {
                                        "--br": 0.2
                                    },
                                    children: text
                                })
                            }, text);
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Footer_DropdownList = (DropdownList);

;// CONCATENATED MODULE: ./src/components/v5/Footer/SmallMiddle.tsx




const SmallMiddle = (param)=>{
    let { sections  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const combinedSections = [
        sections[0],
        sections[1],
        sections[2],
        {
            id: "get-in-touch",
            header: i18n.t("Get in touch"),
            // @ts-expect-error TS2532, TS2532: Object is possibly 'undefined'.,  Object is possibly 'undefined'.
            items: [
                ...sections.findById("follow").items,
                ...sections.findById("support").items
            ]
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        children: combinedSections.map((section, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_DropdownList, {
                section: section,
                noBorder: i === combinedSections.length - 1
            }, section.header))
    });
};
/* harmony default export */ var Footer_SmallMiddle = (SmallMiddle);

;// CONCATENATED MODULE: ./src/components/v5/Footer/Footer.tsx











const Footer = (param)=>{
    let { minimal  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { isMobile  } = (0,store/* useTypedSelector */.ix)((state)=>state.config);
    const sections = [
        {
            id: "services",
            header: i18n.t("Services"),
            items: [
                {
                    text: i18n.t("Primary Care"),
                    href: {
                        pathname: _constants/* v5Pages.primaryCare */.Td.primaryCare
                    }
                },
                {
                    text: i18n.t("Urgent Care"),
                    href: {
                        pathname: _constants/* v5Pages.urgentCare */.Td.urgentCare
                    }
                },
                {
                    text: i18n.t("Mental Health Care"),
                    href: {
                        pathname: _constants/* v5Pages.virtualCareMental */.Td.virtualCareMental
                    }
                },
                {
                    text: i18n.t("Virtual Care"),
                    href: {
                        pathname: _constants/* v5Pages.virtualCare */.Td.virtualCare
                    }
                },
                {
                    text: i18n.t("COVID Care"),
                    href: {
                        pathname: _constants/* v5Pages.getCareSlug */.Td.getCareSlug,
                        query: {
                            slug: getCareSlugs.covidCare
                        }
                    }
                },
                {
                    text: i18n.t("COVID Travel Testing"),
                    href: {
                        pathname: _constants/* v5Pages.covid19TravelClearance */.Td.covid19TravelClearance
                    }
                },
                {
                    text: i18n.t("Get Care"),
                    href: {
                        pathname: _constants/* v5Pages.getCareRoot */.Td.getCareRoot
                    }
                },
                {
                    text: i18n.t("Insurance & Pricing"),
                    href: {
                        pathname: _constants/* v5Pages.insurance */.Td.insurance
                    }
                }
            ]
        },
        {
            id: "company",
            header: i18n.t("Company"),
            items: [
                {
                    text: i18n.t("Locations"),
                    href: {
                        pathname: _constants/* v5Pages.locations */.Td.locations
                    }
                },
                {
                    text: i18n.t("About Us"),
                    href: {
                        pathname: _constants/* v5Pages.about */.Td.about
                    }
                },
                {
                    text: i18n.t("Careers"),
                    href: {
                        pathname: _constants/* v5Pages.careers */.Td.careers
                    }
                },
                {
                    text: i18n.t("Press"),
                    href: {
                        pathname: _constants/* v5Pages.press */.Td.press
                    }
                },
                {
                    text: i18n.t("Blog"),
                    href: _constants/* blogURL */.GD
                }
            ]
        },
        {
            id: "forBusiness",
            header: i18n.t("For Business"),
            items: [
                {
                    text: i18n.t("Partners"),
                    href: _constants/* v5Pages.partners */.Td.partners
                },
                {
                    text: "Carbon for Campus",
                    href: _constants/* v5Pages.carbonForCampus */.Td.carbonForCampus
                },
                {
                    text: i18n.t("Occupational Health"),
                    href: _constants/* occupationalHealthLink */.U_
                },
                {
                    text: i18n.t("COVID Employer Program"),
                    href: _constants/* v5Pages.covidReady */.Td.covidReady
                }
            ]
        },
        {
            id: "follow",
            header: i18n.t("Follow"),
            items: [
                {
                    text: i18n.t("Instagram"),
                    href: _constants/* instagramUrl */.TG
                },
                {
                    text: i18n.t("Twitter"),
                    href: _constants/* twitterUrl */.x_
                },
                {
                    text: i18n.t("Facebook"),
                    href: _constants/* facebookUrl */.cm
                },
                {
                    text: i18n.t("LinkedIn"),
                    href: _constants/* linkedInUrl */.Gj
                }
            ]
        },
        {
            id: "support",
            header: i18n.t("Get Support"),
            shouldMerge: [
                2,
                i18n.t("Get in touch")
            ],
            isOnRight: true,
            items: [
                {
                    text: "support@carbonhealth.com",
                    href: "mailto:support@carbonhealth.com"
                },
                {
                    text: i18n.t("Support Center"),
                    href: _constants/* supportLink */.gy
                }
            ]
        }
    ];
    const isSm = (0,useMediaQuery/* default */.Z)("sm");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: "pt20 pt10-md ".concat(isMobile ? "brdt brd-gray200" : ""),
        id: "footer",
        children: [
            !minimal && [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Top, {}, "footer-top"),
                isSm ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_SmallMiddle, {
                    sections: sections
                }, "footer-small-middle") : /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Middle, {
                    sections: sections
                }, "footer-middle")
            ],
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_MinimalFooter, {})
        ]
    });
};
/* harmony default export */ var Footer_Footer = (Footer);

// EXTERNAL MODULE: ./src/components/v5/Circle.tsx
var Circle = __webpack_require__(43046);
// EXTERNAL MODULE: ./src/components/v5/NextImage.tsx + 1 modules
var NextImage = __webpack_require__(5621);
// EXTERNAL MODULE: ./public/static/data/localRegions.json
var localRegions = __webpack_require__(14930);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(56722);
// EXTERNAL MODULE: ./src/constants/specialtyIds.ts
var specialtyIds = __webpack_require__(93209);
// EXTERNAL MODULE: ./src/hooks/useQueryController.ts + 1 modules
var useQueryController = __webpack_require__(75290);
// EXTERNAL MODULE: ./src/hooks/useReadableSlotTime.ts + 1 modules
var useReadableSlotTime = __webpack_require__(8764);
// EXTERNAL MODULE: ./src/hooks/useSoonestVirtualSlot.ts
var useSoonestVirtualSlot = __webpack_require__(77230);
// EXTERNAL MODULE: ./src/store/slices/userLocation.ts
var userLocation = __webpack_require__(36330);
// EXTERNAL MODULE: ./src/utils/analytics.ts
var analytics = __webpack_require__(82546);
// EXTERNAL MODULE: ./src/utils/getRedirectUrl.ts
var getRedirectUrl = __webpack_require__(34488);
// EXTERNAL MODULE: ./src/utils/stateUtils.ts + 1 modules
var stateUtils = __webpack_require__(83202);
// EXTERNAL MODULE: ./src/components/v5/Glimmer.tsx
var Glimmer = __webpack_require__(88177);
;// CONCATENATED MODULE: ./src/components/v5/LocationExplorer/VirtualLocations.tsx




















const Loading = /*#__PURE__*/ react.memo(function Loading() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "dg gg2 gafr w100p",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Glimmer/* default */.Z, {
                height: 200
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Glimmer/* default */.Z, {
                height: 30
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Glimmer/* default */.Z, {
                height: 22,
                width: "30%"
            })
        ]
    });
});
const VirtualLocations = ()=>{
    const selectedRegion = (0,store/* useTypedSelector */.ix)(userLocation/* selectSelectedRegion */.dz);
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const flowId = (0,react.useMemo)(()=>(0,v4/* default */.Z)(), []);
    const specialtyId = (0,react.useMemo)(()=>[
            specialtyIds/* SpecialtyId.VIRTUAL_URGENT_CARE */.mg.VIRTUAL_URGENT_CARE
        ], []);
    const regionName = (0,react.useMemo)(()=>{
        var _Regions_find;
        return (_Regions_find = localRegions.find((param)=>{
            let { slug  } = param;
            return slug === selectedRegion;
        })) === null || _Regions_find === void 0 ? void 0 : _Regions_find.name;
    }, [
        selectedRegion
    ]);
    const soonestVirtualSlotQuery = (0,useSoonestVirtualSlot/* useSoonestVirtualSlotInState */.cO)(specialtyId);
    const slot = soonestVirtualSlotQuery === null || soonestVirtualSlotQuery === void 0 ? void 0 : soonestVirtualSlotQuery.data;
    const onClick = ()=>{
        analytics/* analytics.post */.c.post({
            category: analytics/* analytics.category.APPOINTMENT_SCHEDULING */.c.category.APPOINTMENT_SCHEDULING,
            action: analytics/* analytics.action.CLICKED */.c.action.CLICKED,
            label: analytics/* analytics.label.APPOINTMENT_BOOKING_LOCATION_EXPLORER */.c.label.APPOINTMENT_BOOKING_LOCATION_EXPLORER,
            value: "Book Appointment",
            extraData: {
                flowId,
                specialtyId,
                isVirtual: true,
                preselectedState
            }
        });
    };
    const time = (0,useReadableSlotTime/* useReadableSlotTime */.H5)(slot === null || slot === void 0 ? void 0 : slot.time);
    const preselectedState = (0,stateUtils/* getStateCodeFromRegionSlug */.GZ)(selectedRegion);
    const href = (0,getRedirectUrl/* getSchedulingRedirectUrl */._W)({
        flowId,
        virtual: true,
        specialtyId,
        // @ts-expect-error TS2322: Type 'string | null' is not assignable to type 'string | undefined'.
        preselectedState
    });
    if (soonestVirtualSlotQuery.status === useQueryController/* QueryStatus.LOADING */.oZ.LOADING) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "p6 p4-sm maxw30",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {})
    });
    if (!slot) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "df fdc mb8-md maxw30",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            href: href,
            onClick: onClick,
            ...!_constants/* isCI */.yg && {
                target: "_blank",
                rel: "noopener noreferrer"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pos-r mb4",
                    style: {
                        height: 275
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                        className: "br1",
                        objectPosition: "50% 50%",
                        layout: "fill",
                        src: "/dad-with-daughter",
                        alt: i18n.t("A happy father with his daughter during a virtual appointment")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "fs14 zIndex1 bg-transparent",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "df fdc jcsb pos-r hide-scroll-bars",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "font-csb-f mb3 fw5-f mb1 fs18 minw18 minw0-xs font-isb gray800",
                                "data-cy": "location-name",
                                children: i18n.t("{{regionName}}: Virtual care only", {
                                    regionName
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "df fdc ovf-x-a",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "mb2 dg gg2 gafr",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "font-ir gray600 df aic wsnw fw ml2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "df aic pos-r",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Circle/* default */.Z, {
                                                                diameter: 5,
                                                                color: palette.darkGreen,
                                                                className: "mr1 pos-a",
                                                                style: {
                                                                    left: -8
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "font-ib gray800 wsnw",
                                                                children: i18n.t("Virtual Urgent Care")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "fs10 mh1",
                                                                "aria-hidden": true,
                                                                children: "•"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "df aic",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "wsnw",
                                                            children: i18n.t("Next: {{time}}", {
                                                                time
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                                        fontSize: 0.75,
                                        className: "mt2 mb1 focus-bsDarkBlue3-hug",
                                        bg: palette.darkGreen,
                                        onClick: onClick,
                                        "aria-label": i18n.t("Book virtual urgent care appointment"),
                                        type: "link",
                                        faux: true,
                                        children: i18n.t("Book Appointment")
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var LocationExplorer_VirtualLocations = (/*#__PURE__*/react.memo(VirtualLocations));

// EXTERNAL MODULE: ./src/components/v5/Region/RegionTreeSelector.tsx + 5 modules
var RegionTreeSelector = __webpack_require__(93994);
// EXTERNAL MODULE: ./src/_services/featureFlagConstants.ts
var featureFlagConstants = __webpack_require__(72714);
// EXTERNAL MODULE: ./src/constants/hardcodedVirtualRegions.ts
var hardcodedVirtualRegions = __webpack_require__(96821);
// EXTERNAL MODULE: ./src/hooks/useFeatureFlags.ts
var useFeatureFlags = __webpack_require__(15343);
// EXTERNAL MODULE: ./src/utils/fetchCachedSlot.ts + 2 modules
var fetchCachedSlot = __webpack_require__(32570);
// EXTERNAL MODULE: ./src/utils/fetchSoonestSlotByLocationsAndSpecialtyIds.ts
var fetchSoonestSlotByLocationsAndSpecialtyIds = __webpack_require__(65597);
// EXTERNAL MODULE: ./src/components/v5/Locations/LocationDetailsCard.tsx + 2 modules
var LocationDetailsCard = __webpack_require__(85533);
// EXTERNAL MODULE: ./src/useS3ImgSrc.tsx
var useS3ImgSrc = __webpack_require__(52221);
// EXTERNAL MODULE: ./src/utils/timeUtils.ts
var timeUtils = __webpack_require__(40248);
;// CONCATENATED MODULE: ./src/components/v5/LocationExplorer/LocationExplorerCard.tsx







// @ts-expect-error TS7031, TS7031: Binding element 'location' implicitly has an 'any' type.,  Binding element 'soonestSlots' implicitly has an 'any' type.
const LocationExplorerCard = (param)=>{
    let { location , soonestSlots  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { timeString , timeBlock , isOpenNow , isBeforeOpeningToday , daysFromToday  } = (0,timeUtils/* getOpenTime */.gi)(i18n, location);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: "df fdc mb8-md",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pos-r mb4",
                style: {
                    height: 250
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                    className: "br1",
                    objectPosition: "50% 50%",
                    layout: "fill",
                    src: (0,useS3ImgSrc/* s3ImageSource */.Lv)(location.images[0].imageId, "jpg", 2),
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationDetailsCard/* default */.Z, {
                location: location,
                timeBlock: timeBlock,
                timeString: timeString,
                isOpenNow: isOpenNow,
                isBeforeOpeningToday: isBeforeOpeningToday,
                hideButton: false,
                buttonText: i18n.t("View Clinic"),
                daysFromToday: daysFromToday,
                specialtyBoxMode: false,
                soonestSlots: soonestSlots,
                condensed: false
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/v5/LocationExplorer/index.tsx












const STARTING_COUNT = 3;
const INC_BY = 6;
const SPECIALTY_COUNT = 10;
const LocationExplorer = (param)=>{
    let { locations , currentLocationId , headerText , initialRegionSlug , isSlotTimeVisible  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const [selectedRegion, setSelectedRegion] = (0,react.useState)(initialRegionSlug);
    const [soonestSlots, setSoonestSlots] = (0,react.useState)({});
    const [numberOfLocationsToDisplay, setNumberOfLocationsToDisplay] = (0,react.useState)(STARTING_COUNT);
    const onSelectionChange = (key)=>setSelectedRegion(key);
    const handleShowMore = ()=>setNumberOfLocationsToDisplay(numberOfLocationsToDisplay + INC_BY);
    const handleShowLess = ()=>setNumberOfLocationsToDisplay(numberOfLocationsToDisplay - INC_BY);
    const enableCache = (0,useFeatureFlags/* useFeatureFlag */.y)(featureFlagConstants/* FeatureFlag.GROWTH_CACHED_SLOTS_ENABLED */.T.GROWTH_CACHED_SLOTS_ENABLED);
    const regionLocations = locations.filter((param)=>{
        let { region  } = param;
        return region.slug === selectedRegion;
    }).discard((param)=>{
        let { id  } = param;
        return id === currentLocationId;
    });
    const displayedLocations = regionLocations.slice(0, numberOfLocationsToDisplay);
    const isShowMoreVisible = numberOfLocationsToDisplay < regionLocations.length;
    const isShowLessVisible = !isShowMoreVisible && regionLocations.length > STARTING_COUNT && numberOfLocationsToDisplay > STARTING_COUNT;
    // Reset to starting # of displayed locations on region change
    (0,react.useEffect)(()=>{
        setNumberOfLocationsToDisplay(STARTING_COUNT);
    }, [
        selectedRegion
    ]);
    // Fetch slots on update to # of displayed locations or region change
    (0,react.useEffect)(()=>{
        if (!isSlotTimeVisible || enableCache === undefined) return;
        // Only fetch slots for locations we haven't fetched slots for yet
        const locationHasSlot = (param)=>{
            let { id  } = param;
            return soonestSlots.getKeys().includes(id);
        };
        const locationsToFetchSlotsFor = displayedLocations.discard(locationHasSlot);
        if (locationsToFetchSlotsFor.length === 0) return;
        if (enableCache) {
            locationsToFetchSlotsFor.map((param)=>{
                let { id , specialtyIds  } = param;
                return specialtyIds.map((sId)=>{
                    return (0,fetchCachedSlot/* fetchCachedSlot */.P)({
                        locationId: id,
                        specialtyId: sId
                    }).then((slot)=>{
                        return [
                            sId,
                            slot === null || slot === void 0 ? void 0 : slot.time
                        ];
                    });
                }).sequence().then((pars)=>{
                    setSoonestSlots((prevSlots)=>({
                            ...prevSlots,
                            ...{
                                [id]: pars.toObject()
                            }
                        }));
                });
            });
        } else {
            (0,fetchSoonestSlotByLocationsAndSpecialtyIds/* fetchSoonestSlotByLocationsAndSpecialtyIds */.u)({
                locations: locationsToFetchSlotsFor,
                specialtyCount: SPECIALTY_COUNT
            }).then((res)=>setSoonestSlots({
                    ...soonestSlots,
                    ...res
                }));
        }
    }, [
        numberOfLocationsToDisplay,
        selectedRegion
    ]);
    if (displayedLocations.length === 0 && !hardcodedVirtualRegions/* default.some */.Z.some((param)=>{
        let { slug  } = param;
        return slug === selectedRegion;
    })) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        "aria-label": headerText,
        className: "pv16 ph24 ph4-sm ph32-md contrast-tbt",
        style: {
            borderColor: "".concat(palette.gray200, "70")
        },
        id: "explore-locations",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "mb4",
                children: headerText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mh-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionTreeSelector/* default */.Z, {
                    initialRegionSlug: initialRegionSlug,
                    onSelect: onSelectionChange
                })
            }),
            displayedLocations.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationExplorer_VirtualLocations, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "gtc3fr dg gafr gg24 gg12-xl gg12-lg gg0-md df-md fdc-md pv8",
                children: displayedLocations.map((location)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(LocationExplorerCard, {
                        soonestSlots: soonestSlots,
                        location: location
                    }, location.id))
            }),
            isShowMoreVisible && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                onClick: handleShowMore,
                className: "br8 cp ma df brdn bg-white aic gray800 font-isb hover-bg-gray100 pv4 ph6",
                children: [
                    i18n.t("Show more locations"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "cIcon-dropdown-arrow-down ml2 gray800",
                        "aria-hidden": true
                    })
                ]
            }),
            isShowLessVisible && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                onClick: handleShowLess,
                className: "br8 cp ma df brdn bg-white aic gray800 font-isb hover-bg-gray100 pv4 ph6",
                children: [
                    i18n.t("Show less"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "cIcon-dropdown-arrow-up ml2 gray800",
                        "aria-hidden": true
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/v5/LocationExplorer/LocationExplorerContainer.tsx








const EXCLUDED_PAGES = [
    // Location Index
    _constants/* v5Pages.locations */.Td.locations,
    // Partner Pages
    _constants/* v5Pages.alaskaToHawaii */.Td.alaskaToHawaii,
    _constants/* v5Pages.covid19TravelClearance */.Td.covid19TravelClearance,
    // Service Maps
    _constants/* v5Pages.covid19TestingCenters */.Td.covid19TestingCenters,
    _constants/* v5Pages.fluVaccine */.Td.fluVaccine,
    _constants/* v5Pages.endocrinologyMap */.Td.endocrinologyMap,
    _constants/* v5Pages.mammogramMap */.Td.mammogramMap,
    _constants/* v5Pages.vaccineNearMe */.Td.vaccineNearMe,
    // Healthpass
    _constants/* v5Pages.healthPass */.Td.healthPass,
    _constants/* v5Pages.partners */.Td.partners,
    // Care Discovery
    _constants/* v5Pages.getCareSlug */.Td.getCareSlug,
    _constants/* v5Pages.testpage */.Td.testpage
];
const LocationExplorerContainer = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { locations  } = (0,store/* useTypedSelector */.ix)((param)=>{
        let { config  } = param;
        return config;
    });
    const selectedRegion = (0,store/* useTypedSelector */.ix)(userLocation/* selectSelectedRegion */.dz);
    const { pathname , query  } = (0,router.useRouter)();
    const isLocationPage = pathname === _constants/* v5Pages.clinicDetails */.Td.clinicDetails;
    let currentLocationId;
    let initialRegion = selectedRegion;
    let isSlotTimeVisible = true;
    let headerText = i18n.t("Explore our locations");
    if (isLocationPage) {
        const currentLocation = locations.find((param)=>{
            let { slug  } = param;
            return slug === query.slug;
        });
        if (currentLocation) {
            currentLocationId = currentLocation.id;
            initialRegion = currentLocation.region.slug;
        }
        isSlotTimeVisible = true;
        headerText = i18n.t("Explore other nearby locations");
    }
    if (!locations || locations.length === 0) return null;
    if (!selectedRegion) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationExplorer, {
        locations: locations,
        headerText: headerText,
        initialRegionSlug: initialRegion,
        // @ts-expect-error TS2322: Type 'string | undefined' is not assignable to type 'string'.
        currentLocationId: currentLocationId,
        isSlotTimeVisible: isSlotTimeVisible
    });
};

// EXTERNAL MODULE: ./src/components/v5/Modal.tsx
var Modal = __webpack_require__(27591);
// EXTERNAL MODULE: ./src/components/v5/Maps/Notice.tsx
var Notice = __webpack_require__(50496);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Collapse/Collapse.js + 87 modules
var Collapse = __webpack_require__(45959);
// EXTERNAL MODULE: ./src/_services/featureFlags.ts
var featureFlags = __webpack_require__(30660);
// EXTERNAL MODULE: ./node_modules/moment-timezone/index.js
var moment_timezone = __webpack_require__(50995);
var moment_timezone_default = /*#__PURE__*/__webpack_require__.n(moment_timezone);
// EXTERNAL MODULE: ./src/useScroll.ts
var useScroll = __webpack_require__(31218);
// EXTERNAL MODULE: ./src/utils/arrays.ts
var arrays = __webpack_require__(91309);
;// CONCATENATED MODULE: ./src/components/v5/DynamicBanner.tsx














/*
eg:
const banners: Banner[] = [
  {
    when: "11/11-11/25",
    text: "Test - Carbon Health clinics will be closed for Thanksgiving on Thursday, Nov 25.",
    subtext: <div>Please check specific clinic hours for other holiday <b>changes</b>.<div>,
    name: "Test Thanksgiving",
    pathsInclude: ["/locations/[slug]"],
    type: "info",
    icon: "info",
    "wrapperClasses": "!bg-yellow-200"
  },
];
*/ const format = "MM/DD";
const DynamicBanner = (param)=>{
    let { bannerData , now  } = param;
    const { y  } = (0,useScroll/* default */.Z)();
    const bannerWrapperRef = (0,react.useRef)(null);
    const windowSize = (0,Carbon/* useWindowSize */.fy)();
    const dispatch = (0,store/* useTypedDispatch */.zL)();
    const { t  } = (0,src_i18n/* useTranslation */.$G)();
    const { pathname  } = (0,router.useRouter)();
    const [banners, setBanners] = (0,react.useState)([]);
    const [banner, setBanner] = (0,react.useState)(null);
    const { locations , locationsSorted  } = (0,store/* useTypedSelector */.ix)((param)=>{
        let { config  } = param;
        return config;
    });
    (0,react.useEffect)(()=>{
        if (bannerData) return;
        (0,featureFlags/* fetchFeatureFlags */.Vw)({
            [featureFlagConstants/* FeatureFlag.GROWTH_WEBSITE_BANNER */.T.GROWTH_WEBSITE_BANNER]: []
        }).then((res)=>{
            const bannersFetched = res[featureFlagConstants/* FeatureFlag.GROWTH_WEBSITE_BANNER */.T.GROWTH_WEBSITE_BANNER];
            setBanners(bannersFetched);
        });
    }, [
        bannerData
    ]);
    (0,react.useEffect)(()=>{
        var _locations_;
        if (!locationsSorted) return;
        // Get the closest state (Didn't use the regions because this works with states)
        const closestState = locations === null || locations === void 0 ? void 0 : (_locations_ = locations[0]) === null || _locations_ === void 0 ? void 0 : _locations_.address.state;
        const bannersFound = (bannerData || banners).map((banner, i)=>{
            const { when , pathsInclude , pathsExclude , type , text , subtext , icon ="info" , wrapperClasses , states  } = banner;
            const [from, to] = when.split("-");
            const startTime = +moment_timezone_default()(from, format);
            const endTime = +moment_timezone_default()(to, format).clone().endOf("day");
            const dateMatch = moment_timezone_default()(now).isBetween(startTime, endTime);
            const pathsMatch = pathsInclude ? pathsInclude.includes(pathname) : true; // if empty, show in all paths
            const pathsExcludeMatch = !(pathsExclude === null || pathsExclude === void 0 ? void 0 : pathsExclude.includes(pathname));
            const statesMatch = states ? states.includes(closestState) : true; // if empty, show in all states
            if (!dateMatch || !pathsMatch || !pathsExcludeMatch || !statesMatch) return null;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Notice/* default */.Z, {
                type: type,
                text: typeof text === "string" ? t(text) : text,
                subtext: t(subtext || ""),
                icon: icon,
                ignoreRange: true,
                className: "rounded-none min-w-full justify-center ".concat(wrapperClasses)
            }, i);
        });
        const bannerFound = (0,arrays/* compact */.o)(bannersFound)[0];
        setBanner(bannerFound);
    }, [
        bannerData,
        banners,
        dispatch,
        locations,
        locationsSorted,
        now,
        pathname,
        t
    ]);
    (0,react.useEffect)(()=>{
        var _bannerWrapperRef_current;
        if (!banner) return;
        // Get BannersWrapper height and update #banner-spacer's height
        const bannerSpacerEl = document.querySelector("#".concat(bannerSpacer));
        const bannersWrapperHeight = (_bannerWrapperRef_current = bannerWrapperRef.current) === null || _bannerWrapperRef_current === void 0 ? void 0 : _bannerWrapperRef_current.offsetHeight;
        if (bannerSpacerEl && bannersWrapperHeight) {
            bannerSpacerEl.style.height = "".concat(bannersWrapperHeight, "px");
        }
    }, [
        banner,
        bannerWrapperRef,
        windowSize
    ]);
    return banner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
        in: y > -32,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: bannerWrapperRef,
            children: banner
        })
    }) : null;
};
/* harmony default export */ var v5_DynamicBanner = (/*#__PURE__*/react.memo(DynamicBanner));

// EXTERNAL MODULE: ./src/components/v5/NextLink.tsx
var NextLink = __webpack_require__(10738);
// EXTERNAL MODULE: ./src/utils/transparent.ts
var transparent = __webpack_require__(74355);
;// CONCATENATED MODULE: ./src/components/v5/Nav/DropdownMenuItem.tsx







const NavItem = (param)=>/*#__PURE__*/ {
    let { setIsHovered , isHovered , href , image , title , subTitle , as , external , onClick  } = param;
    return (0,jsx_runtime.jsx)("li", {
        className: "br8 t-100",
        onFocus: ()=>setIsHovered(title),
        // @ts-expect-error TS2345: Argument of type 'null' is not assignable to parameter of type 'SetStateAction<string>'.
        onBlur: ()=>setIsHovered(null),
        onMouseEnter: ()=>setIsHovered(title),
        // @ts-expect-error TS2345: Argument of type 'null' is not assignable to parameter of type 'SetStateAction<string>'.
        onMouseLeave: ()=>setIsHovered(null),
        style: {
            borderRadius: "6rem",
            backgroundColor: isHovered ? palette.lightYellow : "white"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
            as,
            href,
            external,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                ...external && typeof href !== "object" && {
                    href
                },
                className: "df aic focus-bsDarkBlue3 p2 br8",
                onClick: ()=>onClick(title),
                "data-cy": "menu-child",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "br50 ovf-x-h ovf-y-h bg-white df aic jcc mr3",
                        style: {
                            width: 58,
                            height: 58
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                            quality: 100,
                            extension: "png",
                            width: 50,
                            height: 50,
                            src: image,
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "df fdc pr6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                className: "gray800 font-isb fs18 lh15 wsnw",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "gray800 font-ir fs14 lh15 wsnw",
                                children: subTitle
                            })
                        ]
                    })
                ]
            })
        })
    });
};
const DropdownMenuItem = (param)=>{
    let { item , onFocus , onClick  } = param;
    // @ts-expect-error TS2345: Argument of type 'null' is not assignable to parameter of type 'string | (() => string)'.
    const [isHovered, setIsHovered] = (0,react.useState)(null);
    const { id , title , subTitle , secondaryTitle , moreMenuItems , style ={}  } = item;
    // 1px is to account for border width
    const placementStyle = {
        top: "100%",
        ...style
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        role: "region",
        className: "pos-a wa brdt brd-gray100 bs1 hfc contrast-tb",
        style: placementStyle,
        onFocus: onFocus,
        id: "".concat(id, "-dropdown"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "df bg-white",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    "aria-labelledby": "".concat(id, "-main"),
                    className: "ph12 pt10 pb12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "ml4 mb4 ttu fs13 lh24 font-im gray400 ls3 ".concat(subTitle ? "" : "visually-hidden"),
                            id: "".concat(id, "-main"),
                            children: subTitle || title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "dg gtc2a gafr cg3 cr3",
                            children: item.menuItems.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                                    setIsHovered: setIsHovered,
                                    isHovered: item.title === isHovered,
                                    onClick: onClick,
                                    ...item
                                }, item.title))
                        })
                    ]
                }),
                moreMenuItems && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    "aria-labelledby": "".concat(id, "-secondary"),
                    className: "ph12 pt10 pb12 minw22 contrast-tbl",
                    style: {
                        backgroundColor: (0,transparent/* transparent */.Z)(palette.gray100, 50)
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            id: "".concat(id, "-secondary"),
                            className: "ml4 mb8 ttu fs13 lh24 font-im gray400 ls3",
                            children: secondaryTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            children: moreMenuItems.map((param)=>/*#__PURE__*/ {
                                let { title , as , href , external , newTab  } = param;
                                return (0,jsx_runtime.jsxs)("li", {
                                    className: "mb3 df",
                                    onFocus: ()=>setIsHovered(title),
                                    // @ts-expect-error TS2345: Argument of type 'null' is not assignable to parameter of type 'SetStateAction<string>'.
                                    onBlur: ()=>setIsHovered(null),
                                    onMouseEnter: ()=>setIsHovered(title),
                                    // @ts-expect-error TS2345: Argument of type 'null' is not assignable to parameter of type 'SetStateAction<string>'.
                                    onMouseLeave: ()=>setIsHovered(null),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavCircle, {
                                            className: "w4 jcs",
                                            isHovered: title === isHovered
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                            as,
                                            href,
                                            external,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                ...newTab && {
                                                    target: "_blank",
                                                    rel: "noopener noreferrer"
                                                },
                                                ...external && {
                                                    href
                                                },
                                                // @ts-expect-error TS2322: Type 'string | false' is not assignable to type 'string | undefined'.
                                                href: typeof href !== "object" && href,
                                                className: "fx wsnw gray800 hover-gray800 font-im hover-font-isb fs16 lh16",
                                                onClick: ()=>onClick(title),
                                                "data-cy": "menu-child",
                                                children: title
                                            })
                                        })
                                    ]
                                }, title);
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/v5/Nav/utils.ts

const trackNavLinkClick = (label, section, value, labelCopy)=>{
    analytics/* analytics.post */.c.post({
        category: "NavigationDiscovery",
        label,
        action: "Clicked",
        value,
        extraData: {
            section,
            labelcopy: labelCopy
        }
    });
};

// EXTERNAL MODULE: ./node_modules/@react-aria/focus/dist/module.js
var dist_module = __webpack_require__(39475);
;// CONCATENATED MODULE: ./src/constants/NavConstants.tsx




const hasDropDownMenu = (item)=>Boolean(item.menuItems);
const useHeaderConstants = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const covidRef = (0,react.useRef)(null);
    const getCareRef = (0,react.useRef)(null);
    // @ts-expect-error TS2322: Type '{ config: { center: ({ id: string; style: { transform: string; left: string; }; title: string; subTitle: string | undefined; secondaryTitle: string | undefined; ariaLabel: string | undefined; label: "Services"; menuItems: ({ ...; } | ... 4 more ... | { ...; })[]; moreMenuItems: ({ ...; } | ... 1 more ... | { ...; })...' is not assignable to type '{ config: NavConfig; }'.
    const config = (0,react.useMemo)(()=>({
            config: {
                center: [
                    {
                        id: "services",
                        style: {
                            transform: "translateX(-50%)",
                            left: "45%"
                        },
                        title: i18n.t("Get Care"),
                        subTitle: i18n.t("Core Services"),
                        secondaryTitle: i18n.t("Specialties"),
                        ariaLabel: i18n.t("Click to toggle a dropdown menu for Carbon Health's patient services."),
                        label: "Services",
                        menuItems: [
                            {
                                href: _constants/* v5Pages.urgentCare */.Td.urgentCare,
                                image: "navigation/get-care/01",
                                title: i18n.t("Urgent Care"),
                                subTitle: i18n.t("Get care quickly")
                            },
                            {
                                href: _constants/* v5Pages.virtualCare */.Td.virtualCare,
                                image: "navigation/get-care/02",
                                title: i18n.t("Virtual Care"),
                                subTitle: i18n.t("Connect on the go")
                            },
                            {
                                href: _constants/* v5Pages.primaryCare */.Td.primaryCare,
                                image: "navigation/get-care/03",
                                title: i18n.t("Primary Care"),
                                subTitle: i18n.t("Get preventative care")
                            },
                            {
                                href: _constants/* v5Pages.virtualCareMental */.Td.virtualCareMental,
                                image: "navigation/get-care/04",
                                title: i18n.t("Mental Health"),
                                subTitle: i18n.t("Video chat with a provider")
                            },
                            {
                                href: {
                                    pathname: _constants/* v5Pages.getCareSlug */.Td.getCareSlug,
                                    query: {
                                        slug: getCareSlugs.covidCare
                                    }
                                },
                                image: "navigation/covid-19/03",
                                title: i18n.t("COVID Care"),
                                subTitle: i18n.t("Testing, vaccination, & treatment")
                            },
                            {
                                href: _constants/* v5Pages.covid19TravelClearance */.Td.covid19TravelClearance,
                                image: "navigation/covid-19/01",
                                title: i18n.t("COVID Travel Testing"),
                                subTitle: i18n.t("Find & book a test")
                            }
                        ],
                        moreMenuItems: [
                            {
                                title: i18n.t("Women's Health"),
                                href: {
                                    pathname: _constants/* v5Pages.getCareSlug */.Td.getCareSlug,
                                    query: {
                                        slug: getCareSlugs.womansHealth
                                    }
                                }
                            },
                            {
                                title: i18n.t("LGBTQ+ Health"),
                                href: {
                                    pathname: _constants/* v5Pages.getCareSlug */.Td.getCareSlug,
                                    query: {
                                        slug: getCareSlugs.lgbtqHealthAndWellness
                                    }
                                }
                            },
                            {
                                title: i18n.t("Diabetes Care"),
                                href: _constants/* v5Pages.diabetesCare */.Td.diabetesCare,
                                external: true
                            }
                        ]
                    },
                    {
                        title: i18n.t("Insurance & Pricing"),
                        href: _constants/* v5Pages.insurance */.Td.insurance,
                        ariaLabel: i18n.t("Click to view detailed insurance and pricing information."),
                        label: "Insurances"
                    },
                    {
                        title: i18n.t("Locations"),
                        href: _constants/* v5Pages.locations */.Td.locations,
                        ariaLabel: i18n.t("Click to view an interactive map of Carbon Health clinics."),
                        label: "Locations"
                    },
                    {
                        id: "company",
                        style: {
                            transform: "translateX(-50%)",
                            left: "45%"
                        },
                        title: i18n.t("Company"),
                        subTitle: i18n.t("Carbon Health"),
                        secondaryTitle: i18n.t("for business"),
                        ariaLabel: i18n.t("Click to view an interactive map of Carbon Health clinics."),
                        label: "Company",
                        menuItems: [
                            {
                                href: _constants/* v5Pages.about */.Td.about,
                                image: "navigation/company/01",
                                title: i18n.t("About Us"),
                                subTitle: i18n.t("Vision, values, & team")
                            },
                            {
                                href: _constants/* v5Pages.press */.Td.press,
                                image: "navigation/company/05",
                                title: i18n.t("Press"),
                                subTitle: i18n.t("News & press kit")
                            },
                            {
                                href: _constants/* v5Pages.careers */.Td.careers,
                                image: "navigation/company/03",
                                title: i18n.t("Careers"),
                                subTitle: i18n.t("We're hiring")
                            },
                            {
                                href: _constants/* v5Pages.blog */.Td.blog,
                                image: "navigation/company/04",
                                title: i18n.t("Blog"),
                                subTitle: i18n.t("Health & wellness resources")
                            }
                        ],
                        moreMenuItems: [
                            {
                                title: i18n.t("Partners"),
                                href: _constants/* v5Pages.partners */.Td.partners
                            },
                            {
                                title: "Carbon for Campus",
                                href: _constants/* v5Pages.carbonForCampus */.Td.carbonForCampus
                            },
                            {
                                title: i18n.t("Occupational Health"),
                                href: _constants/* occupationalHealthLink */.U_,
                                external: true
                            },
                            {
                                title: i18n.t("COVID Employer Program"),
                                href: _constants/* v5Pages.covidReady */.Td.covidReady
                            }
                        ]
                    }
                ],
                // @ts-expect-error TS2352, TS2352: Conversion of type '{ accordion: ({ title: string; id: string; ref: React.MutableRefObject<null>; label: "Services"; sub: ({ title: string; href: "/urgent-care"; } | { title: string; href: "/primary-care"; } | ... 4 more ... | { ...; })[]; } | { ...; })[]; footer: ({ ...; } | { ...; })[]; }' to type 'Drawer' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.,  Conversion of type '{ accordion: ({ title: string; id: string; ref: React.MutableRefObject<null>; label: "Services"; sub: ({ title: string; href: "/urgent-care"; } | { title: string; href: "/primary-care"; } | ... 4 more ... | { ...; })[]; } | { ...; })[]; footer: ({ ...; } | { ...; })[]; }' to type 'Drawer' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
                drawer: {
                    accordion: [
                        {
                            title: i18n.t("Get Care"),
                            id: "get-care",
                            ref: getCareRef,
                            label: "Services",
                            sub: [
                                {
                                    title: i18n.t("Urgent Care"),
                                    href: _constants/* v5Pages.urgentCare */.Td.urgentCare
                                },
                                {
                                    title: i18n.t("Primary Care"),
                                    href: _constants/* v5Pages.primaryCare */.Td.primaryCare
                                },
                                {
                                    title: i18n.t("Virtual Care"),
                                    href: _constants/* v5Pages.virtualCare */.Td.virtualCare
                                },
                                {
                                    title: i18n.t("Mental Health Care"),
                                    href: _constants/* v5Pages.virtualCareMental */.Td.virtualCareMental
                                },
                                {
                                    title: i18n.t("Women's Health"),
                                    href: {
                                        pathname: _constants/* v5Pages.getCareSlug */.Td.getCareSlug,
                                        query: {
                                            slug: getCareSlugs.womansHealth
                                        }
                                    }
                                },
                                {
                                    title: i18n.t("LGBTQ+ Health"),
                                    href: {
                                        pathname: _constants/* v5Pages.getCareSlug */.Td.getCareSlug,
                                        query: {
                                            slug: getCareSlugs.lgbtqHealthAndWellness
                                        }
                                    }
                                },
                                {
                                    title: i18n.t("Diabetes Management"),
                                    href: _constants/* v5Pages.diabetesCare */.Td.diabetesCare,
                                    external: true
                                }
                            ]
                        },
                        {
                            title: i18n.t("COVID-19"),
                            id: "covid-19",
                            ref: covidRef,
                            label: "Covid",
                            sub: [
                                {
                                    title: i18n.t("COVID Care"),
                                    href: {
                                        pathname: _constants/* v5Pages.getCareSlug */.Td.getCareSlug,
                                        query: {
                                            slug: getCareSlugs.covidCare
                                        }
                                    }
                                },
                                {
                                    title: i18n.t("COVID Travel Testing"),
                                    href: _constants/* v5Pages.covid19TravelClearance */.Td.covid19TravelClearance
                                },
                                {
                                    title: i18n.t("Employer Program"),
                                    href: _constants/* v5Pages.covidReady */.Td.covidReady
                                }
                            ]
                        }
                    ],
                    footer: [
                        {
                            title: i18n.t("Home"),
                            href: _constants/* v5Pages.home */.Td.home,
                            ariaLabel: i18n.t("Click to visit the Carbon Health home page.")
                        },
                        {
                            title: i18n.t("Press"),
                            href: _constants/* v5Pages.press */.Td.press
                        },
                        {
                            title: i18n.t("About Us"),
                            href: _constants/* v5Pages.about */.Td.about,
                            ariaLabel: i18n.t("Click to learn more about Carbon Health's leaders and values.")
                        },
                        {
                            title: i18n.t("Partners"),
                            href: _constants/* v5Pages.partners */.Td.partners
                        },
                        {
                            title: i18n.t("Insurance & Pricing"),
                            href: _constants/* v5Pages.insurance */.Td.insurance,
                            ariaLabel: i18n.t("Click to view detailed insurance and pricing information.")
                        },
                        {
                            title: "Carbon for Campus",
                            href: _constants/* v5Pages.carbonForCampus */.Td.carbonForCampus
                        },
                        {
                            title: i18n.t("Careers"),
                            href: _constants/* v5Pages.careers */.Td.careers,
                            ariaLabel: i18n.t("Learn more about opportunities to join Carbon Health.")
                        },
                        {
                            title: i18n.t("Occupational Health"),
                            href: _constants/* occupationalHealthLink */.U_
                        },
                        {
                            title: i18n.t("Blog"),
                            href: _constants/* blogURL */.GD,
                            ariaLabel: i18n.t("Click to visit the Carbon Health blog.")
                        },
                        {
                            title: i18n.t("Support"),
                            href: _constants/* supportLink */.gy
                        }
                    ]
                }
            }
        }), [
        i18n
    ]);
    return config;
};

// EXTERNAL MODULE: ./src/components/v5/components/Dialog/useDialog.tsx
var useDialog = __webpack_require__(93063);
// EXTERNAL MODULE: ./node_modules/@react-aria/button/dist/module.js
var button_dist_module = __webpack_require__(19811);
// EXTERNAL MODULE: ./node_modules/@react-aria/menu/dist/module.js
var menu_dist_module = __webpack_require__(84528);
// EXTERNAL MODULE: ./node_modules/@react-stately/menu/dist/module.js
var _react_stately_menu_dist_module = __webpack_require__(86771);
// EXTERNAL MODULE: ./src/hooks/useClientSideId.ts
var useClientSideId = __webpack_require__(33437);
// EXTERNAL MODULE: ./node_modules/@react-aria/interactions/dist/module.js
var interactions_dist_module = __webpack_require__(99321);
// EXTERNAL MODULE: ./node_modules/@react-aria/utils/dist/module.js
var utils_dist_module = __webpack_require__(3912);
;// CONCATENATED MODULE: ./src/components/v5/components/Menu/MenuItem.tsx







const MenuItem = (param)=>{
    let { item , state , onAction , onClose  } = param;
    // Get props for the menu item element
    const ref = react.useRef();
    const { menuItemProps  } = (0,menu_dist_module/* useMenuItem */.iX)({
        key: item.key,
        onAction,
        onClose
    }, state, // @ts-expect-error TS2345: Argument of type 'MutableRefObject<undefined>' is not assignable to parameter of type 'RefObject<HTMLElement>'.
    ref);
    // Handle focus events so we can apply highlighted
    // style to the focused menu item
    const [isFocused, setFocused] = react.useState(false);
    const { focusProps  } = (0,interactions_dist_module/* useFocus */.KK)({
        onFocusChange: setFocused
    });
    const [selectedKey] = state.selectionManager.selectedKeys;
    const isSelected = item.key === selectedKey;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_module/* FocusRing */.tE, {
        focusRingClass: "focus-ring",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
            ...(0,utils_dist_module/* mergeProps */.dG)(menuItemProps, focusProps),
            // @ts-expect-error TS2322: Type 'MutableRefObject<undefined>' is not assignable to type 'LegacyRef<HTMLLIElement> | undefined'.
            ref: ref,
            className: "aria-focus cp df aic jcsb fs16 lh15 ph6 pv3 br8 ".concat(isFocused || isSelected ? "font-isb" : "font-ir", " ").concat(isSelected ? "contrast-tb" : ""),
            style: {
                backgroundColor: isSelected ? palette.darkGreen : isFocused ? "".concat(palette.gray800, "10") : "transparent",
                color: isSelected ? "white" : palette.gray800
            },
            "data-cy": "lng",
            children: [
                item.rendered,
                isSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    "aria-hidden": true,
                    className: "cIcon-check white"
                })
            ]
        })
    });
};
/* harmony default export */ var Menu_MenuItem = (/*#__PURE__*/react.memo(MenuItem));

// EXTERNAL MODULE: ./node_modules/@react-aria/overlays/dist/module.js + 1 modules
var overlays_dist_module = __webpack_require__(89729);
// EXTERNAL MODULE: ./node_modules/@react-stately/tree/dist/module.js
var tree_dist_module = __webpack_require__(10619);
;// CONCATENATED MODULE: ./src/components/v5/components/Menu/constants.ts
const positions = {
    "bottom left": {
        top: 42,
        left: 0
    },
    "bottom right": {
        top: 42,
        right: 0
    },
    "top left": {
        bottom: 42
    },
    "top right": {
        bottom: 42,
        right: 0
    }
};

;// CONCATENATED MODULE: ./src/components/v5/components/Menu/MenuPopup.tsx









const MenuPopup = (props)=>{
    const state = (0,tree_dist_module/* useTreeState */.D)({
        ...props,
        selectionMode: "single"
    });
    const ref = react.useRef();
    // @ts-expect-error TS2345: Argument of type 'MutableRefObject<undefined>' is not assignable to parameter of type 'RefObject<HTMLElement>'.
    const { menuProps  } = (0,menu_dist_module/* useMenu */.H9)(props, state, ref);
    const overlayRef = react.useRef();
    const { overlayProps  } = (0,overlays_dist_module/* useOverlay */.Ir)({
        onClose: props.onClose,
        shouldCloseOnBlur: true,
        isOpen: true,
        isDismissable: true
    }, // @ts-expect-error TS2345: Argument of type 'MutableRefObject<undefined>' is not assignable to parameter of type 'RefObject<HTMLElement>'.
    overlayRef);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_module/* FocusScope */.MT, {
        restoreFocus: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            ...overlayProps,
            ref: overlayRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(overlays_dist_module/* DismissButton */.U4, {
                    onDismiss: props.onClose
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "pos-a p6 bg-gray50 br5 minw18 mt2 bs2 zIndex2 contrast-tb",
                    style: {
                        ...positions[props.anchorDirection]
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "gray800 fs16 lh15 ph6 mb2",
                            children: props.label
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            ...(0,utils_dist_module/* mergeProps */.dG)(menuProps, props.domProps),
                            ref: ref,
                            children: [
                                ...state.collection
                            ].map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_MenuItem, {
                                    item: item,
                                    state: state,
                                    // @ts-expect-error TS2322: Type '((key: Key) => void) | undefined' is not assignable to type '(key: Key) => void'.
                                    onAction: props.onAction,
                                    onClose: props.onClose
                                }, item.key))
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(overlays_dist_module/* DismissButton */.U4, {
                    onDismiss: props.onClose
                })
            ]
        })
    });
};
/* harmony default export */ var Menu_MenuPopup = (/*#__PURE__*/react.memo(MenuPopup));

;// CONCATENATED MODULE: ./src/components/v5/components/Menu/MenuButton.tsx









const MenuButton = (props)=>{
    // Create state based on the incoming props
    const state = (0,_react_stately_menu_dist_module/* useMenuTriggerState */.W)(props);
    const menuId = (0,useClientSideId/* useClientSideId */.i)();
    const triggerId = (0,useClientSideId/* useClientSideId */.i)();
    // Get props for the menu trigger and menu elements
    const ref = react.useRef();
    // @ts-expect-error TS2345: Argument of type 'MutableRefObject<undefined>' is not assignable to parameter of type 'RefObject<HTMLElement>'.
    const { menuTriggerProps , menuProps  } = (0,menu_dist_module/* useMenuTrigger */.u4)({}, state, ref);
    // Get props for the button based on the trigger props from useMenuTrigger
    // @ts-expect-error TS2769: No overload matches this call.
    const { buttonProps: menuButtonProps  } = (0,button_dist_module/* useButton */.U)(menuTriggerProps, ref);
    const { patchedButtonProps , patchedMenuProps  } = (0,react.useMemo)(()=>{
        return {
            patchedButtonProps: {
                ...menuButtonProps,
                ref,
                id: triggerId
            },
            patchedMenuProps: {
                ...menuProps,
                id: menuId,
                "aria-labelledby": triggerId
            }
        };
    }, [
        menuButtonProps,
        menuId,
        menuProps,
        triggerId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pos-r dib",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_module/* FocusRing */.tE, {
                focusRingClass: "focus-ring",
                children: props.renderButton(patchedButtonProps)
            }),
            state.isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyComp/* LazyComp */.P, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_MenuPopup, {
                    ...props,
                    domProps: patchedMenuProps,
                    autoFocus: state.focusStrategy,
                    onClose: ()=>state.close(),
                    "aria-label": props.label
                })
            })
        ]
    });
};
/* harmony default export */ var Menu_MenuButton = (/*#__PURE__*/react.memo(MenuButton));

// EXTERNAL MODULE: ./node_modules/@react-stately/collections/dist/module.js
var collections_dist_module = __webpack_require__(81207);
;// CONCATENATED MODULE: ./src/components/v5/Nav/NavLanguageSelector.tsx






const NavLanguageSelector = (param)=>{
    let { renderButton , anchorDirection ="bottom left"  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const options = (0,react.useMemo)(()=>{
        return languages.languages.filter((lng)=>languages.selectable.includes(lng.code)).map((lng)=>{
            return {
                text: lng === null || lng === void 0 ? void 0 : lng.native,
                value: lng.code
            };
        });
    }, []);
    const selected = options.find((param)=>{
        let { value  } = param;
        return value === i18n.lang.substr(0, 2);
    });
    const selectedKeys = (0,react.useMemo)(()=>{
        return [
            selected === null || selected === void 0 ? void 0 : selected.value
        ];
    }, [
        selected === null || selected === void 0 ? void 0 : selected.value
    ]);
    const onAction = (0,react.useCallback)((code)=>(0,src_i18n/* setLanguage */.m0)(code), []);
    const _renderButton = (0,react.useCallback)((props)=>{
        return renderButton({
            selectedItem: selected === null || selected === void 0 ? void 0 : selected.text,
            ...props
        });
    }, [
        renderButton,
        selected === null || selected === void 0 ? void 0 : selected.text
    ]);
    const renderItem = (0,react.useCallback)((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(collections_dist_module/* Item */.ck, {
            children: item.text
        }, item.value), []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_MenuButton, {
        label: i18n.t("Select Language"),
        // @ts-expect-error TS2322: Type '(code: string) => Promise<boolean>' is not assignable to type '(key: Key) => void'.
        onAction: onAction,
        // @ts-expect-error TS2322: Type '(string | undefined)[]' is not assignable to type '"all" | Iterable<Key> | undefined'.
        selectedKeys: selectedKeys,
        items: options,
        anchorDirection: anchorDirection,
        renderButton: _renderButton,
        children: renderItem
    });
};

;// CONCATENATED MODULE: ./src/components/v5/Nav/DrawerNavAnchor.tsx




const DrawerNavAnchor = (param)=>{
    let { title , href , as , newTab , external , ariaLabel , closeDrawer , onClick  } = param;
    const [hovered, setHovered] = (0,react.useState)(false);
    const toggleHovered = (boolean)=>()=>{
            if (typeof boolean === "boolean") {
                setHovered(boolean);
            } else {
                setHovered(!hovered);
            }
        };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: "gray800 hover-darkGreen fs16 lh22",
        onClick: (e)=>{
            e.stopPropagation();
            closeDrawer();
            // @ts-expect-error TS2722: Cannot invoke an object which is possibly 'undefined'.
            onClick();
        },
        onMouseEnter: toggleHovered(true),
        onMouseLeave: toggleHovered(false),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
            as,
            href,
            external,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                "aria-label": ariaLabel || title,
                className: "focus-bsDarkBlue3 dif aic",
                onFocus: toggleHovered(true),
                onBlur: toggleHovered(false),
                ...newTab && {
                    target: "_blank",
                    rel: "noopener noreferrer"
                },
                ...external && {
                    href
                },
                "data-cy": "drawer-child-link",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        height: 6,
                        width: 6,
                        className: "t-150",
                        style: {
                            visibility: hovered ? "visible" : "hidden",
                            opacity: hovered ? 1 : 0
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                            cx: "50%",
                            cy: "50%",
                            r: "45%",
                            strokeWidth: "3",
                            fill: palette.green
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "ml3 font-c",
                        style: {
                            color: hovered ? palette.green : palette.gray800
                        },
                        children: title
                    })
                ]
            })
        })
    }, title);
};
/* harmony default export */ var Nav_DrawerNavAnchor = (DrawerNavAnchor);

;// CONCATENATED MODULE: ./src/components/v5/Nav/Drawer.tsx













const Drawer = (param)=>{
    let { closeDrawer  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { config: { drawer  }  } = useHeaderConstants();
    const [openIndexes, setOpenIndexes] = (0,react.useState)([]);
    const toggleOpenIndex = (i)=>()=>{
            if (openIndexes.includes(i)) {
                setOpenIndexes(openIndexes.filter((x)=>x !== i));
            } else {
                setOpenIndexes([
                    ...openIndexes,
                    i
                ].distinct());
            }
        };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "df fdc pt4 bg-white h100vh",
        "data-cy": "drawer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_module/* FocusRing */.tE, {
                focusRingClass: "focus-ring",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "pos-a right0 top0 mt3 mr3 br50 brdn cp zIndex2 aria-focus",
                    "aria-label": i18n.t("Close Menu"),
                    style: {
                        height: "2.5rem",
                        width: "2.5rem"
                    },
                    onClick: ()=>{
                        closeDrawer();
                        trackNavLinkClick("Menu", "Menu", "Close Menu", "");
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "cIcon-close fs12",
                        "aria-hidden": true
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLanguageSelector, {
                renderButton: (param)=>/*#__PURE__*/ {
                    let { selectedItem , ...rest } = param;
                    return (0,jsx_runtime.jsxs)("button", {
                        ...rest,
                        className: "br8 ph4 pv3 brdn fs14 lh1 cp bg-transparent df aic ph10 aria-focus",
                        onClick: ()=>trackNavLinkClick("Languages", "Menu", selectedItem, selectedItem),
                        "data-cy": "lng-selector",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "cIcon-globe fs16",
                                "aria-hidden": true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "ph2 font-im gray800",
                                children: selectedItem
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "cIcon-icon_arrow_dropdown fs16",
                                "aria-hidden": true
                            })
                        ]
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "ph10 pt5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pb8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "visually-hidden",
                                children: i18n.t("Site Navigation")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "ttu font-im fs13 lh18 gray400 ls2 pb3",
                                children: i18n.t("My Account")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "dg gg2 gafc wfc",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "focus-bsDarkBlue3 font-isb fs14 lh12 pv3 ph4 bg-gray800 br8 white",
                                        href: (0,getRedirectUrl/* getLoginRedirectUrl */.yv)(),
                                        onClick: ()=>trackNavLinkClick("Account", "Menu", "Log In", "My Account"),
                                        children: i18n.t("Log In")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "focus-bsDarkBlue3 font-isb fs14 lh12 pv3 ph4 gray800 br8",
                                        href: (0,getRedirectUrl/* getSignupRedirectUrl */.sj)(),
                                        style: {
                                            backgroundColor: "".concat(palette.gray800, "10")
                                        },
                                        onClick: ()=>trackNavLinkClick("Account", "Menu", "Sign Up Free", "My Account"),
                                        children: i18n.t("Sign Up Free")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                        "aria-label": i18n.t("Services"),
                        children: [
                            drawer.accordion.map((param, i)=>{
                                let { title , sub , id , label  } = param;
                                const isOpen = openIndexes.includes(i);
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "pb4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "cp focus-bsDarkBlue3 t-150 wfc gray800 brdn bg-white db ph2",
                                            "aria-controls": id,
                                            "aria-expanded": isOpen,
                                            tabIndex: 0,
                                            onClick: toggleOpenIndex(i),
                                            "data-cy": "drawer-parent-link",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "cIcon-plus2 fs14 dib pos-r t-tf100 tal ".concat(isOpen ? "rotate45" : ""),
                                                        "aria-hidden": true
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "fs20 lh14 font-cm ml3",
                                                        children: title
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                                            in: isOpen,
                                            unmountOnExit: true,
                                            duration: 100,
                                            timeout: 0,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                className: "ml2 pt2 ph2",
                                                id: id,
                                                "data-cy": "drawer-".concat(id),
                                                children: sub.map((link)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Nav_DrawerNavAnchor, {
                                                        ...link,
                                                        closeDrawer: closeDrawer,
                                                        // @ts-expect-error TS2345: Argument of type 'NavLabel | undefined' is not assignable to parameter of type 'NavLabel'.
                                                        onClick: ()=>trackNavLinkClick(label, "Menu", link.title, title)
                                                    }, link.title))
                                            })
                                        })
                                    ]
                                }, i);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: _constants/* v5Pages.locations */.Td.locations,
                                onClick: ()=>trackNavLinkClick("Locations", "Menu", "Find a Location", "Find a Location"),
                                className: "focus-bsDarkBlue3 db",
                                "data-cy": "drawer-parent-link",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "df aic ml2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "cIcon-bigRightArrow dib fs14 mr3 gray800",
                                            "aria-hidden": true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "fs20 lh14 font-cm gray800",
                                            children: i18n.t("Find a Location")
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pt10 pb12 maxw26",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "ttu font-im ls2 fs13 gray400 pb4",
                                children: i18n.t("More")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "dg gafr font-cm gtc2fr cg12",
                                    children: drawer.footer.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: item.href,
                                                className: "focus-bsDarkBlue3 wfc mr8 wsnw font-im fs14 lh22 gray800",
                                                onClick: ()=>trackNavLinkClick("Company", "Menu", item.title, "More"),
                                                "data-cy": "footer-link",
                                                children: item.title
                                            })
                                        }, item.title))
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "df fs20",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "pr10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: _constants/* instagramUrl */.TG,
                                        style: {
                                            color: "".concat(palette.gray800, "50")
                                        },
                                        className: "cIcon-instagram",
                                        onClick: ()=>trackNavLinkClick("Company", "Menu", "Instagram", ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "visually-hidden",
                                            children: "Instagram"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "pr10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: _constants/* twitterUrl */.x_,
                                        style: {
                                            color: "".concat(palette.gray800, "50")
                                        },
                                        className: "cIcon-twitter",
                                        onClick: ()=>trackNavLinkClick("Company", "Menu", "Twitter", ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "visually-hidden",
                                            children: "Twitter"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "pr10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: _constants/* facebookUrl */.cm,
                                        style: {
                                            color: "".concat(palette.gray800, "50")
                                        },
                                        className: "cIcon-facebook",
                                        onClick: ()=>trackNavLinkClick("Company", "Menu", "Facebook", ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "visually-hidden",
                                            children: "Facebook"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "pr10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: _constants/* linkedInUrl */.Gj,
                                        style: {
                                            color: "".concat(palette.gray800, "50")
                                        },
                                        className: "cIcon-linkedin",
                                        onClick: ()=>trackNavLinkClick("Company", "Menu", "LinkedIn", ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "visually-hidden",
                                            children: "LinkedIn"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Nav_Drawer = (Drawer);

// EXTERNAL MODULE: ./src/components/v5/Nav/useNavState.ts
var useNavState = __webpack_require__(13284);
;// CONCATENATED MODULE: ./src/components/v5/Nav/Nav.tsx
/* eslint-disable react/no-invalid-html-attribute */ 






















const Nav = (param)=>{
    let { theme =useNavState/* NavTheme.DEFAULT */.Xm.DEFAULT , startTransparent =true  } = param;
    const { isMobile  } = (0,store/* useTypedSelector */.ix)((param)=>{
        let { config  } = param;
        return {
            ...config
        };
    });
    const isXs = (0,useMediaQuery/* default */.Z)("xs");
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { pathname  } = (0,router.useRouter)();
    // @ts-expect-error TS2345: Argument of type 'null' is not assignable to parameter of type 'number | (() => number)'.
    const [openMenuIndex, setOpenMenuIndex] = (0,react.useState)(null);
    // @ts-expect-error TS2345: Argument of type 'null' is not assignable to parameter of type 'number | (() => number)'.
    const [hoveredIndex, setHoveredIndex] = (0,react.useState)(null);
    const [timeoutId, setTimeoutId] = (0,react.useState)(null); // Used to prevent a react bug with onBlur
    const [isNavHovered, setIsNavHovered] = (0,react.useState)(false);
    const config = useHeaderConstants();
    const { center  } = config.config;
    const styleState = (0,useNavState/* useNavState */.b9)(startTransparent, theme, isNavHovered);
    const { showBookingButton , activeStyle: { transition , transitionClass , ...activeStyle } , showNav  } = styleState;
    const toggleHoveredIndex = (0,react.useCallback)((number, shouldToggleMenu)=>()=>{
            if (Number.isInteger(number)) {
                // @ts-expect-error TS2345: Argument of type 'number | undefined' is not assignable to parameter of type 'SetStateAction<number>'.
                setHoveredIndex(number);
            } else {
                // @ts-expect-error TS2345: Argument of type 'null' is not assignable to parameter of type 'SetStateAction<number>'.
                setHoveredIndex(null);
            }
            if (shouldToggleMenu) {
                if (Number.isInteger(number) && shouldToggleMenu === "on") {
                    // @ts-expect-error TS2345: Argument of type 'number | undefined' is not assignable to parameter of type 'SetStateAction<number>'.
                    setOpenMenuIndex(number);
                } else if (shouldToggleMenu === "off") {
                    // @ts-expect-error TS2345: Argument of type 'null' is not assignable to parameter of type 'SetStateAction<number>'.
                    setOpenMenuIndex(null);
                } else if (shouldToggleMenu === "opposite") {
                    const val = openMenuIndex === number ? null : number;
                    // @ts-expect-error TS2345: Argument of type 'number | null | undefined' is not assignable to parameter of type 'SetStateAction<number>'.
                    setOpenMenuIndex(val);
                }
            }
        }, [
        openMenuIndex
    ]);
    const renderLangSelectorButton = (0,react.useCallback)((param)=>/*#__PURE__*/ {
        let { selectedItem , ...rest } = param;
        return (0,jsx_runtime.jsxs)("button", {
            ...rest,
            className: "br8 ph4 pv3 brdn fs14 lh1 cp bg-transparent aria-focus ".concat(transitionClass),
            onClick: ()=>trackNavLinkClick("Languages", "Navbar", selectedItem, ""),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: {
                        color: activeStyle.anchorColor
                    },
                    className: "cIcon-globe fs16 ".concat(transitionClass),
                    "aria-hidden": true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "visually-hidden",
                    children: i18n.t("Language: {{language}}", {
                        language: selectedItem
                    })
                })
            ]
        });
    }, [
        activeStyle.anchorColor,
        i18n.lang,
        transitionClass
    ]);
    const { state: dialog , Dialog  } = (0,useDialog/* useDialog */.R)({
        title: i18n.t("Menu"),
        isFullWidth: true,
        isTitleHidden: true,
        blurBackdrop: false
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
        in: !!_constants/* isCI */.yg || showNav,
        timeout: transition,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                backgroundColor: activeStyle.backgroundColor,
                maxWidth: 1900,
                zIndex: 100,
                boxShadow: activeStyle.boxShadow
            },
            className: "pos-f w100p brdb brd-transparent ".concat(transitionClass),
            onMouseEnter: ()=>isMobile ? null : setIsNavHovered(true),
            onMouseLeave: ()=>isMobile ? null : setIsNavHovered(false),
            onFocus: ()=>isMobile ? null : setIsNavHovered(true),
            onBlur: ()=>isMobile ? null : setIsNavHovered(false),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(v5_DynamicBanner, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "df jcsb df aic pl8 pr4 ph3-lg ph4-xs minh20 minh14-sm d",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/",
                            rel: "home",
                            className: "pos-r zIndex1",
                            style: {
                                flexShrink: 0
                            },
                            "data-cy": "carbon-logo",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "contrast-saturate t-".concat(transition / 2),
                                height: 26,
                                width: isMobile ? 26 : 186,
                                src: (0,useV5ImgSrc/* useV5ImgSrc */.eH)(activeStyle.carbonLogoSrc, true),
                                alt: "Carbon Health",
                                style: {
                                    filter: activeStyle.logoFilter || null
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                            "aria-label": i18n.t("Site Navigation"),
                            className: "fx maxw52 dn-f-md",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "df jcc fx fw aic pos-r zIndex2 jcse",
                                children: center.map((item, i)=>{
                                    const isHovered = i === hoveredIndex;
                                    const { anchorColor  } = activeStyle;
                                    const titleColor = Number.isInteger(hoveredIndex) && !isHovered ? (0,transparent/* transparent */.Z)(anchorColor, 75) : anchorColor;
                                    // Is the user on the url of the current menu item
                                    const isActive = hasDropDownMenu(item) ? false : item.href === pathname && openMenuIndex === null && hoveredIndex === null;
                                    const handleFocus = ()=>{
                                        // @ts-expect-error TS2769: No overload matches this call.
                                        clearTimeout(timeoutId);
                                        toggleHoveredIndex(i)();
                                    };
                                    const isOpenAndHovered = openMenuIndex === i && isHovered;
                                    const handleClick = (value)=>trackNavLinkClick(item.label, "Navbar", value, item.title);
                                    const hoverEffects = {
                                        onMouseEnter: toggleHoveredIndex(i, "on"),
                                        onFocus: handleFocus,
                                        // @ts-expect-error TS2345: Argument of type 'null' is not assignable to parameter of type 'number | undefined'.
                                        onMouseLeave: toggleHoveredIndex(null, "off"),
                                        onBlur: ()=>{
                                            setTimeoutId(// @ts-expect-error TS2345: Argument of type 'Timeout' is not assignable to parameter of type 'SetStateAction<null>'.
                                            setTimeout(()=>{
                                                // @ts-expect-error TS2345: Argument of type 'null' is not assignable to parameter of type 'number | undefined'.
                                                toggleHoveredIndex(null, "off")();
                                            }));
                                        },
                                        // @ts-expect-error TS2345: Argument of type 'null' is not assignable to parameter of type 'number | undefined'.
                                        onKeyDown: (0,useEscape/* onKeyHandler */.PS)("Escape", toggleHoveredIndex(null, "off"))
                                    };
                                    const circle = /*#__PURE__*/ (0,jsx_runtime.jsx)(NavCircle, {
                                        className: "w100p pos-a left0 right0",
                                        style: {
                                            bottom: "1rem"
                                        },
                                        isHovered: isHovered || isActive
                                    });
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "df fdc aic p0 h20",
                                        ...hoverEffects,
                                        "data-cy": "menu-parent",
                                        children: hasDropDownMenu(item) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "wsnw pv8 df aic jcc font-cm fs16 lh1 h100p w100p focus-bsDarkBlue3 ",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                            className: "br8 pos-r bg-inherit brdn font-cm p0 m0 cp ".concat(transitionClass),
                                                            onClick: toggleHoveredIndex(i, "opposite"),
                                                            style: {
                                                                color: titleColor
                                                            },
                                                            "aria-expanded": isOpenAndHovered,
                                                            "aria-controls": "".concat(item.id, "-dropdown"),
                                                            children: [
                                                                item.title,
                                                                circle
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "cIcon-icon_arrow_dropdown ml1 ".concat(transitionClass),
                                                            style: {
                                                                color: titleColor
                                                            },
                                                            "aria-hidden": true
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                                                    in: isOpenAndHovered,
                                                    unmountOnExit: true,
                                                    duration: transition,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_module/* FocusScope */.MT, {
                                                        restoreFocus: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownMenuItem, {
                                                            item: item,
                                                            onFocus: handleFocus,
                                                            onClick: (value)=>handleClick(value)
                                                        })
                                                    })
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: item.href,
                                            legacyBehavior: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "wsnw cp focus-bsDarkBlue3 fs16 lh1 font-cm pv8",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    className: "br8 pos-r ".concat(transitionClass),
                                                    style: {
                                                        color: titleColor
                                                    },
                                                    onClick: ()=>handleClick(item.title),
                                                    href: item.href,
                                                    "data-text": item.title,
                                                    children: [
                                                        item.title,
                                                        circle
                                                    ]
                                                })
                                            })
                                        })
                                    }, item.title);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "dg aic gg2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                                    in: showBookingButton,
                                    duration: 100,
                                    unmountOnExit: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "dn db-lg",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "white bg-darkGreen hover-white pv3 ph4 br8 font-im fs14 lh12",
                                            href: "#widget",
                                            onClick: ()=>trackNavLinkClick("Booking", "Navbar", isXs ? i18n.t("Book") : i18n.t("Book Appointment"), isXs ? "Book" : "Book Appointment"),
                                            children: isXs ? i18n.t("Book") : i18n.t("Book Appointment")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Login, {
                                        isNavHovered: isNavHovered,
                                        backgroundColor: activeStyle.buttonBackground,
                                        isPrimary: !showBookingButton,
                                        onClick: ()=>trackNavLinkClick("Account", "Navbar", "Log In", "Log In"),
                                        children: i18n.t("Log In")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "dn-lg",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLanguageSelector, {
                                        anchorDirection: "bottom right",
                                        renderButton: renderLangSelectorButton
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "dn db-lg",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "gray800 brdn font-im fs14 lh12 br8 ph4 pv3 cp aria-focus ".concat(transitionClass),
                                            style: {
                                                backgroundColor: activeStyle.buttonBackground
                                            },
                                            "aria-label": i18n.t("Open Menu"),
                                            onClick: ()=>{
                                                dialog.open();
                                                trackNavLinkClick("Menu", "Navbar", "Menu", "Menu");
                                            },
                                            "data-cy": "menu",
                                            children: i18n.t("Menu")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav_Drawer, {
                                                closeDrawer: dialog.close
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
const Login = (param)=>{
    let { children , isNavHovered , backgroundColor , isPrimary , onClick  } = param;
    const [isHovered, setIsHovered] = (0,react.useState)(false);
    const isMd = (0,useMediaQuery/* default */.Z)("md");
    const color = isNavHovered ? isHovered ? (0,transparent/* transparent */.Z)(palette.gray800, 20) : (0,transparent/* transparent */.Z)(palette.gray800, 10) : backgroundColor;
    const sharedProps = {
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onClick,
        href: (0,getRedirectUrl/* getLoginRedirectUrl */.yv)()
    };
    if (isPrimary && isMd) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: "wsnw ph4 pv3 brdn br8 font-im fs14 lh12 white hover-white bg-gray800 t-300",
            ...sharedProps,
            children: children
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        className: "wsnw ph4 pv3 brdn br8 font-im fs14 lh12 gray800 hover-gray800 hover-bg-gray200 t-300",
        style: {
            backgroundColor: color
        },
        ...sharedProps,
        children: children
    });
};
const NavCircle = (param)=>/*#__PURE__*/ {
    let { isHovered , className ="" , style  } = param;
    return (0,jsx_runtime.jsx)("span", {
        className: "ma minh4 df jcc aic ".concat(className),
        style: style,
        "aria-hidden": true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            height: 6,
            width: 6,
            className: "t-150",
            style: {
                visibility: isHovered ? "visible" : "hidden",
                opacity: isHovered ? 1 : 0
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "50%",
                cy: "50%",
                r: "45%",
                strokeWidth: "3",
                fill: palette.darkerMint
            })
        })
    });
};
/* harmony default export */ var Nav_Nav = (/*#__PURE__*/react.memo(Nav));

// EXTERNAL MODULE: ./src/components/v5/SkipLink.tsx
var SkipLink = __webpack_require__(85527);
;// CONCATENATED MODULE: ./src/components/v5/SkipLinkBar.tsx



const SkipLinkBar = (param)=>{
    let { skipLinks  } = param;
    const [focused, setFocused] = (0,react.useState)(false);
    const style = {
        zIndex: 101,
        ...focused ? {} : {
            clip: "rect(0 0 0 0)",
            clipPath: "inset(50%)",
            height: 1,
            overflow: "hidden",
            width: 1
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "skip-links",
        className: "pos-f dg gg2 zIndex2 p1",
        onFocusCapture: ()=>{
            setFocused(true);
        },
        onBlur: ()=>{
            setFocused(false);
        },
        style: style,
        children: skipLinks.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SkipLink/* default */.Z, {
                item: item
            }, "skip-link-".concat(item.text)))
    });
};
/* harmony default export */ var v5_SkipLinkBar = (SkipLinkBar);

;// CONCATENATED MODULE: ./src/components/v5/Layout.tsx
/* eslint-disable react/no-invalid-html-attribute */ 

























const defaultPageImage = "default-page-image";
const Layout = (param)=>{
    let { children , style , pageTitle , pageDescription , className ="" , wrapClasses ="ovf-x-hidden" , pageImage =defaultPageImage , absolutePageImage , noHeader , noFooter , navTheme , navStartTransparent , noIndex , blockChatWidget , ogAlt , schemas , pageImageExt ="jpg" , skipLinks =[] , minimalFooter  } = param;
    const { asPath , pathname , query  } = (0,router.useRouter)();
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const ogAltText = ogAlt || i18n.t("Carbon Health is making good health accessible to everyone");
    const { host =urls/* CarbonEnvs.prod */.R.prod , referer , talkdeskFlowId , covidModal  } = (0,store/* useTypedSelector */.ix)((param)=>{
        let { config  } = param;
        return config;
    });
    const newHost = "".concat(host.protocol, "://").concat(host.domain);
    const { showCovidModal , showTravelContent , covidLocationId  } = covidModal || {};
    const { showTravelModal , modalInner , modalImage  } = useCovidTravelModalConstants(referer, pathname);
    const [showModal, setShowModal] = (0,react.useState)(showTravelModal);
    const [ready, setRready] = (0,react.useState)(false);
    const rootUrl = newHost;
    const closeModal = ()=>{
        setShowModal(false);
    };
    (0,useEscape/* default */.ZP)(closeModal);
    const bannerImage = absolutePageImage || "".concat(rootUrl, "/static/img/_common/og_image/").concat(pageImage, ".").concat(pageImageExt);
    const canonical = getCanonicalLink(asPath);
    const title = pageTitle || i18n.t("Carbon Health | Modern Primary & Urgent Care");
    const desc = (pageDescription || "").replace(/['"]+/g, "") || i18n.t("Carbon Health Provides Smart, hassle-free Primary & Urgent Care. Book same day Adult & Pediatric appointments instantly.");
    const scssColorVarMap = Object.keys(palette).sort().reduce((acc, next)=>({
            ...acc,
            // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'typeof import("/Users/goksel/Sites/carbon-website-next/node_modules/@c10h/colors/types/palette")'.
            ["--".concat(next)]: palette[next]
        }), {});
    const breadCrumb = {
        // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ "/": string; "/primary-care": string; "/urgent-care": string; "/locations": string; "/locations2": string; "/locations/[slug]": string; "/insurance-pricing": string; "/about-us": string; "/partners": string; ... 18 more ...; "/uc-hastings": string; }'.
        name: _constants/* v5PagesTitles */.Jl[pathname] || pathname.replace("/", "") || "",
        item: newHost + asPath
    };
    const cleanedAsPath = asPath.replace("/", "");
    const isWidgetAllowedAsPaths = _constants/* widgetAllowedAsPaths.includes */.lw.includes(cleanedAsPath) || pathname === _constants/* v5Pages.clinicDetails */.Td.clinicDetails;
    const shouldNotIndex = noIndex || host.subdomain;
    (0,react.useEffect)(()=>{
        setRready(true);
    }, []);
    const a11ySkipLinks = [
        {
            targetId: "main",
            text: i18n.t("Skip to Main Content")
        },
        ...skipLinks
    ].distinctBy("targetId");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "layout",
        className: "w100p ma bg-white wspl ".concat(className),
        style: {
            ...style,
            maxWidth: "118.75rem",
            "--defaultColor": palette.mint,
            "--pcColor": palette.blue,
            "--ucColor": palette.yellow,
            ...scssColorVarMap
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        id: "title",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no, user-scalable=yes, viewport-fit=cover"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        httpEquiv: "X-UA-Compatible",
                        content: "IE=edge"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "apple-itunes-app",
                        content: "app-id=1152807572"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "google-play-app",
                        content: "app-id=com.carbonhealth.patient.prod"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: desc
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: canonical
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: bannerImage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:alt",
                        content: ogAltText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:site_name",
                        content: "Carbon Health"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image:alt",
                        content: ogAltText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: desc
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: bannerImage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "fb:app_id",
                        content: "175947640371537"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:site",
                        content: "@CarbonHealth"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "image_src",
                        href: bannerImage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: desc
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: canonical
                    }),
                    languages.languages.map((param)=>/*#__PURE__*/ {
                        let { code  } = param;
                        return (0,jsx_runtime.jsx)("link", {
                            rel: "alternate",
                            hrefLang: code,
                            href: getLinkWithLocale(asPath, code)
                        }, code);
                    }),
                    shouldNotIndex && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "noindex"
                    }),
                    schemas && schemas.map((schema, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                            type: "application/ld+json",
                            dangerouslySetInnerHTML: {
                                __html: schema
                            }
                        }, "schema-".concat(i))),
                    (()=>{
                        if (pathname === _constants/* v5Pages.serviceMap */.Td.serviceMap && query.state) {
                            const { group , state , city  } = query;
                            const serviceRootUrl = newHost + asPath.replace("/".concat(state), "").replace("/".concat(city), "").replace("//", "/");
                            const cityItem = ',{\n                        "@type": "ListItem",\n                        "position": 3,\n                        "name": "'.concat((0,Carbon/* unslugify */.BW)((0,ignoreArrays/* ignoreArrays */.F)(city) || ""), '",\n                        "item": "').concat(breadCrumb.item, '"\n                      }');
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                                type: "application/ld+json",
                                dangerouslySetInnerHTML: {
                                    __html: '\n                     [{\n                      "@context": "https://schema.org",\n                      "@type": "BreadcrumbList",\n                      "itemListElement": [{\n                        "@type": "ListItem",\n                        "position": 1,\n                        "name": "'.concat((0,Carbon/* unslugify */.BW)((0,ignoreArrays/* ignoreArrays */.F)(group) || ""), '",\n                        "item": "').concat(serviceRootUrl, '"\n                      },{\n                        "@type": "ListItem",\n                        "position": 2,\n                        "name": "').concat((0,Carbon/* unslugify */.BW)((0,ignoreArrays/* ignoreArrays */.F)(state) || ""), '",\n                        "item": "').concat(serviceRootUrl, "/").concat(state, '"\n                      }').concat(city ? cityItem : "", "]\n                    }]\n              ")
                                }
                            });
                        }
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                            type: "application/ld+json",
                            dangerouslySetInnerHTML: {
                                __html: '\n                   [{\n                      "@context": "https://schema.org",\n                      "@type": "BreadcrumbList",\n                      "itemListElement": [{\n                        "@type": "ListItem",\n                        "position": 1,\n                        "name": "'.concat(breadCrumb.name, '",\n                        "item": "').concat(breadCrumb.item, '"\n                      }]\n                    }]\n              ')
                            }
                        });
                    })(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "thumbnail",
                        content: bannerImage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("noscript", {
                        dangerouslySetInnerHTML: {
                            __html: '\n              <!--\n            <PageMap>\n              <DataObject type="thumbnail">\n                <Attribute name="src" value="'.concat(bannerImage, '"/>\n                <Attribute name="width" value="120"/>\n                <Attribute name="height" value="63"/>\n              </DataObject>\n            </PageMap>\n          -->\n              ')
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid min-h-screen relative",
                style: {
                    gridTemplateRows: "auto 1fr auto"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                        style: {
                            zIndex: zIndexMap/* highZIndexMap.NAV_BAR */.q.NAV_BAR
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(v5_SkipLinkBar, {
                                skipLinks: a11ySkipLinks
                            }),
                            !noHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav_Nav, {
                                theme: navTheme,
                                startTransparent: !_constants/* isCI */.yg && navStartTransparent
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                        className: wrapClasses + " relative",
                        id: "main",
                        style: {
                            ...noHeader ? {
                                paddingTop: 0
                            } : {},
                            maxWidth: "min(118.75rem, 100vw)"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: bannerSpacer
                            }),
                            children
                        ]
                    }),
                    !EXCLUDED_PAGES.includes(pathname) && /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyComp/* LazyComp */.P, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationExplorerContainer, {})
                    }),
                    !noFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Footer, {
                        minimal: minimalFooter
                    })
                ]
            }),
            ready && isWidgetAllowedAsPaths && !blockChatWidget && /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "/static/js/talkdesk.js?flowId=".concat(talkdeskFlowId),
                strategy: "lazyOnload",
                type: "text/javascript",
                id: "tdChatWidgetScript"
            }),
            ready && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                className: "maxw35",
                active: showModal,
                onClickOutside: closeModal,
                img: modalImage,
                children: modalInner
            }),
            showCovidModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDialog/* default */.Z, {
                // @ts-expect-error TS2322: Type 'string | undefined' is not assignable to type 'string'.
                title: title,
                isDismissable: true,
                isTitleHidden: true,
                blurBackdrop: true,
                isFullWidth: false,
                zIndex: zIndexMap/* highZIndexMap.COVID_MODAL */.q.COVID_MODAL,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CovidTestModal/* default */.Z, {
                    showTravelContent,
                    covidLocationId
                })
            })
        ]
    });
};
/* harmony default export */ var v5_Layout = (Layout);


/***/ }),

/***/ 54206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ isBookingDisabled; }
/* harmony export */ });
/* harmony import */ var src_constants_locations__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43402);
/* harmony import */ var _constants_LocationConstants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74594);
/* harmony import */ var _utils_timeUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40248);



const isBookingDisabled = (id)=>{
    const isElCaminoAndAfterSep5 = src_constants_locations__WEBPACK_IMPORTED_MODULE_0__/* .elCaminoLocIds.includes */ .yX.includes(id) && (0,_utils_timeUtils__WEBPACK_IMPORTED_MODULE_2__/* .isInTimeRange */ .Si)(_constants_LocationConstants__WEBPACK_IMPORTED_MODULE_1__/* .elCaminoDisabledTime */ .UE);
    return isElCaminoAndAfterSep5;
};


/***/ }),

/***/ 85533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Locations_LocationDetailsCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/@c10h/colors/es/palette.js
var palette = __webpack_require__(45602);
// EXTERNAL MODULE: ./src/components/v5/V5Comp.tsx
var V5Comp = __webpack_require__(63575);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(21395);
// EXTERNAL MODULE: ./src/i18n.ts + 5 modules
var src_i18n = __webpack_require__(76361);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/components/_common/_constants.ts + 1 modules
var _constants = __webpack_require__(93932);
// EXTERNAL MODULE: ./src/utils/analytics.ts
var analytics = __webpack_require__(82546);
// EXTERNAL MODULE: ./src/components/v5/Circle.tsx
var Circle = __webpack_require__(43046);
// EXTERNAL MODULE: ./src/components/v5/Transitions/Fade.tsx
var Fade = __webpack_require__(64800);
// EXTERNAL MODULE: ./src/constants/specialtyIds.ts
var specialtyIds = __webpack_require__(93209);
;// CONCATENATED MODULE: ./src/hooks/useLocalSpecialtyConfigs.ts


const useLocalSpecialtyConfigs = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    return {
        [specialtyIds/* SpecialtyId.PRIMARY_CARE */.mg.PRIMARY_CARE]: {
            icon: "stethoscope-2"
        },
        [specialtyIds/* SpecialtyId.URGENT_CARE */.mg.URGENT_CARE]: {
            icon: "shield-cross"
        },
        [specialtyIds/* SpecialtyId.VIRTUAL_URGENT_CARE */.mg.VIRTUAL_URGENT_CARE]: {
            icon: "happy-phone-in-hand"
        },
        [specialtyIds/* SpecialtyId.VIRTUAL_PRIMARY_CARE */.mg.VIRTUAL_PRIMARY_CARE]: {
            icon: "happy-phone-in-hand"
        },
        [specialtyIds/* SpecialtyId.COVID_TESTING_MOBILE */.mg.COVID_TESTING_MOBILE]: {
            icon: "virus-molecule",
            nameOverride: i18n.t("COVID Testing")
        },
        [specialtyIds/* SpecialtyId.COVID_TRAVEL_CLEARANCE */.mg.COVID_TRAVEL_CLEARANCE]: {
            icon: "plane",
            nameOverride: i18n.t("COVID Travel Testing")
        }
    };
};
const useSpecialtyConfig = (specialtyId)=>// @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<SpecialtyId, LocalSpecialtyConfig>>'.
    useLocalSpecialtyConfigs()[specialtyId] || {
        icon: "stethoscope-2"
    };

// EXTERNAL MODULE: ./src/hooks/useReadableSlotTime.ts + 1 modules
var useReadableSlotTime = __webpack_require__(8764);
// EXTERNAL MODULE: ./src/components/v5/ReadableSlotTime.tsx
var ReadableSlotTime = __webpack_require__(566);
;// CONCATENATED MODULE: ./src/components/v5/Locations/SpecialtyAndTime.tsx










const SpecialtyAndTime = /*#__PURE__*/ react.memo((param)=>{
    let { location , specialty , boxMode , soonestSlots  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    // @ts-expect-error TS2532: Object is possibly 'undefined'.
    const isLoaded = !!soonestSlots[location.id];
    // @ts-expect-error TS2532: Object is possibly 'undefined'.
    const firstSlot = isLoaded && soonestSlots[location.id][specialty.id];
    const isPrimaryCare = specialty.id === specialtyIds/* SpecialtyId.PRIMARY_CARE */.mg.PRIMARY_CARE;
    const { nameOverride  } = useSpecialtyConfig(specialty.id);
    const showPrimaryCareWait = isPrimaryCare && isLoaded && !firstSlot;
    const time = (0,useReadableSlotTime/* useReadableSlotTime */.H5)(firstSlot);
    return boxMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-gray100 p3 br3 wfc por-r font-ir fs14 gray600 ls-3",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "df fdc wsnw",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "font-ib gray800 fs14",
                    children: nameOverride || specialty.name
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                    in: isLoaded,
                    timeout: 0,
                    unmountOnExit: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "df aic mt1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Circle/* default */.Z, {
                                diameter: 5,
                                color: showPrimaryCareWait || !firstSlot ? palette.red : palette.darkGreen,
                                className: "mr1"
                            }),
                            showPrimaryCareWait ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: i18n.t("One week wait")
                            }) : firstSlot ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadableSlotTime/* ReadableSlotTime */.n, {
                                    time: firstSlot,
                                    dateOnlyAfterTomorrow: true
                                })
                            }) : isLoaded ? i18n.t("Limited availability") : null
                        ]
                    })
                })
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "font-ir gray600 df aic wsnw fw ml2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "df aic pos-r",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Circle/* default */.Z, {
                        diameter: 5,
                        color: showPrimaryCareWait || !firstSlot && isLoaded ? palette.red : palette.darkGreen,
                        className: "mr1 pos-a",
                        style: {
                            left: -8
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-ib gray800 wsnw",
                        children: nameOverride || specialty.name
                    }),
                    isLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "fs10 mh1",
                        "aria-hidden": true,
                        children: "•"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                in: isLoaded,
                timeout: 0,
                unmountOnExit: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "df aic",
                    children: showPrimaryCareWait ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "wsnw",
                        children: i18n.t("One week wait")
                    }) : firstSlot ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "wsnw",
                        children: i18n.t("Next: {{time}}", {
                            time
                        })
                    }) : isLoaded ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "wsnw",
                        children: i18n.t("Limited availability")
                    }) : null
                })
            })
        ]
    });
});
SpecialtyAndTime.displayName = "SpecialtyAndTime";
/* harmony default export */ var Locations_SpecialtyAndTime = (SpecialtyAndTime);

;// CONCATENATED MODULE: ./src/components/v5/Locations/LocationDetailsCard.tsx









const LocationDetailsCard = (param)=>{
    let { location , timeString , timeBlock , isOpenNow , hideButton , isMapPopup , disableButton , specialtyBoxMode , soonestSlots , buttonText , condensed ="true"  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { pathname  } = (0,router.useRouter)();
    const { name , yelpRating , dist , specialties , address  } = location;
    // Will not matter for ClinicList in ListView/Map toggle experiment because button is hidden
    const btnProps = (0,react.useMemo)(()=>!disableButton ? {
            href: {
                pathname: _constants/* v5Pages.clinicDetails */.Td.clinicDetails,
                query: {
                    slug: location.slug
                }
            },
            link: true
        } : {
            type: "link",
            faux: true
        }, [
        disableButton,
        location.slug
    ]);
    const onClick = (0,react.useCallback)(()=>{
        // Will not fire for ClinicList in ListView/Map toggle experiment because button is hidden
        if (!disableButton) {
            analytics/* analytics.post */.c.post({
                category: "LocationDiscovery",
                action: "Clicked",
                label: "SelectClinic",
                extraData: {
                    locationId: location.id,
                    milesAway: location.dist,
                    openNow: isOpenNow,
                    isMapPopup,
                    source: pathname === _constants/* v5Pages.locations */.Td.locations ? "index" : "footer"
                }
            });
        }
    }, [
        disableButton,
        isMapPopup,
        isOpenNow,
        location.dist,
        location.id,
        pathname
    ]);
    const orderedSpecialties = specialties.vals().filter((s)=>!s.isVirtual).sortBy((s)=>s.sortIndex);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "fs14 zIndex1 bg-transparent",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "df fdc jcsb pos-r hide-scroll-bars",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mb2 lh12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "font-csb-f fw5-f mb1 ".concat(condensed ? "maxw18 maxw12-xs" : "", " fs18 minw18 minw0-xs font-isb"),
                            "data-cy": "location-name",
                            children: name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "font-isb",
                                children: [
                                    yelpRating && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cIcon-star darkYellow mr1",
                                                "aria-hidden": true
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "visually-hidden",
                                                children: i18n.t("Star Rating:")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: yelpRating
                                            }),
                                            dist > -1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "mh1",
                                                "aria-hidden": true,
                                                children: "\xb7"
                                            })
                                        ]
                                    }),
                                    timeBlock && /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        className: "font-isb ".concat(!isOpenNow ? "gray800-f" : "darkGreen-f mr1"),
                                        children: isOpenNow ? i18n.t("Open") : null
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "gray600 font-ir",
                                        children: timeString
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "gray600 font-ir minh8 ls-3 pb2 df fw maxw16-xs",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: address.firstLine
                                }),
                                dist > -1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mh1",
                                    "aria-hidden": true,
                                    children: "\xb7"
                                }),
                                dist > -1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: i18n.t("{{number}} mi away", {
                                        number: dist
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "df fdc ovf-x-a",
                    style: {
                        maxWidth: specialtyBoxMode ? "90vw" : "80vw"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "mb2 dg gg2 ".concat(specialtyBoxMode ? "gafc" : "gafr"),
                            children: [
                                orderedSpecialties.map((s)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Locations_SpecialtyAndTime, {
                                            location: location,
                                            specialty: s,
                                            boxMode: specialtyBoxMode,
                                            soonestSlots: soonestSlots
                                        })
                                    }, location.id + s.id)),
                                specialtyBoxMode && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "minw2",
                                    "aria-hidden": true
                                })
                            ]
                        }),
                        !hideButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                            fontSize: 0.75,
                            className: "mt2 mb1 focus-bsDarkBlue3-hug",
                            ...btnProps,
                            onClick: onClick,
                            // @ts-expect-error TS2322: Type 'string | null' is not assignable to type 'string | undefined'.
                            color: isMapPopup ? palette.gray800 : null,
                            // @ts-expect-error TS2322: Type 'string | null' is not assignable to type 'string | undefined'.
                            bg: isMapPopup ? palette.gray100 : null,
                            // @ts-expect-error TS2322: Type 'string | null' is not assignable to type 'string | undefined'.
                            hoverBg: isMapPopup ? palette.gray100 : null,
                            "aria-label": i18n.t("Select Clinic: {{location}}", {
                                location: location.name
                            }),
                            children: buttonText || i18n.t("Select Clinic")
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Locations_LocationDetailsCard = (LocationDetailsCard);


/***/ }),

/***/ 50496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _c10h_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45602);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var _utils_timeUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40248);
/* harmony import */ var _V5Comp__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63575);





const Notice = (param)=>{
    let { type ="warning" , text , href , onCtaClick , btnText , subtext , className , textClasses , btnProps , icon , startTime =Date.now() , endTime , ignoreRange , ...props } = param;
    const modes = {
        success: {
            backgroundColor: _c10h_colors__WEBPACK_IMPORTED_MODULE_4__.lighterGreen,
            icon: "info"
        },
        info: {
            backgroundColor: _c10h_colors__WEBPACK_IMPORTED_MODULE_4__.blue + 77,
            icon: "info"
        },
        warning: {
            backgroundColor: _c10h_colors__WEBPACK_IMPORTED_MODULE_4__.lightYellow,
            icon: "warning"
        },
        error: {
            backgroundColor: _c10h_colors__WEBPACK_IMPORTED_MODULE_4__.red + 70,
            icon: "warning"
        }
    };
    const buttonProps = {
        ...btnProps || {},
        ...onCtaClick ? {
            onClick: onCtaClick
        } : {},
        ...href ? {
            href
        } : {}
    };
    const showButton = Boolean(href || onCtaClick);
    return !text && !subtext || !ignoreRange && !(0,_utils_timeUtils__WEBPACK_IMPORTED_MODULE_2__/* .isInTimeRange */ .Si)(startTime, endTime) ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "p3 br5 font-ir fs14 df jcsb aic fdc-xs ".concat(className || ""),
        ...props,
        style: {
            backgroundColor: modes[type].backgroundColor,
            width: showButton ? "100%" : "fit-content"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "df aic pr2 mb2-xs",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "mr4 fs30 cIcon-".concat(icon || modes[type].icon),
                        "aria-hidden": true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: textClasses,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                className: "font-ib db lh16",
                                children: text
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "lh14 db",
                                children: subtext
                            })
                        ]
                    })
                ]
            }),
            showButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_V5Comp__WEBPACK_IMPORTED_MODULE_3__/* .Btn */ .un, {
                bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_4__.gray800 + 10,
                hoverBg: _c10h_colors__WEBPACK_IMPORTED_MODULE_4__.gray800 + 5,
                color: _c10h_colors__WEBPACK_IMPORTED_MODULE_4__.gray800,
                fontSize: 0.75,
                ...buttonProps,
                children: btnText
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Notice);


/***/ }),

/***/ 27591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _c10h_colors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45602);
/* harmony import */ var ni18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76361);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32466);
/* harmony import */ var src_useV5ImgSrc__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52299);
/* harmony import */ var _utils_transparent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74355);
/* harmony import */ var _utils_zIndexMap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45812);







const Modal = (param)=>{
    let { className , style , active , img , children , onClickOutside , innerClasses , shouldAutoFocus , closeFocusRef , closeButtonStyle ={}  } = param;
    const i18n = (0,ni18n__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)();
    const closeRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const lastItemRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const imgSrc = (0,src_useV5ImgSrc__WEBPACK_IMPORTED_MODULE_3__/* .useV5ImgSrc */ .eH)(img || "");
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (shouldAutoFocus && closeRef.current) {
            // @ts-expect-error TS2339: Property 'focus' does not exist on type 'never'.
            closeRef.current.focus();
        }
    }, [
        active
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        var _window_getComputedStyle, _window_getComputedStyle1;
        const originalBodyStyle = (_window_getComputedStyle = window.getComputedStyle(document.body)) === null || _window_getComputedStyle === void 0 ? void 0 : _window_getComputedStyle.overflow;
        const originalHtmlStyle = (_window_getComputedStyle1 = window.getComputedStyle(document.documentElement)) === null || _window_getComputedStyle1 === void 0 ? void 0 : _window_getComputedStyle1.overflow;
        if (active) {
            document.body.style.overflow = "hidden";
            document.documentElement.style.overflow = "hidden";
        }
        return ()=>{
            document.body.style.overflow = originalBodyStyle;
            document.documentElement.style.overflow = originalHtmlStyle;
        };
    }, [
        active
    ]);
    // Passes the close ref to children for containing the tab order to the modal
    const childrenAsArray = react__WEBPACK_IMPORTED_MODULE_2__.Children.toArray(children);
    const childElements = childrenAsArray.map((child)=>typeof child === "string" || typeof child === "number" ? child : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.cloneElement(child, {
            closeRef,
            lastItemRef
        }));
    // @ts-expect-error TS7006: Parameter 'e' implicitly has an 'any' type.
    const keyDownHandler = (e)=>{
        if (e.shiftKey && e.key === "Tab" && lastItemRef.current) {
            // @ts-expect-error TS2339: Property 'focus' does not exist on type 'never'.
            lastItemRef.current.focus();
        }
        if (e.key === "Enter") {
            onClickOutside();
            // @ts-expect-error TS2532: Object is possibly 'undefined'.
            if (closeFocusRef.current) {
                // @ts-expect-error TS2532: Object is possibly 'undefined'.
                closeFocusRef.current.focus();
            }
        }
    };
    return active ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w100p h100p top0 left0 tac df fdc aic jcc pos-f",
        style: {
            verticalAlign: "middle",
            backgroundColor: (0,_utils_transparent__WEBPACK_IMPORTED_MODULE_4__/* .transparent */ .Z)(_c10h_colors__WEBPACK_IMPORTED_MODULE_6__.gray800, 85),
            zIndex: _utils_zIndexMap__WEBPACK_IMPORTED_MODULE_5__/* .highZIndexMap.NAV_BAR */ .q.NAV_BAR
        },
        onClick: onClickOutside,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            role: "dialog",
            className: "pos-r br5 bg-white gray800 ".concat(className || ""),
            onClick: (e)=>e.stopPropagation(),
            onKeyDown: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    ref: closeRef,
                    className: "gray800 df jcc aic pos-a-f fs14 br50 p2 cp zIndex1 focus-bsDarkBlue3",
                    role: "button",
                    tabIndex: 0,
                    style: {
                        height: 37,
                        width: 37,
                        right: 10,
                        top: 10,
                        backgroundColor: "rgba(0, 0, 0, 0.05)",
                        ...closeButtonStyle
                    },
                    onClick: onClickOutside,
                    onKeyDown: keyDownHandler,
                    "aria-label": i18n.t("Close modal"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "cIcon-close"
                    })
                }),
                img && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: imgSrc,
                    alt: img,
                    style: {
                        borderRadius: "20px 20px 0 0",
                        bottom: 1
                    },
                    className: "pos-r"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "p10 p8-md p4-xs ".concat(innerClasses || ""),
                    style: {
                        ...style || {}
                    },
                    children: childElements
                })
            ]
        })
    }) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (Modal);


/***/ }),

/***/ 13284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Xm": function() { return /* binding */ NavTheme; },
/* harmony export */   "b9": function() { return /* binding */ useNavState; }
/* harmony export */ });
/* unused harmony exports useHasBeenScrolled, getBackgroundColor, getAnchorColor, LogoFilter, getNavStyles */
/* harmony import */ var _c10h_colors__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45602);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21395);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var _constants_locations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43402);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40367);
/* harmony import */ var _useScroll__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31218);
/* harmony import */ var _utils_isDeepEqual__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55797);
/* harmony import */ var _utils_transparent__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74355);
/* harmony import */ var _common_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93932);
/* harmony import */ var _Location_isBookingDisabled__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(54206);










const useHasBeenScrolled = (y)=>{
    const [hasBeenScrolled, setHasBeenScrolled] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!hasBeenScrolled) {
            setHasBeenScrolled(y > 0);
        }
    }, [
        y
    ]);
    return hasBeenScrolled;
};
const pathHasElCaminoSlug = (asPath)=>_constants_locations__WEBPACK_IMPORTED_MODULE_2__/* .elCaminoLocSlugs.some */ .h7.some((slug)=>asPath.includes(slug)) && (0,_Location_isBookingDisabled__WEBPACK_IMPORTED_MODULE_8__/* .isBookingDisabled */ .l)(_constants_locations__WEBPACK_IMPORTED_MODULE_2__/* .LocationId.EL_CAMINO_CUPERTINO */ .zI.EL_CAMINO_CUPERTINO);
const checkIfShouldShowBookingButton = (hasBeenScrolled, asPath, pathname, isMobile)=>{
    const isLocationPage = pathname === _common_constants__WEBPACK_IMPORTED_MODULE_7__/* .v5Pages.clinicDetails */ .Td.clinicDetails;
    return hasBeenScrolled && isLocationPage && isMobile && !pathHasElCaminoSlug(asPath);
};
const useShouldShowBookingButton = (y)=>{
    const [showBookingButton, setShowBookingButton] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { asPath , pathname  } = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    const { isMobile  } = (0,_store__WEBPACK_IMPORTED_MODULE_3__/* .useTypedSelector */ .ix)((state)=>state.config);
    const hasBeenScrolled = useHasBeenScrolled(y);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setShowBookingButton(// @ts-expect-error TS2345: Argument of type 'boolean | undefined' is not assignable to parameter of type 'boolean'.
        checkIfShouldShowBookingButton(hasBeenScrolled, asPath, pathname, isMobile));
    }, [
        hasBeenScrolled,
        asPath,
        pathname,
        isMobile
    ]);
    return showBookingButton;
};
const THRESHOLD = -5; // scroll value when nav will disappear
const OFFSET = 30; // subtracted from threshold to get value when theme changes to default
var NavTheme;
(function(NavTheme) {
    NavTheme["LIGHT"] = "light";
    NavTheme["BLACK"] = "black";
    NavTheme["DEFAULT"] = "default";
})(NavTheme || (NavTheme = {}));
const getBackgroundColor = (startTransparent, isAboveThreshold, isNavHovered)=>startTransparent && !isNavHovered && isAboveThreshold ? "transparent" : "#fff";
const getAnchorColor = (themeColor, backgroundColor)=>{
    switch(backgroundColor){
        case "transparent":
            return themeColor;
        case "#fff":
            return _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.gray800;
        default:
            return _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.gray800;
    }
};
var LogoFilter;
(function(LogoFilter) {
    LogoFilter["LIGHT"] = "brightness(10)";
    LogoFilter["BLACK"] = "brightness(0)";
    LogoFilter["DEFAULT"] = "";
})(LogoFilter || (LogoFilter = {}));
const getNavStyles = (param)=>{
    let { theme , startTransparent , isAboveThreshold , isNavHovered , hideOnScrolldown , useCompactLogo , scrollDirection  } = param;
    const shouldHide = hideOnScrolldown && scrollDirection === "down" && !isAboveThreshold;
    const backgroundColor = getBackgroundColor(startTransparent, isAboveThreshold, isNavHovered);
    const boxShadow = backgroundColor === "transparent" ? "none" : "0 1px 4px rgba(0, 0, 0, 0.1)";
    const carbonLogoSrc = useCompactLogo ? "/navigation/logo/mobile/color" : "/logo";
    const transition = 200;
    const transitionClass = "t-".concat(transition);
    const transparentGrey = (0,_utils_transparent__WEBPACK_IMPORTED_MODULE_6__/* .transparent */ .Z)(_c10h_colors__WEBPACK_IMPORTED_MODULE_9__.gray800, 10);
    const styleLookup = {
        [NavTheme.LIGHT]: {
            anchorColor: getAnchorColor("#fff", backgroundColor),
            logoFilter: isNavHovered || !isAboveThreshold ? LogoFilter.DEFAULT : LogoFilter.LIGHT,
            buttonBackground: backgroundColor === "#fff" ? transparentGrey : "#fff"
        },
        [NavTheme.BLACK]: {
            anchorColor: getAnchorColor(_c10h_colors__WEBPACK_IMPORTED_MODULE_9__.gray800, backgroundColor),
            logoFilter: LogoFilter.BLACK,
            buttonBackground: transparentGrey
        },
        [NavTheme.DEFAULT]: {
            anchorColor: getAnchorColor(_c10h_colors__WEBPACK_IMPORTED_MODULE_9__.gray800, backgroundColor),
            logoFilter: LogoFilter.DEFAULT,
            buttonBackground: transparentGrey
        }
    };
    return {
        showNav: !shouldHide,
        activeStyle: {
            ...styleLookup[theme],
            boxShadow,
            carbonLogoSrc,
            backgroundColor,
            transition,
            transitionClass
        }
    };
};
const checkIfAboveThreshold = function(scroll) {
    let offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return scroll.y + offset >= THRESHOLD;
};
const useNavState = (startTransparent, theme, isNavHovered)=>{
    const scroll = (0,_useScroll__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    const { isMobile  } = (0,_store__WEBPACK_IMPORTED_MODULE_3__/* .useTypedSelector */ .ix)((state)=>state.config);
    const showBookingButton = useShouldShowBookingButton(scroll.y);
    const isAboveThreshold = checkIfAboveThreshold(scroll, isMobile ? 0 : OFFSET);
    const getNewState = ()=>({
            ...getNavStyles({
                theme,
                startTransparent,
                isAboveThreshold,
                isNavHovered,
                // @ts-expect-error TS2322: Type 'boolean | undefined' is not assignable to type 'boolean'.
                hideOnScrolldown: isMobile,
                // @ts-expect-error TS2322: Type 'boolean | undefined' is not assignable to type 'boolean'.
                useCompactLogo: isMobile,
                scrollDirection: scroll.direction
            }),
            showBookingButton
        });
    const initialStyle = getNewState();
    const [styleState, setStyleState] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialStyle);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const newState = getNewState();
        setStyleState((state)=>(0,_utils_isDeepEqual__WEBPACK_IMPORTED_MODULE_5__/* .isDeepEqual */ .x)(state, newState) ? state : newState);
    }, [
        theme,
        startTransparent,
        isAboveThreshold,
        isNavHovered,
        isMobile,
        scroll.direction
    ]);
    return styleState;
};


/***/ }),

/***/ 10738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26420);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32466);



const NextLink = (param)=>{
    let { children , external , href , as , replace , scroll , shallow , prefetch , className , passHref  } = param;
    return external ? children : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href,
        as,
        replace,
        scroll,
        shallow,
        prefetch,
        className,
        passHref,
        legacyBehavior: true,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NextLink);


/***/ }),

/***/ 57347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var ni18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76361);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32466);
/* harmony import */ var react_outside_click_handler__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98280);



// @ts-expect-error TS7016: Could not find a declaration file for module 'react-outside-click-handler'. '/Users/goksel/Sites/carbon-website-next/node_modules/react-outside-click-handler/index.js' implicitly has an 'any' type.

const isSectionHeader = (item)=>item.header !== undefined;
const OptionsList = (param)=>{
    let { options , onOutsideClick , onSelectOption , className , ...props } = param;
    const i18n = (0,ni18n__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)();
    const onClick = (value, i)=>()=>{
            onOutsideClick();
            onSelectOption(value, i);
        };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_outside_click_handler__WEBPACK_IMPORTED_MODULE_3__["default"], {
        onOutsideClick: onOutsideClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            ...props,
            className: "p4 br5 bs2 bg-gray50 font-ir ".concat(className),
            onClick: (e)=>{
                e.stopPropagation();
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                role: "tablist",
                className: "basic",
                children: options.map((opt, i)=>isSectionHeader(opt) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "gray800 font-im ml4 mt2 mb4 cd",
                        children: opt.header
                    }, "option-".concat(i)) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: " br5 mb2 cp font-ir focus-bsDarkBlue3 ".concat(opt.selected ? "bg-darkGreen white fw6 contrast-tb" : "hover-bg-gray100 hover-fw6"),
                        onClick: onClick(opt.value, i),
                        onKeyDown: (e)=>e.key === "Enter" && onSelectOption(opt.value, i),
                        style: {
                            minWidth: 200
                        },
                        role: "tab",
                        "aria-label": i18n.t("Select {{text}}", {
                            text: opt.text
                        }),
                        tabIndex: 0,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "df aic jcsb p3 pl4",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "lh1",
                                    children: opt.text
                                }),
                                opt.selected && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "cIcon-check fs14"
                                })
                            ]
                        })
                    }, "option-".concat(i)))
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (OptionsList);


/***/ }),

/***/ 566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ ReadableSlotTime; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50995);
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment_timezone__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ni18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76361);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32466);
/* harmony import */ var _hooks_useReadableSlotTime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8764);
/* harmony import */ var _common_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93932);






// TODO: Refactor to use hook
const ReadableSlotTime = (param)=>{
    let { time , lowerCase , dateOnlyAfterTomorrow  } = param;
    const i18n = (0,ni18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)();
    const [slotTime, setSlotTime] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        if (!time) return;
        const actualMoment = moment_timezone__WEBPACK_IMPORTED_MODULE_1___default()(time);
        const timeFormat = (0,_hooks_useReadableSlotTime__WEBPACK_IMPORTED_MODULE_4__/* .isEvenHour */ .u5)(actualMoment.valueOf()) ? "ha" : "h:mma";
        const t = actualMoment.calendar(null, {
            sameDay: "[".concat(lowerCase ? i18n.t("today") : i18n.t("Today"), "] ").concat(timeFormat),
            nextDay: "[".concat(lowerCase ? i18n.t("tomorrow") : i18n.t("Tomorrow"), "] ").concat(timeFormat),
            lastWeek: "[".concat(lowerCase ? i18n.t("last") : i18n.t("Last"), "] dddd"),
            nextWeek: dateOnlyAfterTomorrow ? "MMM Do" : "ddd ".concat(timeFormat),
            sameElse: dateOnlyAfterTomorrow ? "MMM Do" : "ddd, MMM Do"
        });
        // @ts-expect-error TS2345: Argument of type 'string' is not assignable to parameter of type 'SetStateAction<null>'.
        setSlotTime(t);
    }, [
        time
    ]);
    if (_common_constants__WEBPACK_IMPORTED_MODULE_5__/* .isCI */ .yg) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: moment_timezone__WEBPACK_IMPORTED_MODULE_1___default()(_common_constants__WEBPACK_IMPORTED_MODULE_5__/* .fakeTimestamp */ .cS).format("ddd, MMM Do")
        });
    }
    // @ts-expect-error TS2322: Type 'null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>>'.
    return slotTime;
};


/***/ }),

/***/ 9121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$g": function() { return /* binding */ getSendClickedCareDiscoveryRowEvent; },
/* harmony export */   "AV": function() { return /* binding */ buildSearchReporter; },
/* harmony export */   "Vt": function() { return /* binding */ useSendDefaultResultsViewedEvent; }
/* harmony export */ });
/* harmony import */ var memoizee__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37453);
/* harmony import */ var memoizee__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(memoizee__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(56722);
/* harmony import */ var _page_containers_booking_utils_bookingStep__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43612);
/* harmony import */ var _page_containers_booking_utils_webBookingAnalytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71561);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40367);
/* harmony import */ var _store_slices_userLocation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36330);
/* harmony import */ var _utils_analytics__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82546);
/* harmony import */ var _utils_analytics_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(557);
/* harmony import */ var _utils_analytics_eventQueue__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57659);
/* harmony import */ var _utils_browser_storage_latLong__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16085);
/* harmony import */ var _common_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(93932);












const getCareEntryResultOptions = (results, reasons)=>{
    return results.slice(0, 20).map((result, idx)=>{
        const apptReason = reasons.find((apptReason)=>apptReason.id === result.appointment_reason);
        return {
            apptReasonId: result.appointment_reason,
            apptReasonText: result.appointment_reason && result.name,
            topicText: !result.appointment_reason ? result.name : undefined,
            specialtyId: (apptReason === null || apptReason === void 0 ? void 0 : apptReason.specialtyIds) ? apptReason.specialtyIds[0] : undefined,
            rank: idx + 1
        };
    });
};
const buildSearchReporter = (query, reasons, noResultSuggestions)=>(results, showNoResults)=>{
        _utils_analytics__WEBPACK_IMPORTED_MODULE_6__/* .analytics.post */ .c.post({
            action: _utils_analytics__WEBPACK_IMPORTED_MODULE_6__/* .analytics.action.SEARCHED */ .c.action.SEARCHED,
            category: _utils_analytics__WEBPACK_IMPORTED_MODULE_6__/* .analytics.category.APPOINTMENT_SCHEDULING */ .c.category.APPOINTMENT_SCHEDULING,
            label: _utils_analytics__WEBPACK_IMPORTED_MODULE_6__/* .analytics.label.APPOINTMENT_REASON */ .c.label.APPOINTMENT_REASON,
            extraData: {
                options: getCareEntryResultOptions(results, reasons),
                resultsCount: results.length,
                searchText: query,
                ...showNoResults && {
                    // @ts-expect-error TS2532: Object is possibly 'undefined'.
                    noResultSuggestions: noResultSuggestions.map((result)=>result.appointment_reason)
                }
            }
        });
    };
const getLabelAndIdFromPathname = (pathname)=>{
    switch(pathname){
        case _common_constants__WEBPACK_IMPORTED_MODULE_10__/* .v5Pages.clinicDetails */ .Td.clinicDetails:
            return [
                _utils_analytics_constants__WEBPACK_IMPORTED_MODULE_7__/* .EventType.AppointmentBookingWebsiteWidgetClicked */ .tw.AppointmentBookingWebsiteWidgetClicked,
                _utils_analytics_constants__WEBPACK_IMPORTED_MODULE_7__/* .Label.AppointmentBookingWebsiteWidget */ .__.AppointmentBookingWebsiteWidget
            ];
        case _common_constants__WEBPACK_IMPORTED_MODULE_10__/* .v5Pages.home */ .Td.home:
            return [
                _utils_analytics_constants__WEBPACK_IMPORTED_MODULE_7__/* .EventType.AppointmentBookingHomeWidgetClicked */ .tw.AppointmentBookingHomeWidgetClicked,
                _utils_analytics_constants__WEBPACK_IMPORTED_MODULE_7__/* .Label.AppointmentBookingHomeWidget */ .__.AppointmentBookingHomeWidget
            ];
        default:
            return [
                _utils_analytics_constants__WEBPACK_IMPORTED_MODULE_7__/* .EventType.AppointmentBookingReasonWidgetClicked */ .tw.AppointmentBookingReasonWidgetClicked,
                _utils_analytics_constants__WEBPACK_IMPORTED_MODULE_7__/* .Label.AppointmentBookingReasonWidget */ .__.AppointmentBookingReasonWidget
            ];
    }
};
/**
 *
 * @param rowClickedTypeId `default` refers to non-modal results
 * @param pathname Only should be used with the `default` type
 */ const getSendClickedCareDiscoveryRowEvent = (rowClickedTypeId, pathname)=>{
    return memoizee__WEBPACK_IMPORTED_MODULE_0___default()((result, soonestSlot, rank, flowId, viewId)=>{
        var _soonestSlot_specialtyIds;
        const [typeId, label] = (()=>{
            switch(rowClickedTypeId){
                case "searched":
                    return [
                        _utils_analytics_constants__WEBPACK_IMPORTED_MODULE_7__/* .EventType.SearchedAppointmentReasonClicked */ .tw.SearchedAppointmentReasonClicked,
                        _utils_analytics_constants__WEBPACK_IMPORTED_MODULE_7__/* .Label.SearchedAppointmentReason */ .__.SearchedAppointmentReason
                    ];
                case "base":
                    return [
                        _utils_analytics_constants__WEBPACK_IMPORTED_MODULE_7__/* .EventType.AppointmentReasonClicked */ .tw.AppointmentReasonClicked,
                        _utils_analytics_constants__WEBPACK_IMPORTED_MODULE_7__/* .Label.AppointmentReason */ .__.AppointmentReason
                    ];
                case "default":
                    return getLabelAndIdFromPathname(pathname);
            }
        })();
        (0,_utils_analytics_eventQueue__WEBPACK_IMPORTED_MODULE_8__/* .queueEvent */ .x$)({
            typeId,
            category: _utils_analytics_constants__WEBPACK_IMPORTED_MODULE_7__/* .EventCategory.Custom */ .Jk.Custom,
            extraData: {
                category: _utils_analytics_constants__WEBPACK_IMPORTED_MODULE_7__/* .CustomCategory.AppointmentScheduling */ .mg.AppointmentScheduling,
                label,
                value: result.appointment_reason,
                flowId,
                viewId,
                rank,
                firstAvailability: soonestSlot === null || soonestSlot === void 0 ? void 0 : soonestSlot.time,
                specialtyId: soonestSlot === null || soonestSlot === void 0 ? void 0 : (_soonestSlot_specialtyIds = soonestSlot.specialtyIds) === null || _soonestSlot_specialtyIds === void 0 ? void 0 : _soonestSlot_specialtyIds[0]
            }
        });
    });
};
const sendDefaultResultsViewedEvent = (id, results, reasons, selectedRegion, locationId, milesAway)=>{
    (0,_utils_analytics_eventQueue__WEBPACK_IMPORTED_MODULE_8__/* .queueEvent */ .x$)({
        id,
        typeId: _utils_analytics_constants__WEBPACK_IMPORTED_MODULE_7__/* .EventType.AppointmentReasonOptionsViewed */ .tw.AppointmentReasonOptionsViewed,
        extraData: {
            category: _utils_analytics_constants__WEBPACK_IMPORTED_MODULE_7__/* .CustomCategory.AppointmentScheduling */ .mg.AppointmentScheduling,
            label: _utils_analytics_constants__WEBPACK_IMPORTED_MODULE_7__/* .Label.AppointmentReasonOptions */ .__.AppointmentReasonOptions,
            bookingStep: _page_containers_booking_utils_bookingStep__WEBPACK_IMPORTED_MODULE_2__/* .BookingStep.REASON_SELECTION */ .a.REASON_SELECTION,
            selectedRegion,
            options: getCareEntryResultOptions(results, reasons),
            apptDetails: locationId || milesAway ? {
                locationId,
                milesAway
            } : undefined
        }
    });
};
const useSendDefaultResultsViewedEvent = (param)=>{
    let { results , isLoading , location  } = param;
    const [viewId, setViewId] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const reasons = (0,_store__WEBPACK_IMPORTED_MODULE_4__/* .useTypedSelector */ .ix)((state)=>state.config.reasons);
    const selectedRegion = (0,_store__WEBPACK_IMPORTED_MODULE_4__/* .useTypedSelector */ .ix)(_store_slices_userLocation__WEBPACK_IMPORTED_MODULE_5__/* .selectSelectedRegion */ .dz);
    const userPosition = (0,_utils_browser_storage_latLong__WEBPACK_IMPORTED_MODULE_9__/* .useLatLong */ .YI)();
    const milesAway = userPosition && (location === null || location === void 0 ? void 0 : location.address) && (0,_page_containers_booking_utils_webBookingAnalytics__WEBPACK_IMPORTED_MODULE_3__/* .getMilesAway */ .W)(userPosition, location);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!isLoading && reasons && reasons.length > 0) {
            const newViewId = (0,uuid__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)();
            sendDefaultResultsViewedEvent(newViewId, results, reasons, selectedRegion, location === null || location === void 0 ? void 0 : location.id, milesAway);
            setViewId(newViewId);
        }
    }, [
        selectedRegion,
        reasons,
        location,
        isLoading,
        results,
        milesAway
    ]);
    return viewId;
};


/***/ }),

/***/ 93994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Region_RegionTreeSelector; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/@react-aria/button/dist/module.js
var dist_module = __webpack_require__(19811);
// EXTERNAL MODULE: ./node_modules/@react-aria/focus/dist/module.js
var focus_dist_module = __webpack_require__(39475);
// EXTERNAL MODULE: ./node_modules/@react-aria/overlays/dist/module.js + 1 modules
var overlays_dist_module = __webpack_require__(89729);
// EXTERNAL MODULE: ./node_modules/@react-aria/utils/dist/module.js
var utils_dist_module = __webpack_require__(3912);
// EXTERNAL MODULE: ./node_modules/@react-stately/overlays/dist/module.js
var _react_stately_overlays_dist_module = __webpack_require__(48720);
// EXTERNAL MODULE: ./node_modules/lodash/omit.js
var omit = __webpack_require__(93072);
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/store/index.ts + 6 modules
var store = __webpack_require__(40367);
;// CONCATENATED MODULE: ./src/components/v5/components/Tree/TreeOverlay.tsx









const CONTAINER_WIDTH = 350;
const variantProps = {
    primary: {
        className: "brdn br5 fw6 p3 df aic bg-transparent cp aria-focus contrast-tb",
        style: {}
    },
    secondary: {
        className: "brdn br2 fw4 p4 df aic cp aria-focus bg-gray100 jcsb aibl contrast-tb",
        style: {
            width: CONTAINER_WIDTH
        }
    },
    locations: {
        className: "br2 flex grow w-full items-center cursor-pointer justify-between aibl fs14 bg-gray50 gray600 hover-gray800 ml0 p4 p-3 sm:p-4 brd1nc brd-gray100 minw10 contrast-tb",
        style: {
            maxWidth: CONTAINER_WIDTH
        }
    }
};
const Popover = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { children , isOpen , onClose , ...otherProps } = param;
    const { overlayProps  } = (0,overlays_dist_module/* useOverlay */.Ir)({
        onClose,
        isOpen,
        isDismissable: true
    }, ref);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(focus_dist_module/* FocusScope */.MT, {
        contain: true,
        restoreFocus: true,
        autoFocus: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            ...(0,utils_dist_module/* mergeProps */.dG)(overlayProps, otherProps),
            ref: ref,
            className: "mt2 pos-a zIndex1",
            style: {
                width: CONTAINER_WIDTH
            },
            children: [
                children,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(overlays_dist_module/* DismissButton */.U4, {
                    onDismiss: onClose
                })
            ]
        })
    });
});
const MemoPopover = /*#__PURE__*/ react.memo(Popover);
Popover.displayName = "Popover";
const TreeOverlay = (param)=>{
    let { onClose , selectorName , renderChildren , selectedItem , variant  } = param;
    const state = (0,_react_stately_overlays_dist_module/* useOverlayTriggerState */.d)({});
    const triggerRef = react.useRef();
    const overlayRef = react.useRef();
    const { isMobile  } = (0,store/* useTypedSelector */.ix)((state)=>state.config);
    // @ts-expect-error TS2345: Argument of type 'MutableRefObject<HTMLButtonElement | undefined>' is not assignable to parameter of type 'RefObject<HTMLElement>'.
    const { triggerProps , overlayProps  } = (0,overlays_dist_module/* useOverlayTrigger */.IB)({
        type: "tree"
    }, state, triggerRef);
    const { overlayProps: positionProps  } = (0,overlays_dist_module/* useOverlayPosition */.tN)({
        // @ts-expect-error TS2322: Type 'MutableRefObject<HTMLButtonElement | undefined>' is not assignable to type 'RefObject<HTMLElement>'.
        targetRef: triggerRef,
        // @ts-expect-error TS2322: Type 'MutableRefObject<HTMLDivElement | undefined>' is not assignable to type 'RefObject<HTMLElement>'.
        overlayRef,
        placement: "top",
        offset: 5,
        isOpen: state.isOpen,
        ...isMobile && {
            onClose: ()=>null
        }
    });
    const { buttonProps  } = (0,dist_module/* useButton */.U)({
        onPress: ()=>state.open()
    }, // @ts-expect-error TS2769: No overload matches this call.
    triggerRef);
    const handleClose = ()=>{
        onClose();
        state.close();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pos-r dib zIndex2 grow",
        style: {
            maxWidth: 350
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "react-aria-select-descriptor",
                className: "visually-hidden",
                children: selectorName
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                ...buttonProps,
                ...omit_default()(triggerProps, "onPress"),
                "aria-labelledby": "react-aria-select-descriptor react-aria-selected-item",
                // @ts-expect-error TS2322: Type 'MutableRefObject<HTMLButtonElement | undefined>' is not assignable to type 'LegacyRef<HTMLButtonElement> | undefined'.
                ref: triggerRef,
                // @ts-expect-error TS2783: 'className' is specified more than once, so this usage will be overwritten.
                className: "brdn br5 fw6 p3 df aibl bg-transparent cp aria-focus",
                ...variantProps[variant],
                "data-cy": "comboboxButton",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        id: "react-aria-selected-item",
                        className: "font-c font-i-sm fs18 fs14-sm lh26 mr2",
                        children: selectedItem
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "cIcon-dropdown-arrow-down",
                        "aria-hidden": "true"
                    })
                ]
            }),
            state.isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(MemoPopover, {
                ...overlayProps,
                ...positionProps,
                // @ts-expect-error TS2322: Type 'MutableRefObject<HTMLDivElement | undefined>' is not assignable to type 'Ref<HTMLDivElement> | undefined'.
                ref: overlayRef,
                isOpen: state.isOpen,
                onClose: handleClose,
                children: renderChildren(handleClose)
            })
        ]
    });
};
/* harmony default export */ var Tree_TreeOverlay = (/*#__PURE__*/react.memo(TreeOverlay));

// EXTERNAL MODULE: ./src/components/v5/Input/TextInput.tsx
var TextInput = __webpack_require__(85208);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(88569);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/hooks/useCurrentRoute.ts
var useCurrentRoute = __webpack_require__(59640);
;// CONCATENATED MODULE: ./src/components/v5/components/Tree/index.tsx






// Need to do this to ensure there's a document
const DynamicComplexTreeWrapper = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(5378), __webpack_require__.e(4687)]).then(__webpack_require__.bind(__webpack_require__, 4687)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(4687)
            ]
    },
    ssr: false
});
const TreeView = (param)=>{
    let { buildTree , initialExpandedItems , initialSelected , selectorName , searchLabel , searchPlaceholder , handleSelect , handleSearch , buttonVariant  } = param;
    // @ts-expect-error TS2339, TS2339: Property 'name' does not exist on type 'SelectedItem | undefined'.,  Property 'id' does not exist on type 'SelectedItem | undefined'.
    const { name , id  } = initialSelected;
    const [selectedId, setSelectedId] = (0,react.useState)(id);
    const [searchTerm, setSearch] = (0,react.useState)("");
    const currentRoute = (0,useCurrentRoute/* useCurrentRoute */.H)();
    const tree = (0,react.useMemo)(()=>buildTree(searchTerm), [
        buildTree,
        searchTerm
    ]);
    const selectedItem = (0,react.useMemo)(()=>tree[selectedId], [
        selectedId,
        tree
    ]);
    const handleClose = (0,react.useCallback)(()=>setSearch(""), []);
    const handleTreeItemSelect = (close)=>(item)=>{
            setSelectedId(item.index);
            handleSelect(item.index);
            close();
        };
    (0,react.useEffect)(()=>{
        if (handleSearch) handleSearch(searchTerm, tree, currentRoute);
    }, [
        currentRoute,
        handleSearch,
        searchTerm,
        tree
    ]);
    (0,react.useEffect)(()=>{
        setSelectedId(id);
    }, [
        id
    ]);
    var _selectedItem_data, _selectedItem_index;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tree_TreeOverlay, {
        selectedItem: (_selectedItem_data = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.data) !== null && _selectedItem_data !== void 0 ? _selectedItem_data : name,
        selectorName: selectorName,
        onClose: handleClose,
        variant: buttonVariant,
        renderChildren: (close)=>{
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                className: "bg-white pv7 br5 bs2 ph6 contrast-tb",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* default */.Z, {
                        onChange: setSearch,
                        className: "mb-2",
                        icon: "cIcon-search -ml-2 mr1 fs28-f",
                        placeholder: searchPlaceholder,
                        ariaLabel: searchLabel,
                        autoFocus: true,
                        autoComplete: "off"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicComplexTreeWrapper, {
                        onSelect: handleTreeItemSelect(close),
                        tree: tree,
                        defaultExpandedItems: initialExpandedItems,
                        defaultSelectedItem: (_selectedItem_index = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.index) !== null && _selectedItem_index !== void 0 ? _selectedItem_index : id
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var Tree = (/*#__PURE__*/react.memo(TreeView));

// EXTERNAL MODULE: ./src/i18n.ts + 5 modules
var src_i18n = __webpack_require__(76361);
// EXTERNAL MODULE: ./src/store/getRegionSlug.ts
var getRegionSlug = __webpack_require__(84684);
// EXTERNAL MODULE: ./src/store/slices/userLocation.ts
var userLocation = __webpack_require__(36330);
// EXTERNAL MODULE: ./public/static/data/localRegions.json
var localRegions = __webpack_require__(14930);
// EXTERNAL MODULE: ./src/constants/hardcodedVirtualRegions.ts
var hardcodedVirtualRegions = __webpack_require__(96821);
;// CONCATENATED MODULE: ./src/utils/regionUtils.ts


const regionHasPhysicalClinics = (region)=>!hardcodedVirtualRegions/* default.map */.Z.map((param)=>{
        let { slug  } = param;
        return slug;
    }).includes(region.slug);
const generateRegionData = function() {
    let hideVirtualOnly = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    const regions = hideVirtualOnly ? localRegions.filter(regionHasPhysicalClinics) : localRegions;
    return regions.map((region)=>({
            key: region.slug,
            textValue: region.name,
            name: region.name,
            slug: region.slug
        }));
};

// EXTERNAL MODULE: ./src/utils/stateUtils.ts + 1 modules
var stateUtils = __webpack_require__(83202);
// EXTERNAL MODULE: ./src/utils/analytics.ts
var analytics = __webpack_require__(82546);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(91663);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(21781);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
;// CONCATENATED MODULE: ./src/components/v5/Region/utils/flattenSearchResultsForAnalytics.ts


function flattenSearchResultsForAnalytics(regions) {
    var _regionsData_root;
    if (isEmpty_default()(regions)) return [];
    // Deep Clone tree object to avoid unexpected reference issues
    const regionsData = cloneDeep_default()(regions);
    const statesWithMultipleRegion = Object.values(regionsData).reduce(// @ts-expect-error TS2769: No overload matches this call.
    (acc, next)=>next.index !== "root" && next.hasChildren ? [
            ...acc,
            next.index
        ] : acc, []);
    // @ts-expect-error TS2322: Type 'TreeItemIndex[] | undefined' is not assignable to type '(string | number)[]'.
    if (isEmpty_default()(statesWithMultipleRegion)) return regionsData === null || regionsData === void 0 ? void 0 : (_regionsData_root = regionsData.root) === null || _regionsData_root === void 0 ? void 0 : _regionsData_root.children;
    const nestedStateRegions = Object.values(regionsData).reduce(// @ts-expect-error TS2769, TS2488: No overload matches this call.,  Type 'TreeItemIndex[] | undefined' must have a '[Symbol.iterator]()' method that returns an iterator.
    (acc, next)=>next.index !== "root" && next.hasChildren ? [
            ...acc,
            ...next.children
        ] : acc, []);
    // @ts-expect-error TS2488: Type 'TreeItem<string>' must have a '[Symbol.iterator]()' method that returns an iterator.
    const regionList = [
        ...regionsData.root.children,
        ...nestedStateRegions
    ].filter(// @ts-expect-error TS2339: Property 'includes' does not exist on type 'TreeItem<string>'.
    (region)=>!statesWithMultipleRegion.includes(region));
    return regionList;
}

;// CONCATENATED MODULE: ./src/components/v5/Region/utils/handleSendAnalyticsData.tsx


const sendAnalyticsDataOnRegionChange = (region, currentRoute)=>{
    analytics/* analytics.post */.c.post({
        category: analytics/* analytics.category.LOCATION_DISCOVERY */.c.category.LOCATION_DISCOVERY,
        label: analytics/* analytics.label.REGION_DROP_DOWN */.c.label.REGION_DROP_DOWN,
        action: analytics/* analytics.action.CLICKED */.c.action.CLICKED,
        extraData: {
            isMapPopup: false,
            value: region,
            source: currentRoute === "index" ? "footer" : currentRoute
        }
    });
};
// @ts-expect-error TS7034: Variable 'interval' implicitly has type 'any' in some locations where its type cannot be determined.
let interval;
const sendAnalyticsDataOnSearch = (searchTerm, tree, currentRoute)=>{
    // @ts-expect-error TS7005, TS7005: Variable 'interval' implicitly has an 'any' type.,  Variable 'interval' implicitly has an 'any' type.
    if (interval) clearInterval(interval);
    interval = setTimeout(()=>{
        const hasSearchTerm = searchTerm.length;
        if (hasSearchTerm) {
            const searchResoults = flattenSearchResultsForAnalytics(tree);
            analytics/* analytics.post */.c.post({
                category: analytics/* analytics.category.LOCATION_DISCOVERY */.c.category.LOCATION_DISCOVERY,
                label: analytics/* analytics.label.REGION */.c.label.REGION,
                action: analytics/* analytics.action.SEARCHED */.c.action.SEARCHED,
                extraData: {
                    options: searchResoults,
                    searchText: searchTerm,
                    resultsCount: searchResoults.length,
                    source: currentRoute === "index" ? "footer" : currentRoute
                }
            });
        }
    }, 500);
};

;// CONCATENATED MODULE: ./src/components/v5/Region/RegionTreeSelector.tsx











const sfBayAreaRegion = {
    slug: (0,getRegionSlug/* getRegionSlug */.x)("sf-bay-area"),
    name: "Bay Area"
};
const isCARegion = (slug)=>(0,stateUtils/* getStateCodeFromRegionSlug */.GZ)(slug) === "CA";
const californiaParentItem = {
    id: "ca",
    name: "California"
};
const buildRegionTree = (regions)=>(searchTerm)=>{
        const filteredRegions = regions.filter((param)=>{
            let { name  } = param;
            return name.toLowerCase().includes(searchTerm.toLowerCase());
        });
        const filteredCARegions = filteredRegions.filter((param)=>{
            let { id  } = param;
            return isCARegion(id);
        }).sort((a, b)=>a.name.charCodeAt(0) - b.name.charCodeAt(0)).map((param)=>{
            let { id  } = param;
            return id;
        });
        const otherRegions = filteredRegions.filter((param)=>{
            let { id  } = param;
            return !isCARegion(id);
        });
        const rootChildren = filteredCARegions.length ? otherRegions.append(californiaParentItem) : otherRegions;
        const root = {
            index: "root",
            hasChildren: true,
            children: rootChildren.sortBy((param)=>{
                let { name  } = param;
                return name;
            }).map((param)=>{
                let { id  } = param;
                return id;
            }),
            data: "Root"
        };
        return filteredRegions.append(californiaParentItem).reduce((prev, curr)=>{
            if (curr.name === californiaParentItem.name && filteredCARegions.length) {
                return {
                    ...prev,
                    [curr.id]: {
                        index: curr.id,
                        hasChildren: true,
                        children: filteredCARegions,
                        data: curr.name
                    }
                };
            }
            return {
                ...prev,
                [curr.id]: {
                    index: curr.id,
                    hasChildren: false,
                    children: null,
                    data: curr.name
                }
            };
        }, {
            root
        });
    };
const RegionTreeSelector = (param)=>{
    let { buttonVariant ="primary" , onSelect , initialRegionSlug , hideVirtualOnly =false  } = param;
    var _locations_;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const dispatch = (0,store/* useTypedDispatch */.zL)();
    var _useTypedSelector;
    const selectedFromStore = (_useTypedSelector = (0,store/* useTypedSelector */.ix)(userLocation/* selectSelectedRegion */.dz)) !== null && _useTypedSelector !== void 0 ? _useTypedSelector : "sf-bay-area";
    const { locations  } = (0,store/* useTypedSelector */.ix)((param)=>{
        let { config  } = param;
        return config;
    });
    const closestRegion = ((_locations_ = locations[0]) === null || _locations_ === void 0 ? void 0 : _locations_.region) || sfBayAreaRegion;
    const selectedRegion = initialRegionSlug !== null && initialRegionSlug !== void 0 ? initialRegionSlug : selectedFromStore;
    const currentRoute = (0,useCurrentRoute/* useCurrentRoute */.H)();
    const selectorName = i18n.t("Region");
    const searchLabel = i18n.t("Search by region name");
    const searchPlaceholder = i18n.t("Search regions");
    const regions = (0,react.useMemo)(()=>generateRegionData(hideVirtualOnly), [
        hideVirtualOnly
    ]);
    const expandedItems = (0,react.useMemo)(()=>(0,stateUtils/* getStateCodeFromRegionSlug */.GZ)(selectedFromStore) === "CA" ? [
            californiaParentItem.id
        ] : [], []);
    const items = (0,react.useMemo)(()=>regions.map((param)=>{
            let { slug , name  } = param;
            return {
                name,
                id: slug
            };
        }), [
        regions
    ]);
    const initialSelected = (0,react.useMemo)(()=>items.find((param)=>{
            let { id  } = param;
            return id === selectedRegion;
        }) || {
            id: closestRegion.slug,
            name: closestRegion.name
        }, [
        items,
        selectedRegion
    ]);
    const handleSelect = (0,react.useCallback)((slug)=>{
        if (selectedFromStore !== slug) dispatch(store/* actions.setUserLocation */.Nw.setUserLocation({
            selectedRegion: slug
        }));
        if (onSelect) onSelect(slug);
        sendAnalyticsDataOnRegionChange(slug, currentRoute);
    }, [
        dispatch,
        onSelect,
        selectedFromStore
    ]);
    const buildTree = (0,react.useMemo)(()=>buildRegionTree(items), [
        items
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tree, {
        buttonVariant: buttonVariant,
        selectorName: selectorName,
        searchLabel: searchLabel,
        searchPlaceholder: searchPlaceholder,
        initialSelected: initialSelected,
        initialExpandedItems: expandedItems,
        handleSelect: handleSelect,
        // @ts-expect-error TS2322: Type '(searchTerm: string, tree: Record<TreeItemIndex, TreeItem<string>>, currentRoute: string) => void' is not assignable to type '(searchTerm?: string | undefined, treeData?: Record<TreeItemIndex, TreeItem<string>> | undefined, currentRoute?: string | undefined) => void'.
        handleSearch: sendAnalyticsDataOnSearch,
        buildTree: buildTree
    });
};
/* harmony default export */ var Region_RegionTreeSelector = (/*#__PURE__*/react.memo(RegionTreeSelector));


/***/ }),

/***/ 85527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var src_useEscape__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58689);
/* harmony import */ var _common_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93932);




const SkipLink = (param)=>{
    let { item: { targetId , text  } , showOnFocus  } = param;
    const [focused, setFocused] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const toggleFocus = (boolean)=>()=>{
            setFocused(typeof boolean === "boolean" ? boolean : !focused);
        };
    const focusTarget = (0,_common_constants__WEBPACK_IMPORTED_MODULE_3__/* .isBrowser */ .jU)() && document.getElementById(targetId);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: "#".concat(targetId),
        ...focusTarget ? {
            onKeyDown: (0,src_useEscape__WEBPACK_IMPORTED_MODULE_2__/* .onKeyHandler */ .PS)("Enter", ()=>{
                focusTarget.focus();
            }),
            onClick: ()=>{
                focusTarget.focus();
            }
        } : {},
        className: "ph3 pv2 gray800 bg-white br5 font-ib fs14 lh15 wsnw bs2 focus-bsDarkBlue3-hug pos-r ".concat(showOnFocus ? "showOnFocus" : ""),
        onFocus: toggleFocus(true),
        onBlur: toggleFocus(false),
        children: text
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SkipLink);


/***/ }),

/***/ 64800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var react_transition_group__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69468);
/* harmony import */ var src_hooks_usePrefersReducedMotion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80366);




const maxHeight = 5000;
const maxWidth = maxHeight;
const Fade = (param)=>{
    let { appear , collapse , timeout =10 , duration =200 , id , in: isIn , ...props } = param;
    const shouldReduceMotion = (0,src_hooks_usePrefersReducedMotion__WEBPACK_IMPORTED_MODULE_2__/* .usePrefersReducedMotion */ .T)();
    const defaultStyle = {
        transition: "all ".concat(shouldReduceMotion ? 0 : duration, "ms ease-in-out"),
        opacity: 0
    };
    const mounted = {
        opacity: 1,
        maxHeight,
        maxWidth
    };
    const unmounted = {
        opacity: 0,
        maxHeight: collapse ? 0 : maxHeight,
        maxWidth: collapse ? 0 : maxWidth
    };
    const transitionStyles = {
        entering: unmounted,
        entered: mounted,
        exiting: mounted,
        exited: unmounted
    };
    const nodeRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_transition_group__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
        nodeRef: nodeRef,
        in: isIn,
        timeout: timeout,
        appear: appear,
        ...props,
        children: (state)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: nodeRef,
                style: {
                    ...defaultStyle,
                    // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'TransitionStatus' can't be used to index type '{ entering: { opacity: number; maxHeight: number; maxWidth: number; }; entered: { opacity: number; maxHeight: number; maxWidth: number; }; exiting: { opacity: number; maxHeight: number; maxWidth: number; }; exited: { ...; }; }'.
                    ...transitionStyles[state]
                },
                id: id,
                children: props.children
            })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(Fade));


/***/ }),

/***/ 63575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H5": function() { return /* binding */ H5; },
/* harmony export */   "WP": function() { return /* binding */ VideoBackground; },
/* harmony export */   "Zx": function() { return /* binding */ ImgWithBg; },
/* harmony export */   "un": function() { return /* binding */ Btn; }
/* harmony export */ });
/* unused harmony export Label */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var color__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32130);
/* harmony import */ var color__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(color__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26420);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32466);
/* harmony import */ var src_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40367);
/* harmony import */ var src_useV5ImgSrc__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52299);
/* harmony import */ var _V5Comp_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82704);
/* harmony import */ var _V5Comp_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_V5Comp_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* eslint-disable @typescript-eslint/no-unused-vars */ // @ts-expect-error TS7016: Could not find a declaration file for module 'color'. '/Users/goksel/Sites/carbon-website-next/node_modules/color/index.js' implicitly has an 'any' type.







const ImgWithBg = (param)=>{
    let { id ="" , children , bgImage , className ="" , isSvg , style , isJpg , onClick , alt  } = param;
    const { imgExt  } = (0,src_store__WEBPACK_IMPORTED_MODULE_3__/* .useTypedSelector */ .ix)((param)=>{
        let { config  } = param;
        return config;
    });
    const bg = "/static/img/v5".concat(bgImage).concat(!isSvg && !isJpg ? ".".concat(imgExt) : "");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: id,
        className: "".concat(className, " ").concat((_V5Comp_module_scss__WEBPACK_IMPORTED_MODULE_5___default().imgWithBg)),
        style: {
            backgroundImage: "url(".concat(bg, ")"),
            ...style
        },
        onClick: onClick,
        role: "img",
        "aria-label": alt || bg,
        children: children
    });
};
const Label = (param)=>/*#__PURE__*/ {
    let { style ={} , children , ...rest } = param;
    return _jsx("span", {
        className: styles.label,
        style: style,
        ...rest,
        children: children
    });
};
const H5 = (param)=>/*#__PURE__*/ {
    let { children , color , style ={} , className ="" , ...rest } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
        className: "".concat((_V5Comp_module_scss__WEBPACK_IMPORTED_MODULE_5___default().h5), " ").concat(className),
        ...rest,
        style: {
            "--color": color,
            ...style
        },
        children: children
    });
};
const Btn = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)((param)=>{
    let { children , color , hover , bg , hoverBg , type , fontSize , bold , href , as , link =true , disabled , tabIndex , faux =false , className ="" , style ={} , ...rest } = param;
    const newHover = hover || color;
    const newHoverBg = hoverBg || color__WEBPACK_IMPORTED_MODULE_6___default()(bg).lighten(0.3);
    const a = !faux ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        className: "".concat((_V5Comp_module_scss__WEBPACK_IMPORTED_MODULE_5___default().btn), " ").concat(bold ? (_V5Comp_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["btn-bold"]) : "", " ").concat(disabled ? (_V5Comp_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["btn-disabled"]) : "", " ").concat(className),
        ...!link && {
            href
        },
        ...rest,
        style: {
            "--color": color,
            "--hover": newHover,
            "--bg": bg,
            "--hoverBg": newHoverBg,
            ...fontSize && {
                "--fontSize": typeof fontSize === "number" ? "".concat(fontSize, "rem") : fontSize
            },
            // ...(lineHeight && {"--lineHeight": lineHeight}),
            ...style
        },
        tabIndex: tabIndex,
        "data-cy": "btn",
        children: children
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "".concat((_V5Comp_module_scss__WEBPACK_IMPORTED_MODULE_5___default().btn), " ").concat(bold ? (_V5Comp_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["btn-bold"]) : "", " ").concat(disabled ? (_V5Comp_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["btn-disabled"]) : "", " ").concat(className),
        style: {
            "--color": color,
            "--hover": newHover,
            "--bg": bg,
            "--hoverBg": newHoverBg,
            ...fontSize && {
                "--fontSize": typeof fontSize === "number" ? "".concat(fontSize, "rem") : fontSize
            },
            ...style
        },
        children: children
    });
    return link && href ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: href,
        as: as,
        legacyBehavior: true,
        children: a
    }) : type === "submit" || type === "button" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        type: type,
        className: "".concat((_V5Comp_module_scss__WEBPACK_IMPORTED_MODULE_5___default().btn), " ").concat(bold ? (_V5Comp_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["btn-bold"]) : "", " ").concat(className),
        ...rest,
        style: {
            "--color": color,
            "--hover": newHover,
            "--bg": bg,
            "--hoverBg": newHoverBg,
            ...fontSize && {
                "--fontSize": typeof fontSize === "number" ? "".concat(fontSize, "rem") : fontSize
            },
            ...style
        },
        tabIndex: tabIndex,
        children: children
    }) : a;
});
Btn.displayName = "Btn";
const VideoBackground = (param)=>/*#__PURE__*/ {
    let { src , alt , poster  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("video", {
        autoPlay: true,
        muted: true,
        loop: true,
        // @ts-expect-error TS2345: Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        poster: (0,src_useV5ImgSrc__WEBPACK_IMPORTED_MODULE_4__/* .useV5ImgSrc */ .eH)(poster),
        className: "pos-a obfc h100p w100p left0 top0",
        title: alt,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                src: "/static/video/".concat(src, ".webm"),
                type: "video/webm"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                src: "/static/video/".concat(src, ".mp4"),
                type: "video/mp4"
            })
        ]
    });
};


/***/ }),

/***/ 66096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _react_aria_dialog__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70984);
/* harmony import */ var _react_aria_focus__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39475);
/* harmony import */ var _react_aria_overlays__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89729);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var _utils_zIndexMap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45812);






const ModalDialog = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.memo((props)=>{
    const { title , children , isFullWidth , isTitleHidden , blurBackdrop , zIndex  } = props;
    // Handle interacting outside the dialog and pressing
    // the Escape key to close the modal.
    const ref = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
    const { overlayProps , underlayProps  } = (0,_react_aria_overlays__WEBPACK_IMPORTED_MODULE_3__/* .useOverlay */ .Ir)(props, ref);
    // Prevent scrolling while the modal is open, and hide content
    // outside the modal from screen readers.
    (0,_react_aria_overlays__WEBPACK_IMPORTED_MODULE_3__/* .usePreventScroll */ .tk)();
    const { modalProps  } = (0,_react_aria_overlays__WEBPACK_IMPORTED_MODULE_3__/* .useModal */ .dd)();
    // Get props for the dialog and its title
    const { dialogProps , titleProps  } = (0,_react_aria_dialog__WEBPACK_IMPORTED_MODULE_4__/* .useDialog */ .R)(props, ref);
    const fullWidthClasses = "inset-0 flex flex-col overflow-y-auto static w-screen";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            position: "fixed",
            zIndex: zIndex || _utils_zIndexMap__WEBPACK_IMPORTED_MODULE_2__/* .highZIndexMap.MOBILE_DRAWER */ .q.MOBILE_DRAWER,
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            background: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backdropFilter: blurBackdrop ? "blur(4px)" : "none"
        },
        ...underlayProps,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_aria_focus__WEBPACK_IMPORTED_MODULE_5__/* .FocusScope */ .MT, {
            contain: true,
            restoreFocus: true,
            autoFocus: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "aria-focus gray800 ".concat(isFullWidth ? fullWidthClasses : ""),
                ...overlayProps,
                ...dialogProps,
                ...modalProps,
                ref: ref,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "".concat(isTitleHidden ? "visually-hidden" : ""),
                        ...titleProps,
                        children: title
                    }),
                    children
                ]
            })
        })
    });
});
ModalDialog.displayName = "ModalDialog";
/* harmony default export */ __webpack_exports__["Z"] = (ModalDialog);


/***/ }),

/***/ 93063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useDialog; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _react_aria_overlays__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89729);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var _hooks_useDisclosure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40603);
/* harmony import */ var _ModalDialog__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66096);





/*
  Implementation of Dialog pattern
  Sourced from @react-aria's implementation: https://react-spectrum.adobe.com/react-aria/useDialog.html
 */ const useDialog = (param)=>{
    let { title , isFullWidth =false , isTitleHidden =false , blurBackdrop =false , onStateChange  } = param;
    const state = (0,_hooks_useDisclosure__WEBPACK_IMPORTED_MODULE_2__/* .useDisclosure */ .q)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (onStateChange) {
            onStateChange(state.isOpen);
        }
    }, [
        onStateChange,
        state.isOpen
    ]);
    const Dialog = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((param)=>{
        let { children  } = param;
        return state.isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_aria_overlays__WEBPACK_IMPORTED_MODULE_4__/* .OverlayContainer */ .Xj, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ModalDialog__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                id: "modal-dialog",
                role: "dialog",
                title: title,
                isDismissable: true,
                isFullWidth: isFullWidth,
                isTitleHidden: isTitleHidden,
                blurBackdrop: blurBackdrop,
                children: children
            })
        }) : null;
    }, [
        blurBackdrop,
        isFullWidth,
        isTitleHidden,
        state.isOpen,
        title
    ]);
    // @ts-expect-error TS2322: Type '{ state: { set: React.Dispatch<React.SetStateAction<boolean>>; close: () => void; open: () => void; toggle: () => void; isOpen: boolean; isClosed: boolean; }; Dialog: ({ children }: { children: React.ReactNode; }) => JSX.Element | null; }' is not assignable to type '{ state: { set: Dispatch<SetStateAction<boolean>>; close: () => void; open: () => void; toggle: () => void; isOpen: boolean; isClosed: boolean; }; Dialog: FC<{}>; }'.
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>({
            state,
            Dialog
        }), [
        state,
        Dialog
    ]);
};


/***/ }),

/***/ 74594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UE": function() { return /* binding */ elCaminoDisabledTime; },
/* harmony export */   "ih": function() { return /* binding */ isFullPageBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _components_NextImage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5621);
/* harmony import */ var ni18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76361);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32466);
/* harmony import */ var src_components_common_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93932);
/* harmony import */ var _locations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43402);






const isFullPageBanner = (item)=>item.type !== undefined;
const elCaminoDisabledTime = 1630893600000; // Sep. 5, 2021 7PM PST
const sfLocationsLink = "".concat(src_components_common_constants__WEBPACK_IMPORTED_MODULE_4__/* .v5Pages.locations */ .Td.locations, "?city=san francisco");
const useLocationConstants = (param)=>{
    let { locationId  } = param;
    const i18n = (0,ni18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)();
    const saucLocsBody = i18n.t("Southern Arizona Urgent Care is now powered by Carbon Health to bring you even better care.");
    const med7Body = i18n.t("Med7 Urgent Care is now powered by Carbon Health to bring you even better care.");
    const locationBanners = {
        [_locations__WEBPACK_IMPORTED_MODULE_5__/* .LocationId.POPUP_BRANNON_SF */ .zI.POPUP_BRANNON_SF]: [
            {
                text: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ni18n__WEBPACK_IMPORTED_MODULE_2__/* .Trans */ .cC, {
                    children: [
                        "This location is relocating. Please book an appointment at one of our other",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "us gray800",
                            href: sfLocationsLink,
                            children: "San Francisco"
                        }),
                        " ",
                        "locations."
                    ]
                }),
                btnText: i18n.t("View Locations"),
                href: sfLocationsLink,
                type: "warning"
            }
        ],
        [_locations__WEBPACK_IMPORTED_MODULE_5__/* .LocationId.LA_COSTA */ .zI.LA_COSTA]: [
            {
                text: i18n.t("La Costa Urgent Care is now Carbon Health")
            }
        ],
        [_locations__WEBPACK_IMPORTED_MODULE_5__/* .LocationId.SANTA_ANA */ .zI.SANTA_ANA]: [
            {
                text: i18n.t("Coastline Urgent Care is now Carbon Health")
            }
        ],
        [_locations__WEBPACK_IMPORTED_MODULE_5__/* .LocationId.MOBILE_ALABAMA */ .zI.MOBILE_ALABAMA]: [
            {
                text: i18n.t("Hillcrest Urgent Care is now Carbon Health")
            }
        ],
        [_locations__WEBPACK_IMPORTED_MODULE_5__/* .LocationId.SUNNYVALE */ .zI.SUNNYVALE]: [
            {
                text: i18n.t("Elite Medical is now Carbon Health")
            }
        ],
        [_locations__WEBPACK_IMPORTED_MODULE_5__/* .LocationId.HILLS_PLAZA */ .zI.HILLS_PLAZA]: [
            {
                type: "info",
                text: i18n.t("Due to the closing of our FiDi location, we are excited to welcome all former FiDi primary care patients to Hills Plaza.")
            }
        ],
        [_locations__WEBPACK_IMPORTED_MODULE_5__/* .LocationId.ATASCOCITA_TEXAS */ .zI.ATASCOCITA_TEXAS]: [
            {
                text: i18n.t("Urgent Care Mds - Atascocita is now Carbon Health")
            }
        ],
        [_locations__WEBPACK_IMPORTED_MODULE_5__/* .LocationId.LITTLETON_COLORADO */ .zI.LITTLETON_COLORADO]: [
            {
                text: i18n.t("Urgent Care of CO is now Carbon Health")
            }
        ],
        [_locations__WEBPACK_IMPORTED_MODULE_5__/* .LocationId.LONG_BEACH */ .zI.LONG_BEACH]: [
            {
                text: i18n.t("Urgent Care Plus is now Carbon Health")
            }
        ],
        ..._locations__WEBPACK_IMPORTED_MODULE_5__/* .saucLocIds.reduce */ .WP.reduce((acc, id)=>acc.assign({
                [id]: [
                    {
                        text: saucLocsBody
                    }
                ]
            }), {}),
        ..._locations__WEBPACK_IMPORTED_MODULE_5__/* .med7LocationIds.reduce */ .SE.reduce((acc, id)=>acc.assign({
                [id]: [
                    {
                        text: med7Body
                    }
                ]
            }), {}),
        ..._locations__WEBPACK_IMPORTED_MODULE_5__/* .elCaminoLocIds.reduce */ .yX.reduce((acc, id)=>acc.assign({
                [id]: [
                    {
                        startTime: elCaminoDisabledTime,
                        type: "warning",
                        href: src_components_common_constants__WEBPACK_IMPORTED_MODULE_4__/* .v5Pages.locations */ .Td.locations,
                        btnText: i18n.t("Find a Carbon Health Clinic Near You"),
                        text: i18n.t("Carbon Health is no longer operating out of this clinic.")
                    }
                ]
            }), {}),
        [_locations__WEBPACK_IMPORTED_MODULE_5__/* .LocationId.NEWBURY_PARK */ .zI.NEWBURY_PARK]: [
            {
                text: i18n.t("Newbury Park Urgent Care is now powered by Carbon Health to bring you even better care."),
                logo: {
                    src: "newburyParkLogo",
                    extension: "svg",
                    alt: i18n.t("Logo for Newbury Park."),
                    width: 400
                }
            }
        ],
        [_locations__WEBPACK_IMPORTED_MODULE_5__/* .LocationId.HIALEAH */ .zI.HIALEAH]: [
            {
                text: i18n.t("Ritecare Urgent Care is now powered by Carbon Health to bring you even better care."),
                logo: {
                    src: "ritecare-logo",
                    extension: "svg",
                    alt: i18n.t("Ritecare Urgent Care")
                }
            }
        ],
        [_locations__WEBPACK_IMPORTED_MODULE_5__/* .LocationId.BROOKLYN */ .zI.BROOKLYN]: [
            {
                text: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ni18n__WEBPACK_IMPORTED_MODULE_2__/* .Trans */ .cC, {
                    children: [
                        "Our Brooklyn COVID-19 testing clinic will be closed from 10/3 to 10/10 for renovations. It will reopen on 10/11. In the meantime, you can check out our other New York clinics",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: src_components_common_constants__WEBPACK_IMPORTED_MODULE_4__/* .v5Pages.locations */ .Td.locations,
                            children: "HERE"
                        }),
                        "."
                    ]
                }),
                startTime: 1632891600000,
                endTime: 1633928400000,
                type: "info"
            }
        ],
        [_locations__WEBPACK_IMPORTED_MODULE_5__/* .LocationId.SAN_CLEMENTE_HYBRID_MD */ .zI.SAN_CLEMENTE_HYBRID_MD]: [
            {
                text: i18n.t("Hybrid MD Urgent Care is now powered by Carbon Health to bring you even better care."),
                logo: {
                    src: "hybrid-md-logo",
                    extension: "svg",
                    width: 300,
                    height: 60
                }
            }
        ],
        [_locations__WEBPACK_IMPORTED_MODULE_5__/* .LocationId.MY_INSTADOC_MONROE */ .zI.MY_INSTADOC_MONROE]: [
            {
                text: i18n.t("My InstaDoc Urgent Care is now powered by Carbon Health to bring you even better care."),
                logo: {
                    src: "my-instadoc-logo",
                    width: 400,
                    height: 60,
                    extension: "png",
                    objectFit: "cover"
                }
            }
        ],
        [_locations__WEBPACK_IMPORTED_MODULE_5__/* .LocationId.CENTRAL_NEW_JERSEY_SKILLMAN */ .zI.CENTRAL_NEW_JERSEY_SKILLMAN]: [
            {
                text: i18n.t("Central New Jersey Urgent Care is now powered by Carbon Health to bring you even better care."),
                logo: {
                    src: "cjuc-logo",
                    width: 400,
                    height: 60,
                    extension: "png",
                    objectFit: "cover"
                }
            }
        ],
        [_locations__WEBPACK_IMPORTED_MODULE_5__/* .LocationId.DRESHER_PA */ .zI.DRESHER_PA]: [
            {
                text: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ni18n__WEBPACK_IMPORTED_MODULE_2__/* .Trans */ .cC, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "fw4 maxw44",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "fw7",
                                children: "This clinic is not yet in-network with most private insurance companies."
                            }),
                            " ",
                            "We can offer self-pay rates or courtesy bill your insurance. However, this might mean a higher fee or co-pay than you typically pay."
                        ]
                    })
                }),
                btnText: i18n.t("Questions? Call {{phone}}", {
                    phone: "(267) 434-1107"
                }),
                href: "tel:(267) 434-1107",
                type: "warning"
            }
        ],
        [_locations__WEBPACK_IMPORTED_MODULE_5__/* .LocationId.RICHMOND_VA_CARYTOWN */ .zI.RICHMOND_VA_CARYTOWN]: [
            {
                text: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ni18n__WEBPACK_IMPORTED_MODULE_2__/* .Trans */ .cC, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "fw4 maxw44",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "fw7",
                                children: "This clinic is not yet in-network with most private insurance companies."
                            }),
                            " ",
                            "We can offer self-pay rates or courtesy bill your insurance. However, this might mean a higher fee or co-pay than you typically pay."
                        ]
                    })
                }),
                btnText: i18n.t("Questions? Call {{phone}}", {
                    phone: "(434) 201-2342"
                }),
                href: "tel:(434) 201-2342",
                type: "warning"
            }
        ],
        [_locations__WEBPACK_IMPORTED_MODULE_5__/* .LocationId.COLUMBUS_OH_EASTON */ .zI.COLUMBUS_OH_EASTON]: [
            {
                text: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ni18n__WEBPACK_IMPORTED_MODULE_2__/* .Trans */ .cC, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "fw4 maxw44",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "fw7",
                                children: "This clinic is not yet in-network with most private insurance companies."
                            }),
                            " ",
                            "We can offer self-pay rates or courtesy bill your insurance. However, this might mean a higher fee or co-pay than you typically pay."
                        ]
                    })
                }),
                btnText: i18n.t("Questions? Call {{phone}}", {
                    phone: "(740) 268-2656"
                }),
                href: "tel:(740) 268-2656",
                type: "warning"
            }
        ],
        [_locations__WEBPACK_IMPORTED_MODULE_5__/* .LocationId.COLUMBUS_OH_THE_SHOPS */ .zI.COLUMBUS_OH_THE_SHOPS]: [
            {
                text: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ni18n__WEBPACK_IMPORTED_MODULE_2__/* .Trans */ .cC, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "fw4 maxw44",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "fw7",
                                children: "This clinic is not yet in-network with most private insurance companies."
                            }),
                            " ",
                            "We can offer self-pay rates or courtesy bill your insurance. However, this might mean a higher fee or co-pay than you typically pay."
                        ]
                    })
                }),
                btnText: i18n.t("Questions? Call {{phone}}", {
                    phone: "(740) 268-2618"
                }),
                href: "tel:(740) 268-2618",
                type: "warning"
            }
        ]
    };
    const banners = locationBanners[locationId] || [];
    const locationLogos = [
        {
            ids: _locations__WEBPACK_IMPORTED_MODULE_5__/* .stMarysLocIds */ .Kw,
            html: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "df aic fs24 font-cm fw5 mt-2 mt0-sm fs14-sm",
                children: [
                    "With",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "df aic mh1 w5-sm",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_NextImage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            className: "db",
                            src: "stMarysLogo",
                            extension: "png",
                            alt: "",
                            width: 32,
                            height: 32
                        })
                    }),
                    "Saint Mary's Regional Medical Center"
                ]
            })
        },
        {
            ids: _locations__WEBPACK_IMPORTED_MODULE_5__/* .saucLocIds */ .WP,
            src: "sauc-logo",
            ext: "svg",
            width: 300,
            height: 60
        },
        {
            ids: _locations__WEBPACK_IMPORTED_MODULE_5__/* .med7LocationIds */ .SE,
            src: "med7-logo",
            ext: "svg",
            width: 300,
            height: 60
        },
        {
            ids: _locations__WEBPACK_IMPORTED_MODULE_5__/* .johnMuirLocIds */ .fU,
            html: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "db fs24 font-cm fw5",
                children: i18n.t("A John Muir Health Partner")
            })
        }
    ];
    const logo = locationLogos.find((logos)=>logos.ids.includes(locationId));
    // @ts-expect-error TS2322: Type 'PartnerLogoType | undefined' is not assignable to type 'PartnerLogoType'.
    return {
        banners,
        logo
    };
};
/* harmony default export */ __webpack_exports__["ZP"] = (useLocationConstants);


/***/ }),

/***/ 94700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ CareSlug; }
/* harmony export */ });
var CareSlug;
(function(CareSlug) {
    CareSlug["PRIMARY_CARE"] = "primary-care";
    CareSlug["ANNUAL_PHYSICAL"] = "annual-physical";
    CareSlug["WOMENS_HEALTH"] = "womens-health";
    CareSlug["EAR_ACHE"] = "ear-ache";
    CareSlug["WELLNESS_VISIT"] = "wellness-visit";
    CareSlug["LGBTQ_HEALTH"] = "lgbtq-health-and-wellness";
    CareSlug["EXISTING_CONDITION"] = "existing-condition";
    CareSlug["CONTRACEPTION"] = "visit-for-contraception";
    CareSlug["STI"] = "sti-test";
    CareSlug["SPORTS_PHYSICAL"] = "sports-physical-exam";
    CareSlug["URGENT_CARE"] = "urgent-care";
    CareSlug["COLD_AND_FLU"] = "cold-flu-symptoms";
    CareSlug["INJURY"] = "injury";
    CareSlug["RASH"] = "rash";
    CareSlug["URINARY_TRACT_INFECTION"] = "urinary-tract-infection";
    CareSlug["ABDOMINAL_PAIN"] = "abdominal-pain";
    CareSlug["COVID_CARE"] = "covid-care";
    CareSlug["COVID_SICK_VISIT"] = "covid-sick-visit";
    CareSlug["COVID_EXPOSURE_SCREENING"] = "covid-exposure-screening";
    CareSlug["COVID_TESTING"] = "covid-19-testing";
    CareSlug["COVID_TREATMENT"] = "covid-treatment";
    CareSlug["COVID_VACCINATION"] = "covid-19-vaccination";
    CareSlug["COVID_TRAVEL_TESTING"] = "covid-19-travel-testing";
    CareSlug["SAME_DAY_RT_PCR"] = "same-day-rt-pcr";
    CareSlug["SAME_DAY_ANTIGEN"] = "same-day-antigen";
    CareSlug["SAME_DAY_NAAT"] = "same-day-naat";
    CareSlug["NEXT_DAY_RT_PCR"] = "next-day-rt-pcr";
    CareSlug["WORKPLACE_HEALTH"] = "workplace-health";
    CareSlug["SORE_THROAT"] = "sore-throat";
    CareSlug["FAMILY_PLANNING"] = "family-planning";
})(CareSlug || (CareSlug = {}));


/***/ }),

/***/ 96821:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ([
    {
        slug: "illinois",
        name: "Illinois",
        latitude: 41.8336479,
        longitude: -87.8720463
    },
    {
        slug: "connecticut",
        name: "Connecticut",
        latitude: 41.2982831,
        longitude: -72.9641152
    },
    {
        slug: "georgia",
        name: "Georgia",
        latitude: 33.7676931,
        longitude: -84.4906437
    },
    {
        slug: "michigan",
        name: "Michigan",
        latitude: 42.3526897,
        longitude: -83.1692445
    },
    {
        slug: "north-carolina",
        name: "North Carolina",
        latitude: 35.2028147,
        longitude: -81.1269099
    }
]);


/***/ }),

/***/ 63871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useExtendCareEntries; },
/* harmony export */   "l": function() { return /* binding */ useResultExtensions; }
/* harmony export */ });
/* harmony import */ var ni18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76361);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var _constants_apptReasons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4063);
/* harmony import */ var _constants_cares__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94700);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40367);





/**
 * This is a hopefully* temporary utility function to enhance reason UI.
 * Icons should be updated in database instead of being overwritten like this.
 * Price and turnaround should also be dynamic.
 */ const useResultExtensions = ()=>{
    const i18n = (0,ni18n__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)();
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>({
            [_constants_cares__WEBPACK_IMPORTED_MODULE_3__/* .CareSlug.FAMILY_PLANNING */ .s.FAMILY_PLANNING]: {
                icon: "child"
            },
            [_constants_cares__WEBPACK_IMPORTED_MODULE_3__/* .CareSlug.SORE_THROAT */ .s.SORE_THROAT]: {
                icon: "sore-throat"
            },
            [_constants_cares__WEBPACK_IMPORTED_MODULE_3__/* .CareSlug.WORKPLACE_HEALTH */ .s.WORKPLACE_HEALTH]: {
                icon: "worker-with-heart"
            },
            [_constants_cares__WEBPACK_IMPORTED_MODULE_3__/* .CareSlug.EAR_ACHE */ .s.EAR_ACHE]: {
                icon: "ear"
            },
            [_constants_cares__WEBPACK_IMPORTED_MODULE_3__/* .CareSlug.PRIMARY_CARE */ .s.PRIMARY_CARE]: {
                icon: "doc-with-stethoscope"
            },
            [_constants_cares__WEBPACK_IMPORTED_MODULE_3__/* .CareSlug.URGENT_CARE */ .s.URGENT_CARE]: {
                icon: "shield-and-cross"
            },
            [_constants_cares__WEBPACK_IMPORTED_MODULE_3__/* .CareSlug.ANNUAL_PHYSICAL */ .s.ANNUAL_PHYSICAL]: {
                icon: "calendar-heart"
            },
            [_constants_cares__WEBPACK_IMPORTED_MODULE_3__/* .CareSlug.WOMENS_HEALTH */ .s.WOMENS_HEALTH]: {
                icon: "person-with-heart"
            },
            [_constants_cares__WEBPACK_IMPORTED_MODULE_3__/* .CareSlug.COLD_AND_FLU */ .s.COLD_AND_FLU]: {
                icon: "cup-of-tea"
            },
            [_constants_cares__WEBPACK_IMPORTED_MODULE_3__/* .CareSlug.INJURY */ .s.INJURY]: {
                icon: "arm-in-sling"
            },
            [_constants_cares__WEBPACK_IMPORTED_MODULE_3__/* .CareSlug.RASH */ .s.RASH]: {
                icon: "chest-rash"
            },
            [_constants_cares__WEBPACK_IMPORTED_MODULE_3__/* .CareSlug.URINARY_TRACT_INFECTION */ .s.URINARY_TRACT_INFECTION]: {
                icon: "uterus"
            },
            [_constants_cares__WEBPACK_IMPORTED_MODULE_3__/* .CareSlug.ABDOMINAL_PAIN */ .s.ABDOMINAL_PAIN]: {
                icon: "tummy-ache"
            },
            [_constants_cares__WEBPACK_IMPORTED_MODULE_3__/* .CareSlug.COVID_CARE */ .s.COVID_CARE]: {
                icon: "covid-19-virus"
            },
            [_constants_cares__WEBPACK_IMPORTED_MODULE_3__/* .CareSlug.COVID_EXPOSURE_SCREENING */ .s.COVID_EXPOSURE_SCREENING]: {
                icon: "icon-microscope",
                turnaround: i18n.t("Results same-day"),
                price: i18n.t("Covered by insurance")
            },
            [_constants_cares__WEBPACK_IMPORTED_MODULE_3__/* .CareSlug.COVID_TESTING */ .s.COVID_TESTING]: {
                icon: "flu-screening"
            },
            [_constants_cares__WEBPACK_IMPORTED_MODULE_3__/* .CareSlug.COVID_TREATMENT */ .s.COVID_TREATMENT]: {
                icon: "covid-19-virus"
            },
            [_constants_cares__WEBPACK_IMPORTED_MODULE_3__/* .CareSlug.COVID_VACCINATION */ .s.COVID_VACCINATION]: {
                icon: "syringe"
            },
            [_constants_cares__WEBPACK_IMPORTED_MODULE_3__/* .CareSlug.SAME_DAY_NAAT */ .s.SAME_DAY_NAAT]: {
                icon: "rapid-hepatitis-c-screening",
                turnaround: i18n.t("Results same-day"),
                price: i18n.t("$150-200")
            },
            [_constants_apptReasons__WEBPACK_IMPORTED_MODULE_2__/* .ApptReasonId.COVID_SICK_VISIT */ .xT.COVID_SICK_VISIT]: {
                icon: "general-surgery",
                turnaround: i18n.t("Results same-day"),
                price: i18n.t("Covered by insurance")
            },
            [_constants_apptReasons__WEBPACK_IMPORTED_MODULE_2__/* .ApptReasonId.COVID_VAX_FIRST_DOSE */ .xT.COVID_VAX_FIRST_DOSE]: {
                icon: "syringe"
            },
            [_constants_apptReasons__WEBPACK_IMPORTED_MODULE_2__/* .ApptReasonId.COVID_VAX_SECOND_DOSE */ .xT.COVID_VAX_SECOND_DOSE]: {
                icon: "syringe"
            },
            [_constants_apptReasons__WEBPACK_IMPORTED_MODULE_2__/* .ApptReasonId.COVID_VAX_ADDITIONAL_DOSE */ .xT.COVID_VAX_ADDITIONAL_DOSE]: {
                icon: "syringe"
            },
            [_constants_apptReasons__WEBPACK_IMPORTED_MODULE_2__/* .ApptReasonId.COVID_TESTING_NO_SYMPTOMS */ .xT.COVID_TESTING_NO_SYMPTOMS]: {
                icon: "lab-testing2",
                turnaround: i18n.t("Results same-day"),
                price: i18n.t("Covered by insurance")
            },
            [_constants_apptReasons__WEBPACK_IMPORTED_MODULE_2__/* .ApptReasonId.COVID_TRAVEL_CLEARANCE_TESTING */ .xT.COVID_TRAVEL_CLEARANCE_TESTING]: {
                icon: "rapid-hepatitis-c-screening",
                turnaround: i18n.t("Results same-day"),
                price: "$150 - 250"
            },
            [_constants_apptReasons__WEBPACK_IMPORTED_MODULE_2__/* .ApptReasonId.NEXT_DAY_RT_PCR */ .xT.NEXT_DAY_RT_PCR]: {
                icon: "lab-testing2",
                turnaround: i18n.t("Results 2pm next day"),
                price: "$150-250"
            },
            [_constants_apptReasons__WEBPACK_IMPORTED_MODULE_2__/* .ApptReasonId.SAME_DAY_ANTIGEN */ .xT.SAME_DAY_ANTIGEN]: {
                icon: "rapid-hepatitis-c-screening",
                turnaround: i18n.t("Results same-day"),
                price: "$60"
            },
            [_constants_apptReasons__WEBPACK_IMPORTED_MODULE_2__/* .ApptReasonId.SAME_DAY_RT_PCR */ .xT.SAME_DAY_RT_PCR]: {
                icon: "rapid-hepatitis-c-screening",
                turnaround: i18n.t("Results same-day"),
                price: "$150 - 200"
            },
            [_constants_apptReasons__WEBPACK_IMPORTED_MODULE_2__/* .ApptReasonId.COVID_I_TESTED_POSITIVE */ .xT.COVID_I_TESTED_POSITIVE]: {
                price: i18n.t("Covered by insurance")
            },
            [_constants_apptReasons__WEBPACK_IMPORTED_MODULE_2__/* .ApptReasonId.VIRTUAL_COVID_19_VISIT */ .xT.VIRTUAL_COVID_19_VISIT]: {
                price: i18n.t("Covered by insurance")
            }
        }), [
        i18n
    ]);
};
const useExtendCareEntries = (careEntries)=>{
    const extensions = useResultExtensions();
    const { reasons =[]  } = (0,_store__WEBPACK_IMPORTED_MODULE_4__/* .useTypedSelector */ .ix)((state)=>state.config);
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return careEntries.map((careEntry)=>{
            var _reasons_find;
            const idKey = typeof careEntry.appointment_reason === "string" ? careEntry.appointment_reason : "";
            const idExtension = extensions[idKey] || {};
            const slugExtension = extensions[careEntry.slug] || {};
            const extendedResult = {
                ...careEntry,
                ...slugExtension,
                ...idExtension
            };
            const icon = extendedResult.icon || ((_reasons_find = reasons === null || reasons === void 0 ? void 0 : reasons.find((reason)=>reason.slug === careEntry.slug)) === null || _reasons_find === void 0 ? void 0 : _reasons_find.iconName) || // This is a hack for the plane icon, so its the same as in the modal.
            // TODO > Needs refactoring when the CMS is properly configured. > GROWTHRND-931
            careEntry.slug === "covid-19-travel-testing" && "flight" || undefined;
            return {
                ...extendedResult,
                icon
            };
        });
    }, [
        careEntries,
        extensions,
        reasons
    ]);
};


/***/ }),

/***/ 33437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useClientSideId; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32466);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56722);


/**
 * Returns `undefined` on first client and server render.
 * Use to prevent react hydration errors.
 * @returns a random v4 UUID
 */ const useClientSideId = ()=>{
    const [state, setState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        setState((0,uuid__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)());
    }, []);
    return state;
};


/***/ }),

/***/ 59640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useCurrentRoute; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21395);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);

function useCurrentRoute() {
    var _router_asPath;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    if ((router === null || router === void 0 ? void 0 : router.asPath) === "/") return "index";
    return router === null || router === void 0 ? void 0 : (_router_asPath = router.asPath) === null || _router_asPath === void 0 ? void 0 : _router_asPath.slice(1);
}


/***/ }),

/***/ 15343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useFeatureFlag; }
/* harmony export */ });
/* harmony import */ var src_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40367);

function useFeatureFlag(flagName) {
    return (0,src_store__WEBPACK_IMPORTED_MODULE_0__/* .useTypedSelector */ .ix)((state)=>state.featureFlags[flagName]);
}


/***/ }),

/***/ 80366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ usePrefersReducedMotion; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32466);
/* harmony import */ var _utils_mediaQueries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11621);


const NO_MOTION_PREFERENCE = "(prefers-reduced-motion: no-preference)";
/**
 * Accessbility hook, detects user-prefers-reduced-motion. Default to
 * `true` since we don't know what the user's preference is on the server.
 */ const usePrefersReducedMotion = ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const mediaQueryList = window.matchMedia(NO_MOTION_PREFERENCE);
        setPrefersReducedMotion(!mediaQueryList.matches);
        const listener = (event)=>{
            setPrefersReducedMotion(!event.matches);
        };
        (0,_utils_mediaQueries__WEBPACK_IMPORTED_MODULE_1__/* .addListenerSafe */ .D)(mediaQueryList, listener);
        return ()=>{
            (0,_utils_mediaQueries__WEBPACK_IMPORTED_MODULE_1__/* .removeListenerSafe */ .n)(mediaQueryList, listener);
        };
    }, []);
    return prefersReducedMotion;
};


/***/ }),

/***/ 77230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P8": function() { return /* binding */ getSoonestVirtualSlot; },
/* harmony export */   "cO": function() { return /* binding */ useSoonestVirtualSlotInState; },
/* harmony export */   "wH": function() { return /* binding */ getVirtualSpecialtyIds; }
/* harmony export */ });
/* unused harmony export orderVirtualSpecialtyIds */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32466);
/* harmony import */ var src_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40367);
/* harmony import */ var src_store_slices_userLocation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36330);
/* harmony import */ var _constants_specialtyIds__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93209);
/* harmony import */ var _utils_fetchCachedSlot__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32570);
/* harmony import */ var _utils_stateUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83202);
/* harmony import */ var _useQueryController__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75290);







const orderVirtualSpecialtyIds = (ids)=>[
        ids[ids.indexOf(_constants_specialtyIds__WEBPACK_IMPORTED_MODULE_3__/* .SpecialtyId.VIRTUAL_URGENT_CARE */ .mg.VIRTUAL_URGENT_CARE)],
        ids[ids.indexOf(_constants_specialtyIds__WEBPACK_IMPORTED_MODULE_3__/* .SpecialtyId.VIRTUAL_PRIMARY_CARE */ .mg.VIRTUAL_PRIMARY_CARE)],
        ids[ids.indexOf(_constants_specialtyIds__WEBPACK_IMPORTED_MODULE_3__/* .SpecialtyId.VIRTUAL_MENTAL_HEALTH */ .mg.VIRTUAL_MENTAL_HEALTH)]
    ].compact();
const getVirtualSpecialtyIds = (apptReason)=>orderVirtualSpecialtyIds(apptReason.specialtyIds.filter((id)=>_constants_specialtyIds__WEBPACK_IMPORTED_MODULE_3__/* .virtualSpecialtyIds.includes */ .A.includes(id)));
/**
 * Attempts to find slots, specialty by specialty in the provided state in order of ids given
 * @param virtualIds virtual specialty ids in order to check
 * @param state only slots with doctors licensed in this state will be returned
 */ const getSoonestVirtualSlot = function(virtualIds, state) {
    let availabilityEnabled = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    return availabilityEnabled ? virtualIds.reduce(async (maybeSlot, specialtyId)=>await maybeSlot || (0,_utils_fetchCachedSlot__WEBPACK_IMPORTED_MODULE_4__/* .fetchCachedSlot */ .P)({
            specialtyId,
            selectedState: state
        }), Promise.resolve(null)) : Promise.resolve(null);
};
const useSoonestVirtualSlotInState = (specialtyIds)=>{
    const selectedRegion = (0,src_store__WEBPACK_IMPORTED_MODULE_1__/* .useTypedSelector */ .ix)(src_store_slices_userLocation__WEBPACK_IMPORTED_MODULE_2__/* .selectSelectedRegion */ .dz);
    const state = (0,_utils_stateUtils__WEBPACK_IMPORTED_MODULE_5__/* .getStateCodeFromRegionSlug */ .GZ)(selectedRegion);
    const fn = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>getSoonestVirtualSlot(specialtyIds, state || "CA"), [
        specialtyIds,
        state
    ]);
    return (0,_useQueryController__WEBPACK_IMPORTED_MODULE_6__/* .useQueryController */ .co)({
        fn,
        cacheKey: state || "CA",
        skip: !state,
        ifRejectedValue: null,
        initialValue: null
    });
};


/***/ }),

/***/ 84684:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ getRegionSlug; }
/* harmony export */ });
// use this to validate type
const getRegionSlug = (slug)=>slug;


/***/ }),

/***/ 31218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32466);

const useScroll = ()=>{
    const isDomLoaded = !( false || !window.document);
    const [scroll, setScroll] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        x: isDomLoaded ? document.body.getBoundingClientRect().left : 0,
        y: isDomLoaded ? document.body.getBoundingClientRect().top : 0,
        direction: null
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const listener = ()=>{
            const boundingClientRect = document.body.getBoundingClientRect();
            setScroll((prev)=>({
                    x: boundingClientRect.left,
                    y: boundingClientRect.top,
                    direction: prev.y < boundingClientRect.top ? "up" : "down"
                }));
        };
        window.addEventListener("scroll", listener, {
            passive: true
        });
        return ()=>{
            window.removeEventListener("scroll", listener);
        };
    }, [
        setScroll
    ]);
    return scroll;
};
/* harmony default export */ __webpack_exports__["Z"] = (useScroll);


/***/ }),

/***/ 82546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ analytics; }
/* harmony export */ });
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3607);
/* harmony import */ var src_components_common_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93932);
/* harmony import */ var _fetch_fetches__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54428);
/* harmony import */ var _promise_tee__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35721);




const label = {
    SELECT_CLINIC: "SelectClinic",
    CLINIC_MAP: "ClinicMap",
    CLINIC_OPTIONS: "ClinicOptions",
    CLINIC_PHONE_NUMBER: "ClinicPhoneNumber",
    CLINIC_PHOTO: "ClinicPhoto",
    CONTACT_SUPPORT: "ContactSupport",
    SCHEDULING_WIDGET_FIRST_LOAD_TIME: "SchedulingWidgetFirstLoadTime",
    SCHEDULING_WIDGET_SLOT_LOAD_TIME: "SchedulingWidgetSlotLoadTime",
    APPOINTMENT_BOOKING_WEBSITE_WIDGET: "AppointmentBooking - WebsiteWidget",
    APPOINTMENT_BOOKING_REASON_WIDGET: "AppointmentBooking - ReasonWidget",
    APPOINTMENT_BOOKING_HOMEWIDGET: "AppointmentBooking - HomeWidget",
    APPOINTMENT_REASON: "AppointmentReason",
    LOCATION_INDEX_VIEW_SWITCH: "LocationIndexViewSwitch",
    COVID: "Covid",
    SERVICES: "Services",
    LOCATIONS: "Locations",
    COMPANY: "Company",
    MENU: "Menu",
    ACCOUNT: "Account",
    INSURANCES: "Insurances",
    LANGUAGES: "Languages",
    BOOKING: "Booking",
    APPOINTMENT_BOOKING_LOCATION_EXPLORER: "AppointmentBooking - LocationFooterWidget",
    AD_UNIT: "AdUnit",
    ADJUST_LOCATION: "AdjustLocation",
    REGION: "Region",
    REGION_DROP_DOWN: "RegionDropDown",
    APPT_REASON_OPTIONS: "ApptReasonOptions"
};
const category = {
    EXPERIMENT_ASSIGNMENT: "ExperimentAssignment",
    LOCATION_DISCOVERY: "LocationDiscovery",
    WEBSITE_PERFORMANCE: "WebsitePerformance",
    LOCATION_PAGE_INFO: "LocationPageInfo",
    APPOINTMENT_SCHEDULING: "AppointmentScheduling",
    WEBSITE_PAGE_CHANGED: "WebsitePageChanged",
    NAVIGATION_DISCOVERY: "NavigationDiscovery",
    SUPPORT: "Support",
    COVID_TESTING_MAP: "CovidTestingMap",
    REASON_DISCOVERY: "ReasonDiscovery"
};
const action = {
    CLICKED: "Clicked",
    VIEWED: "Viewed",
    LOADED: "Loaded",
    SCROLLED: "Scrolled",
    SEARCHED: "Searched"
};
const post = (param)=>{
    let { extraData ={} , req , ...data } = param;
    const domain = (0,src_components_common_constants__WEBPACK_IMPORTED_MODULE_0__/* .isBrowser */ .jU)() ? window.location.href : req === null || req === void 0 ? void 0 : req.headers.location;
    return (0,_fetch_fetches__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)()("/hib/event-tracking", {
        method: "POST",
        body: JSON.stringify({
            ...data,
            extraData: JSON.stringify({
                domain,
                platform: "web",
                ...extraData
            })
        })
    }).then((0,_promise_tee__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((res)=>{
        if (res.status !== 200) {
            const msg = 'endpoint: /hib/event-tracking" failed';
            ;
            _sentry_nextjs__WEBPACK_IMPORTED_MODULE_3__/* .captureException */ .Tb(msg);
        }
    }));
};
const analytics = {
    category,
    action,
    label,
    post
};


/***/ }),

/***/ 39815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* binding */ fetchCachedSlotAround; }
});

// EXTERNAL MODULE: ./src/utils/fetchCachedSlot.ts + 2 modules
var fetchCachedSlot = __webpack_require__(32570);
// EXTERNAL MODULE: ./src/utils/filterLocationsBySpecialtyId.ts
var filterLocationsBySpecialtyId = __webpack_require__(83821);
// EXTERNAL MODULE: ./public/static/data/localSpecialties.json
var localSpecialties = __webpack_require__(61005);
// EXTERNAL MODULE: ./node_modules/memoizee/index.js
var memoizee = __webpack_require__(37453);
var memoizee_default = /*#__PURE__*/__webpack_require__.n(memoizee);
;// CONCATENATED MODULE: ./src/utils/isVirtual.ts


const isVirtual = memoizee_default()((specialtyId)=>{
    var _localSpecialties_findById;
    return ((_localSpecialties_findById = localSpecialties.findById(specialtyId)) === null || _localSpecialties_findById === void 0 ? void 0 : _localSpecialties_findById.isVirtual) || false;
});

;// CONCATENATED MODULE: ./src/utils/fetchCachedSlotAround.ts



// eg:
// fetchCachedSlotAround({locations, specialtyId: SpecialtyId.URGENT_CARE, locationCount: 5})
// use this only for clinics ,no virtual
const fetchCachedSlotAround = (args)=>{
    const { locations , specialtyId , locationCount =3  } = args;
    // @ts-expect-error TS2345: Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    const locationsWithSpecialtyId = isVirtual(specialtyId) ? [
        locations === null || locations === void 0 ? void 0 : locations[0]
    ] : (0,filterLocationsBySpecialtyId/* filterLocationsBySpecialtyId */.N)(locations, specialtyId, locationCount);
    // @ts-expect-error TS2322: Type 'Promise<Partial<ApptSlot> | {} | undefined>' is not assignable to type 'Promise<Partial<ApptSlot>>'.
    return locationsWithSpecialtyId.map((location)=>(0,fetchCachedSlot/* fetchCachedSlot */.P)({
            ...args,
            locationId: location.id
        })).sequence().then((slots)=>{
        return (slots === null || slots === void 0 ? void 0 : slots.length) ? slots.sortBy((slot)=>{
            return slot === null || slot === void 0 ? void 0 : slot.time;
        })[0] : {};
    });
};


/***/ }),

/***/ 42091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ fetchCities; }
/* harmony export */ });
/* harmony import */ var memoizee__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37453);
/* harmony import */ var memoizee__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(memoizee__WEBPACK_IMPORTED_MODULE_0__);

const _fetchCities = ()=>fetch("/static/data/cities.json").then((r)=>r.json());
const fetchCities = memoizee__WEBPACK_IMPORTED_MODULE_0___default()(_fetchCities, {
    promise: true
});


/***/ }),

/***/ 37059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ fetchPricingData; }
/* harmony export */ });
/* harmony import */ var isomorphic_fetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51396);
/* harmony import */ var isomorphic_fetch__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(isomorphic_fetch__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var memoizee__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37453);
/* harmony import */ var memoizee__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(memoizee__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_common_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93932);



const fetchPricingData = memoizee__WEBPACK_IMPORTED_MODULE_1___default()(()=>fetch(_components_common_constants__WEBPACK_IMPORTED_MODULE_2__/* .dev */ .WI ? _components_common_constants__WEBPACK_IMPORTED_MODULE_2__/* .pricingWorkerUrls.dev */ .iL.dev : _components_common_constants__WEBPACK_IMPORTED_MODULE_2__/* .pricingWorkerUrls.prod */ .iL.prod).then((res)=>res.json()).catch(()=>{
        const tier1 = __webpack_require__.e(/* import() */ 383).then(__webpack_require__.t.bind(__webpack_require__, 383, 19)).then((module)=>module.default);
        const tier2 = __webpack_require__.e(/* import() */ 6750).then(__webpack_require__.t.bind(__webpack_require__, 96750, 19)).then((module)=>module.default);
        const tier3 = __webpack_require__.e(/* import() */ 5746).then(__webpack_require__.t.bind(__webpack_require__, 5746, 19)).then((module)=>module.default);
        return Promise.all([
            tier1,
            tier2,
            tier3
        ]).then((res)=>{
            const [tier1, tier2, tier3] = res;
            return {
                tier1,
                tier2,
                tier3
            };
        });
    }));


/***/ }),

/***/ 65597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ fetchSoonestSlotByLocationsAndSpecialtyIds; }
/* harmony export */ });
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50995);
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment_timezone__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _services_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95832);
/* harmony import */ var _components_common_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93932);



const fetchSoonestSlotByLocationsAndSpecialtyIds = (param)=>{
    let { locations , specialtyIds , daysCount =21 , specialtyCount =1  } = param;
    const now = +moment_timezone__WEBPACK_IMPORTED_MODULE_0___default()();
    return locations.map((l)=>{
        const sortedSpecialties = l.specialties.vals().sortBy("sortIndex").slice(0, specialtyCount);
        return (specialtyIds || sortedSpecialties.map((s)=>s.id) // if specialIds param is null, try with first specialtyId
        ).map((sId)=>{
            const isSpecialtyInList = l.specialtyIds.includes(sId);
            // if location doesn't have ids in specialIds doesn't exist, try with first specialtyId
            const newSpecialtyId = isSpecialtyInList ? sId : sortedSpecialties[0].id;
            const { defaultNewPatientApptDuration: duration = 10 , apptLeadTime =0  } = l.specialties[newSpecialtyId];
            const from = (apptLeadTime * _components_common_constants__WEBPACK_IMPORTED_MODULE_2__/* .millisPerMinute */ .NM || 0) < 0 ? now : now + apptLeadTime; // check if from is in past
            return (0,_services_api__WEBPACK_IMPORTED_MODULE_1__/* .loadAvailableSlots */ .vk)({
                practiceId: l.practiceId,
                locationId: l.id,
                from,
                to: +moment_timezone__WEBPACK_IMPORTED_MODULE_0___default()(now).add(daysCount, "days").endOf("day"),
                duration,
                specialtyId: newSpecialtyId,
                timezone: l.timezone || _components_common_constants__WEBPACK_IMPORTED_MODULE_2__/* .laTimezone */ .$A
            }).then((slotTimes)=>{
                var _slotTimes_, _slotTimes__;
                return {
                    lId: l.id,
                    sId,
                    slotTime: slotTimes === null || slotTimes === void 0 ? void 0 : (_slotTimes_ = slotTimes[0]) === null || _slotTimes_ === void 0 ? void 0 : (_slotTimes__ = _slotTimes_[0]) === null || _slotTimes__ === void 0 ? void 0 : _slotTimes__.time
                };
            });
        }).sequence();
    }).sequence().then((locationsAndSlot)=>locationsAndSlot.flat().groupBy("lId").mapValues((slots)=>slots.groupBy("sId").mapValues((slots)=>slots[0].slotTime)));
};


/***/ }),

/***/ 83821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ filterLocationsBySpecialtyId; },
/* harmony export */   "e": function() { return /* binding */ doesLocationHaveASpecialtyId; }
/* harmony export */ });
const filterLocationsBySpecialtyId = function(locations, specialtyId) {
    let limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3;
    return locations.filter((l)=>l.specialtyIds.includes(specialtyId)).slice(0, limit);
};
const doesLocationHaveASpecialtyId = (specialtyIds)=>(location)=>location.specialtyIds.some((specialtyId)=>specialtyIds.includes(specialtyId));


/***/ }),

/***/ 67350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ getPricingTierByRegionSlug; }
});

// EXTERNAL MODULE: ./src/store/getRegionSlug.ts
var getRegionSlug = __webpack_require__(84684);
;// CONCATENATED MODULE: ./src/constants/regionsByPricingTier.ts

const regionsByPricingTiers = {
    tier1: [
        (0,getRegionSlug/* getRegionSlug */.x)("sf-bay-area")
    ],
    tier2: [
        (0,getRegionSlug/* getRegionSlug */.x)("los-angeles"),
        (0,getRegionSlug/* getRegionSlug */.x)("colorado"),
        (0,getRegionSlug/* getRegionSlug */.x)("florida"),
        (0,getRegionSlug/* getRegionSlug */.x)("nevada"),
        (0,getRegionSlug/* getRegionSlug */.x)("texas"),
        (0,getRegionSlug/* getRegionSlug */.x)("arizona"),
        (0,getRegionSlug/* getRegionSlug */.x)("washington"),
        (0,getRegionSlug/* getRegionSlug */.x)("missouri"),
        (0,getRegionSlug/* getRegionSlug */.x)("greater-san-diego"),
        (0,getRegionSlug/* getRegionSlug */.x)("orange-county"),
        (0,getRegionSlug/* getRegionSlug */.x)("san-luis-obispo"),
        (0,getRegionSlug/* getRegionSlug */.x)("inland-empire"),
        (0,getRegionSlug/* getRegionSlug */.x)("sacramento"),
        (0,getRegionSlug/* getRegionSlug */.x)("ohio"),
        (0,getRegionSlug/* getRegionSlug */.x)("pennsylvania"),
        (0,getRegionSlug/* getRegionSlug */.x)("massachusetts"),
        (0,getRegionSlug/* getRegionSlug */.x)("virginia")
    ],
    tier3: [
        (0,getRegionSlug/* getRegionSlug */.x)("alabama"),
        (0,getRegionSlug/* getRegionSlug */.x)("new-jersey")
    ]
};

;// CONCATENATED MODULE: ./src/utils/getPricingTierBySlug.ts

const DEFAULT_TIER = "tier2";
const getPricingTierByRegionSlug = (slug)=>{
    const result = Object.entries(regionsByPricingTiers).find((param)=>{
        let [, value] = param;
        return value.includes(slug);
    });
    if (!result) return DEFAULT_TIER;
    const [tier] = result;
    return tier;
};


/***/ }),

/***/ 55797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ isDeepEqual; }
/* harmony export */ });
/* harmony import */ var assert__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9889);
/* harmony import */ var assert__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(assert__WEBPACK_IMPORTED_MODULE_0__);

const isDeepEqual = (val1, val2)=>{
    try {
        assert__WEBPACK_IMPORTED_MODULE_0___default().deepStrictEqual(val1, val2);
        return true;
    } catch (e) {
        return false;
    }
};


/***/ }),

/***/ 10241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ locationsByRegion; },
/* harmony export */   "v": function() { return /* binding */ regionFilter; }
/* harmony export */ });
/* harmony import */ var _components_common_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93932);

const regionFilter = (region)=>(loc)=>loc.region.slug === region;
const locationsByRegion = (locations, selectedRegion)=>{
    if (!selectedRegion) return locations.filter((l)=>l.id !== _components_common_constants__WEBPACK_IMPORTED_MODULE_0__/* .mods.video */ .HT.video);
    return locations.filter((l)=>l.id !== _components_common_constants__WEBPACK_IMPORTED_MODULE_0__/* .mods.video */ .HT.video).filter(regionFilter(selectedRegion)) || [];
};


/***/ }),

/***/ 83202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "WY": function() { return /* binding */ getCityAndState; },
  "DX": function() { return /* binding */ getCityAndStatesOptions; },
  "K8": function() { return /* binding */ getStateCodeByName; },
  "GZ": function() { return /* binding */ getStateCodeFromRegionSlug; }
});

// EXTERNAL MODULE: ./node_modules/us-state-codes/index.js
var us_state_codes = __webpack_require__(14492);
var us_state_codes_default = /*#__PURE__*/__webpack_require__.n(us_state_codes);
;// CONCATENATED MODULE: ./src/constants/regionStateMap.ts
const RegionStateMap = {
    alabama: {
        state: "Alabama",
        code: "AL"
    },
    arizona: {
        state: "Arizona",
        code: "AZ"
    },
    colorado: {
        state: "Colorado",
        code: "CO"
    },
    connecticut: {
        state: "Connecticut",
        code: "CT"
    },
    florida: {
        state: "Florida",
        code: "FL"
    },
    georgia: {
        state: "Georgia",
        code: "GA"
    },
    "greater-san-diego": {
        state: "California",
        code: "CA"
    },
    illinois: {
        state: "Illinois",
        code: "IL"
    },
    kansas: {
        state: "Kansas",
        code: "KS"
    },
    "los-angeles": {
        state: "California",
        code: "CA"
    },
    massachusetts: {
        state: "Massachusetts",
        code: "MA"
    },
    michigan: {
        state: "Michigan",
        code: "MI"
    },
    missouri: {
        state: "Missouri",
        code: "MO"
    },
    "new-jersey": {
        state: "New Jersey",
        code: "NJ"
    },
    "north-carolina": {
        state: "North Carolina",
        code: "NC"
    },
    ohio: {
        state: "Ohio",
        code: "OH"
    },
    pennsylvania: {
        state: "Pennsylvania",
        code: "PA"
    },
    nevada: {
        state: "Nevada",
        code: "NV"
    },
    sacramento: {
        state: "California",
        code: "CA"
    },
    washington: {
        state: "Washington",
        code: "WA"
    },
    "sf-bay-area": {
        state: "California",
        code: "CA"
    },
    "inland-empire": {
        state: "California",
        code: "CA"
    },
    "orange-county": {
        state: "California",
        code: "CA"
    },
    "san-luis-obispo": {
        state: "California",
        code: "CA"
    },
    texas: {
        state: "Texas",
        code: "TX"
    },
    virginia: {
        state: "Virginia",
        code: "VA"
    }
};

// EXTERNAL MODULE: ./src/utils/fetchCities.ts
var fetchCities = __webpack_require__(42091);
;// CONCATENATED MODULE: ./src/utils/stateUtils.ts



const getStateCodeByName = function() {
    let name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return us_state_codes_default().getStateCodeByStateName(name.replace(/-/g, " ")) || "";
};
const getCityAndStatesOptions = async ()=>{
    const cityAndStates = await (0,fetchCities/* fetchCities */.g)();
    return cityAndStates.sortBy([
        "state",
        "city"
    ]).map((c)=>{
        const stCode = us_state_codes_default().getStateCodeByStateName(c.state);
        const ci = c.city;
        return [
            c.state,
            "".concat(ci, ", ").concat(stCode)
        ];
    }).flat().distinct();
};
/**
 *
 * @param cityAndState i.e. "San Francisco, CA" or "California"
 * @returns [city, state]
 */ const getCityAndState = (cityAndState)=>{
    if (!cityAndState) {
        return [
            null,
            null
        ];
    }
    const keyVals = cityAndState.split(",");
    const hasCity = keyVals.length > 1;
    const state = hasCity ? us_state_codes_default().getStateNameByStateCode(keyVals[1]) : keyVals[0];
    const city = hasCity ? keyVals[0] : null;
    return [
        city,
        state
    ];
};
const getStateCodeFromRegionSlug = (string)=>// @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Record<"new-york" | "los-angeles" | "greater-san-diego" | "seattle" | "florida" | "sf-bay-area" | "ohio" | "new-jersey" | "colorado" | "texas" | "arizona" | "missouri" | "virginia" | ... 10 more ... | "north-carolina", { ...; }>'.
    typeof string === "string" && string in RegionStateMap ? RegionStateMap[string].code : null;


/***/ }),

/***/ 74355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ transparent; }
/* harmony export */ });
const opacity = {
    100: "FF",
    95: "F2",
    90: "E6",
    85: "D9",
    80: "CC",
    75: "BF",
    70: "B3",
    65: "A6",
    60: "99",
    55: "8C",
    50: "80",
    45: "73",
    40: "66",
    35: "59",
    30: "4D",
    25: "40",
    20: "33",
    15: "26",
    10: "1A",
    5: "0D",
    0: "00"
};
const transparent = (color, opacityAmount)=>"".concat(color).concat(opacity[opacityAmount]);


/***/ }),

/***/ 45812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ highZIndexMap; }
/* harmony export */ });
const highZIndexMap = {
    NAV_BAR: 1000,
    MOBILE_DRAWER: 2000,
    COVID_MODAL: 2001
};


/***/ }),

/***/ 82704:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mobImg":"V5Comp_mobImg__jPgY3","imgWithBg":"V5Comp_imgWithBg__MZIS7","label":"V5Comp_label__Q3lEQ","h5":"V5Comp_h5__ILKlw","btn-bold":"V5Comp_btn-bold__AHxEG","btn-disabled":"V5Comp_btn-disabled__EU3_p","btn":"V5Comp_btn__KsAXt"};

/***/ }),

/***/ 14930:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('[{"slug":"los-angeles","name":"Los Angeles","state":"CA","latitude":33.8958,"longitude":-118.2201},{"slug":"florida","name":"Florida","state":"FL","latitude":28.1846241,"longitude":-81.9060095},{"slug":"greater-san-diego","name":"San Diego","state":"CA","latitude":32.7353,"longitude":-117.149},{"slug":"sf-bay-area","name":"Bay Area","state":"CA","latitude":37.8272,"longitude":-122.2913},{"slug":"orange-county","name":"Orange County","state":"CA","latitude":33.7889,"longitude":-117.9061},{"slug":"ohio","name":"Ohio","state":"OH","latitude":40.4173,"longitude":-82.9071},{"slug":"new-jersey","name":"New Jersey","state":"NJ","latitude":40.1462,"longitude":-74.7118},{"slug":"inland-empire","name":"Inland Empire","state":"CA","latitude":33.8822,"longitude":-117.3573},{"slug":"colorado","name":"Colorado","state":"CO","latitude":39.63692,"longitude":-105.361441},{"slug":"san-luis-obispo","name":"San Luis Obispo","state":"CA","latitude":35.2828,"longitude":-120.6596},{"slug":"texas","name":"Texas","state":"TX","latitude":31.410467,"longitude":-99.1039747},{"slug":"arizona","name":"Arizona","state":"AZ","latitude":33.4484,"longitude":-112.074},{"slug":"missouri","name":"Missouri","state":"MO","latitude":38.971001,"longitude":-93.5580653},{"slug":"virginia","name":"Virginia","state":"VA","latitude":37.4316,"longitude":-78.6569},{"slug":"pennsylvania","name":"Pennsylvania","state":"PA","latitude":40.194,"longitude":-75.4563},{"slug":"sacramento","name":"Sacramento","state":"CA","latitude":38.5816,"longitude":-121.4944},{"slug":"kansas","name":"Kansas","state":"KS","latitude":38.9183771,"longitude":-94.6838461},{"slug":"massachusetts","name":"Massachusetts","state":"MA","latitude":42.4072,"longitude":-71.3824},{"slug":"washington","name":"Washington","state":"WA","latitude":47.751076,"longitude":-120.740135},{"slug":"alabama","name":"Alabama","state":"AL","latitude":32.31823,"longitude":-86.902298},{"slug":"nevada","name":"Nevada","state":"NV","latitude":39.5296,"longitude":-119.8138},{"slug":"illinois","name":"Illinois","latitude":41.8336479,"longitude":-87.8720463},{"slug":"connecticut","name":"Connecticut","latitude":41.2982831,"longitude":-72.9641152},{"slug":"georgia","name":"Georgia","latitude":33.7676931,"longitude":-84.4906437},{"slug":"michigan","name":"Michigan","latitude":42.3526897,"longitude":-83.1692445},{"slug":"north-carolina","name":"North Carolina","latitude":35.2028147,"longitude":-81.1269099}]');

/***/ }),

/***/ 61005:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('[{"id":"0a72611a-bf86-422c-9b7c-c44d7c7851b7","name":"COVID-19 Serology Testing Symptomatic Both","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":200},{"id":"998810c7-5732-4fc2-9515-f17e39ca864c","name":"COVID-19 Diagnostic Testing Symptomatic Both","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":200},{"id":"f2b5e873-c97b-4eb3-9d36-0788428fd672","name":"COVID-19 Diagnostic Testing Symptomatic Only","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":200},{"id":"ae7a194f-b90e-4f9f-bb16-a2a009fd1bd6","name":"COVID-19 Diagnostic Testing Asymptomatic Only","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":200},{"id":"81819097-bb0a-4957-8a94-602234814f4a","name":"COVID-19 Diagnostic Testing Need Referral","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":200},{"id":"c1a96270-ee59-4ed7-9b09-e22fb609939f","name":"COVID-19 Diagnostic Testing Not Need Referral","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":200},{"id":"f50b8d82-8e81-49ca-94f3-af9d10af4f09","name":"COVID-19 Serology Testing Not Need Referral","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":200},{"id":"787f6bea-1c15-4a4c-a723-b0525c14204b","name":"COVID-19 Serology Testing Need Referral","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":200},{"id":"e3482cae-cca3-4e74-bd9f-595fdf635f63","name":"COVID-19 Serology Testing Asymptomatic Only","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":200},{"id":"87dd835e-0814-4dc1-a54d-faede219b7d6","name":"COVID-19 Serology Testing Symptomatic Only","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":200},{"id":"fc68f27e-b693-4c89-b94c-424432234ca3","name":"Coronavirus Vaccine","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":200},{"id":"f3b9b95b-de04-4835-b42f-d10a18511eff","name":"Monj Weight Management","isVirtual":true,"isDefault":false,"popular":false,"sortIndex":100},{"id":"7d353615-f338-43cc-8fe6-f0f9f153dd3d","name":"Alertive","isVirtual":true,"isDefault":false,"popular":false,"sortIndex":110},{"id":"dd8bc1ad-492c-457f-abe0-5f00ef774d09","name":"Virtual Diabetes Care","isVirtual":true,"isDefault":true,"popular":true,"sortIndex":30},{"id":"9672d7ec-9cc6-4d6c-ad8d-f9aa534b15a7","name":"Workplace Health","isVirtual":false,"isDefault":true,"popular":true,"sortIndex":6},{"id":"7012b067-edf0-4162-a74f-161085a24359","name":"Metabolic Health Assessment","isVirtual":true,"isDefault":true,"popular":true,"sortIndex":30},{"id":"31cf5e95-0952-4cbd-9a53-d4f74f729407","name":"Virtual Therapy","isVirtual":true,"isDefault":true,"popular":true,"sortIndex":10},{"id":"3ea88aaa-94c4-4208-ad11-fcea2d231e0f","name":"COVID-19 Travel Testing","isVirtual":false,"isDefault":false,"popular":true,"sortIndex":3},{"id":"eb1d79e6-1319-475f-aaa1-afdf7fb79b05","name":"Alertive Blood Pressure Assessment","isVirtual":true,"isDefault":false,"popular":false,"sortIndex":110},{"id":"a9b863ac-ab6f-4ee4-94d9-a98daa3e63b6","name":"Virtual Mental Health","isVirtual":true,"isDefault":true,"popular":true,"sortIndex":-6},{"id":"6647b27b-b527-4580-bd3a-86f9aa511eba","name":"Oncology","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"652c64cc-9fcb-442f-b71e-266390ef2f63","name":"Coronavirus Testing","isVirtual":false,"isDefault":false,"popular":true,"sortIndex":2},{"id":"9325b52e-3877-4b7b-b952-a6c6f5fc9c74","name":"Virtual Pediatrics","isVirtual":true,"isDefault":false,"popular":false,"sortIndex":-5},{"id":"b04b2c6d-e4b1-410a-81ae-61797e3c487f","name":"Pro-bono Virtual Care (COVID-19 only)","isVirtual":true,"isDefault":false,"popular":false,"sortIndex":-6},{"id":"5202919c-6817-4763-a9f7-6956d9f8fceb","name":"Virtual Orthopedics","isVirtual":true,"isDefault":false,"popular":false,"sortIndex":-1},{"id":"3dc0ad34-3c11-455d-ae4b-79ffaecb757d","name":"Virtual Nutritionist","isVirtual":true,"isDefault":false,"popular":false,"sortIndex":-1},{"id":"19e0d4a5-a5f5-4bf2-9f54-d792bafbf51a","name":"Virtual Dermatology","isVirtual":true,"isDefault":false,"popular":false,"sortIndex":-1},{"id":"95963903-d72e-4504-98ae-3759c3e3aa7e","name":"Virtual Clinical Psychology","isVirtual":true,"isDefault":false,"popular":false,"sortIndex":-1},{"id":"a8a0326e-c1cb-4d10-8113-2e249be6296c","name":"Virtual Podiatry","isVirtual":true,"isDefault":false,"popular":false,"sortIndex":-1},{"id":"88730211-1695-45f8-8a96-0df360010327","name":"Virtual Care","isVirtual":true,"isDefault":false,"popular":false,"sortIndex":-8},{"id":"0ad3697e-1ce1-4118-b355-d1b3dd9540ee","name":"Urgent Care","isVirtual":false,"isDefault":true,"popular":true,"sortIndex":1},{"id":"5d8e99b5-b8b9-4df7-b0f1-f74a64882656","name":"Coronavirus Testing - Urgent Care","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":20},{"id":"54829879-6634-4be4-ae1a-61bb0bade3a6","name":"Allergy & Immunology","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"63d57c57-7da0-4e80-88a9-667323f2cd58","name":"Anesthesiology","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"5f4ca1e5-7c2e-486a-89ed-11ef0d55bad0","name":"Endocrinology","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"ecfa079d-ed4b-4966-ac3c-c3adef22a871","name":"Family Medicine","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"e9833be2-7938-4c7a-bf7f-cb55b30c169b","name":"Gastroenterology","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"c3d497cb-6fe5-487a-9e5c-5acf3f1c377f","name":"General Surgery","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"f7fc4cda-c0c4-4fad-a6d8-fadd32ffb92d","name":"Hematology","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"d66fe3d2-13f5-4a5d-bf58-4569fe346b98","name":"Infectious Disease","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"28ae4184-68df-483d-a5f8-f98ddaa0e5d9","name":"Internal Medicine","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"4af28126-3efe-4de1-a739-eb828c59a63e","name":"Nephrology","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"c602055c-8a22-47e5-92ee-65de0864eb4c","name":"Neurosurgery","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"980f15c7-c9ca-4897-abcc-c0c23190611e","name":"Nuclear Medicine","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"78344a97-4e09-4c42-9187-ea43646e43e7","name":"ObGyn","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":3},{"id":"ae7e4f46-2500-42d8-a870-9939f4a8faf1","name":"Occupational Medicine","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"8aa71398-ea77-466a-ba6f-02205dd32497","name":"Ophthalmology","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"5e0de1d0-de33-41c8-8e2d-2fd279d5d435","name":"Oral & Maxillofacial Surgery","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"5a816dea-2461-4357-87a3-ff6070846abc","name":"Otolaryngology (ENT)","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"404fde6f-afda-4bbc-b946-eaf48499aaa6","name":"Pathology","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"6f8bbea0-b92c-4eed-b249-0a7ca3f9fa84","name":"Physical Medicine/Rehab","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"0b1aa03e-5782-4bb6-ba20-08046032d605","name":"Plastic Surgery","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"6e04bb91-5f34-4a2c-a5db-6432cb8ad426","name":"Preventive Medicine","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"38f090b6-8896-49d8-9025-3d7feca89b37","name":"Psychiatry","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"e79bef0d-3cab-4a6c-b2c6-4405d1a5ece1","name":"Pulmonology","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"ddbbada5-d1c9-40fa-a449-5d574408c202","name":"Radiation Oncology","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"6caccbc8-ffe2-4f5e-a4a9-fd479435f5d0","name":"Radiology","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"2856f459-8fe1-413e-a5cf-2e6b66eb33d9","name":"Rheumatology","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"0f35b9c6-48d0-435b-8989-9ae9c9ab3fff","name":"Thoracic Surgery","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"b3a39f9f-9e2c-4ca1-b5f8-5877af8a9ad0","name":"Urology","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"7ed486f2-ad7f-4d62-8afa-f2753f2b721e","name":"Vascular Surgery","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"170c9f62-88d8-4b00-9bf6-262e65b0b9c8","name":"Geriatrics","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"7f15eac0-7af8-4a22-8192-57c9cc01b77b","name":"Medical Genetics","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"c82edb8d-0336-4f77-871f-c05548324f5d","name":"Neonat/Perinatology","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"57687d24-1fef-41fc-9f46-ae8328a435a0","name":"Pediatric Cardiology","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"e94b77cf-22dd-462b-bd68-0e6fefa03303","name":"COVID-19 Serology Testing","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":200},{"id":"a9073fd0-4fca-4d26-8a7a-14b5d0ee55d9","name":"Virtual Urgent Care","isVirtual":true,"isDefault":false,"popular":false,"sortIndex":8},{"id":"5aab78ac-c910-4a28-aae3-458c10ee23fd","name":"Virtual Primary Care","isVirtual":true,"isDefault":false,"popular":false,"sortIndex":9},{"id":"e8765782-1917-479d-b098-6c26c2c5f8ca","name":"Pediatric Endocrinology","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"55e39a48-0e64-4927-9daf-d1ff8985a1b2","name":"Pediatric Gastroenterology","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"3475446e-b6ea-4c76-9ff0-f44b68e5df27","name":"Pediatric Infectious Disease","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"d1364316-753b-47da-93fd-173fcdeb7831","name":"Pediatric Nephrology","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"964d6909-ddc7-4eb5-8b38-2166cd7fe582","name":"Pediatric Pulmonology","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"f69c75e9-27f4-418d-aecb-f882fbf2f8e8","name":"Pediatric Rheumatology","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"3fd726fe-f5e5-4318-b71d-fa8278072475","name":"Research","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"9c3b2e42-523e-435d-b848-383a1058d3d2","name":"Neurology","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"ba73882e-80f8-4a33-abdf-b3b55540826a","name":"Pediatric Hematology & Oncology","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"43d1fff0-4335-4499-9db9-3234bff9dc13","name":"Resident Physician","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"0340f561-f948-47a4-b513-ddbc0ec754b7","name":"Cardiology","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"31bc4b11-2c66-4d2b-8571-4b7e2f20c378","name":"Colon & Rectal Surgery","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"b9bb5f08-0117-42d3-8ac1-0ac3a7e537f5","name":"Child Neurology","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"a75875b0-a029-46b2-a84e-12f7e5a53b4f","name":"Sports Medicine","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"af4efea1-4c00-41db-b8cb-65f6a288e831","name":"Pediatrics","isVirtual":false,"isDefault":true,"popular":true,"sortIndex":2},{"id":"ad729f95-30ce-4beb-b262-052b6b9857a3","name":"Orthopedics","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":3},{"id":"c6346b67-2204-41b4-8e91-049667947587","name":"Nutritionist","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":100},{"id":"feaa861e-9054-4b7b-98ca-f30ae622bd8c","name":"Dermatology","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"6f517e93-9cbc-4ff6-baa8-761b88fe4048","name":"Physical Therapy","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"aa76a0ab-d899-4c13-924d-6e3672432650","name":"Clinical Psychology","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":100},{"id":"35e6c4f8-bdc4-4a76-9c75-1cee4754ce4d","name":"Clinical Social Worker","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":100},{"id":"1e90ee8e-3942-4c65-9fd0-d2609c3045aa","name":"Orthopedic Spine Surgery","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":100},{"id":"4c35c997-20d4-40fd-9ed4-6d566a5d70fd","name":"Child and Adolescent Psychiatry","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":100},{"id":"84b505c7-54ae-4be7-9a64-37e9d89f71d2","name":"Bariatric (Weight Loss) Medicine","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":100},{"id":"66570ab0-4b43-49b5-9890-3428ece8efe3","name":"Naturopathic Medicine","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":100},{"id":"f2ae693a-3653-4845-af8b-cb81be77c8e5","name":"Sleep Medicine","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":100},{"id":"1de4dc70-f8b6-44a7-a3cf-370f7f37b772","name":"Podiatry","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":100},{"id":"d01045d0-e874-4dd0-85d9-fcc332b10726","name":"Genetic Counselor","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":100},{"id":"889951ae-c9a2-4e37-8573-5257fd13207f","name":"Reproductive Endocrinology & Infertility","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":100},{"id":"132d0e99-0005-4e23-a427-ce7efd778cce","name":"Registered Dietitian","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":100},{"id":"426bc3fd-d250-4f9e-b52a-3362898b62d6","name":"Audiology","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":100},{"id":"50a8f321-a470-4075-bc56-6ba738fef785","name":"Optometry","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":100},{"id":"91da3ed2-8de8-4f47-8665-6c0228770bea","name":"Hepatology","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":100},{"id":"ca61238b-062f-45ac-9cea-80d6464c442f","name":"Pediatric Orthopedics","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":45},{"id":"910711e8-be97-4d97-9303-6b531946df15","name":"Acupuncture","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":0},{"id":"00b24d75-66ac-4a75-8a4b-281a2ace56ec","name":"Naturopathic Medicine","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":25},{"id":"ad3f8e53-9357-4f41-bef5-37478593d2a8","name":"Wound Care","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"983b1dd4-3861-4e21-807a-b1674280fc3f","name":"Pain Management","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":35},{"id":"28919ff5-8e59-4139-8551-332e73d3441e","name":"Emergency Medicine","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"77574d2e-4ce3-4ca0-9e58-0f3aec3d4065","name":"Pediatric Emergency Medicine","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":100},{"id":"c879c2f6-1e3e-4c47-9603-e79827222b54","name":"Virtual Physical Medicine/Rehab","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":-1},{"id":"6a0326a8-fd43-431d-b80a-f4bdfb1268c6","name":"Chiropractor","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":80},{"id":"85f04a02-2383-49e5-adbc-56f627c8ab95","name":"Mental Health","isVirtual":false,"isDefault":true,"popular":false,"sortIndex":4},{"id":"4e6076c3-0340-45a3-acb1-313238ab0695","name":"Pediatric Mental Health","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":60},{"id":"a0793e21-8bb8-4356-8b47-a92e98257ab9","name":"DO NOT USE","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":0},{"id":"39484fab-3986-4e36-8a13-2a4fffba35af","name":"Coronavirus Testing - ER","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":25},{"id":"9f92600a-3959-42ed-924e-fd7580e7aa29","name":"Diabetes Education","isVirtual":false,"isDefault":false,"popular":false,"sortIndex":100},{"id":"5814d99a-b767-4298-8d46-ada317655fda","name":"Primary Care","isVirtual":false,"isDefault":true,"popular":true,"sortIndex":0}]');

/***/ })

}]);